export const posicaoCargaMock = [
       [
            {
                "id": 892,
                "codigoVendedor": "234182",
                "nomeVendedor": "ALESSANDRA ALEXANDRE NUNES",
                "basesPosicaoCarga": [
                    {
                        "tag": "Card-Rota",
                        "card": {
                            "totalPedidos": 3,
                            "percentTotalPedidos": 1,
                            "totalEntregues": 0,
                            "percentTotalEntregues": 1,
                            "totalEmTransito": 3,
                            "totalEmAtraso": 0
                        },
                        "id": -1
                    },
                    {
                        "tag": "Card-Todos",
                        "card": {
                            "totalPedidos": 74,
                            "percentTotalPedidos": 4.285714285714286,
                            "totalEntregues": 0,
                            "percentTotalEntregues": 1,
                            "totalEmTransito": 45,
                            "totalEmAtraso": 0
                        },
                        "id": -2
                    },
                    {
                        "tag": "Rota",
                        "codigoCliente": "1458429",
                        "razaoSocial": "AGRO SHOPPING LTDA",
                        "id": 47502,
                        "createdAt": "2026-09-25T16:00:06.8394853",
                        "clienteId": 15688,
                        "pedido": "2053082182",
                        "dataPedido": "2026-09-24T00:00:00",
                        "previsaoEntrega": "2026-09-28T00:00:00",
                        "previsaoEntregaAjustada": "2026-09-29T00:00:00",
                        "statusPrazo": 1,
                        "statusEntrega": 3
                    },
                    {
                        "tag": "Rota",
                        "codigoCliente": "1458429",
                        "razaoSocial": "AGRO SHOPPING LTDA",
                        "id": 47503,
                        "createdAt": "2026-09-25T16:00:06.8394859",
                        "clienteId": 15688,
                        "pedido": "2053082182",
                        "dataPedido": "2026-09-24T00:00:00",
                        "previsaoEntrega": "2026-09-28T00:00:00",
                        "previsaoEntregaAjustada": "2026-09-29T00:00:00",
                        "statusPrazo": 1,
                        "statusEntrega": 3
                    },
                    {
                        "tag": "Rota",
                        "codigoCliente": "1458429",
                        "razaoSocial": "AGRO SHOPPING LTDA",
                        "id": 47504,
                        "createdAt": "2026-09-25T16:00:06.8394864",
                        "clienteId": 15688,
                        "pedido": "2053082182",
                        "dataPedido": "2026-09-24T00:00:00",
                        "previsaoEntrega": "2026-09-28T00:00:00",
                        "previsaoEntregaAjustada": "2026-09-29T00:00:00",
                        "statusPrazo": 1,
                        "statusEntrega": 3
                    },
                    {
                        "tag": "Todos",
                        "codigoCliente": "1367137",
                        "razaoSocial": "ELOS COMERCIO DE MATERIAIS DE",
                        "id": 47649,
                        "createdAt": "2026-09-25T16:00:06.8395665",
                        "clienteId": 8231,
                        "pedido": "2052675782",
                        "dataPedido": "2026-08-21T00:00:00",
                        "previsaoEntrega": "2026-09-30T00:00:00",
                        "previsaoEntregaAjustada": "2026-09-30T00:00:00",
                        "statusPrazo": 1,
                        "statusEntrega": 2
                    },
                    {
                        "tag": "Todos",
                        "codigoCliente": "1367137",
                        "razaoSocial": "ELOS COMERCIO DE MATERIAIS DE",
                        "id": 47650,
                        "createdAt": "2026-09-25T16:00:06.839567",
                        "clienteId": 8231,
                        "pedido": "2052675782",
                        "dataPedido": "2026-08-21T00:00:00",
                        "previsaoEntrega": "2026-09-30T00:00:00",
                        "previsaoEntregaAjustada": "2026-09-30T00:00:00",
                        "statusPrazo": 1,
                        "statusEntrega": 2
                    },
                    {
                        "tag": "Todos",
                        "codigoCliente": "1367137",
                        "razaoSocial": "ELOS COMERCIO DE MATERIAIS DE",
                        "id": 47653,
                        "createdAt": "2026-09-25T16:00:06.8395686",
                        "clienteId": 8231,
                        "pedido": "2052675774",
                        "dataPedido": "2026-08-21T00:00:00",
                        "previsaoEntrega": "2026-09-30T00:00:00",
                        "previsaoEntregaAjustada": "2026-09-30T00:00:00",
                        "statusPrazo": 1,
                        "statusEntrega": 2
                    },
                    {
                        "tag": "Todos",
                        "codigoCliente": "1367137",
                        "razaoSocial": "ELOS COMERCIO DE MATERIAIS DE",
                        "id": 47654,
                        "createdAt": "2026-09-25T16:00:06.8395691",
                        "clienteId": 8231,
                        "pedido": "2052675774",
                        "dataPedido": "2026-08-21T00:00:00",
                        "previsaoEntrega": "2026-09-30T00:00:00",
                        "previsaoEntregaAjustada": "2026-09-30T00:00:00",
                        "statusPrazo": 1,
                        "statusEntrega": 2
                    },
                    {
                        "tag": "Todos",
                        "codigoCliente": "1367137",
                        "razaoSocial": "ELOS COMERCIO DE MATERIAIS DE",
                        "id": 47659,
                        "createdAt": "2026-09-25T16:00:06.839572",
                        "clienteId": 8231,
                        "pedido": "2052686628",
                        "dataPedido": "2026-08-21T00:00:00",
                        "previsaoEntrega": "2026-09-28T00:00:00",
                        "previsaoEntregaAjustada": "2026-09-28T00:00:00",
                        "statusPrazo": 1,
                        "statusEntrega": 2
                    },
                    {
                        "tag": "Todos",
                        "codigoCliente": "1367137",
                        "razaoSocial": "ELOS COMERCIO DE MATERIAIS DE",
                        "id": 47660,
                        "createdAt": "2026-09-25T16:00:06.8395725",
                        "clienteId": 8231,
                        "pedido": "2052686628",
                        "dataPedido": "2026-08-21T00:00:00",
                        "previsaoEntrega": "2026-09-28T00:00:00",
                        "previsaoEntregaAjustada": "2026-09-28T00:00:00",
                        "statusPrazo": 1,
                        "statusEntrega": 2
                    },
                    {
                        "tag": "Todos",
                        "codigoCliente": "1367137",
                        "razaoSocial": "ELOS COMERCIO DE MATERIAIS DE",
                        "id": 47663,
                        "createdAt": "2026-09-25T16:00:06.8395743",
                        "clienteId": 8231,
                        "pedido": "2052675744",
                        "dataPedido": "2026-08-21T00:00:00",
                        "previsaoEntrega": "2026-10-01T00:00:00",
                        "previsaoEntregaAjustada": "2026-10-01T00:00:00",
                        "statusPrazo": 1,
                        "statusEntrega": 2
                    },
                    {
                        "tag": "Todos",
                        "codigoCliente": "1367137",
                        "razaoSocial": "ELOS COMERCIO DE MATERIAIS DE",
                        "id": 47664,
                        "createdAt": "2026-09-25T16:00:06.8395748",
                        "clienteId": 8231,
                        "pedido": "2052675744",
                        "dataPedido": "2026-08-21T00:00:00",
                        "previsaoEntrega": "2026-10-01T00:00:00",
                        "previsaoEntregaAjustada": "2026-10-01T00:00:00",
                        "statusPrazo": 1,
                        "statusEntrega": 2
                    },
                    {
                        "tag": "Todos",
                        "codigoCliente": "1367137",
                        "razaoSocial": "ELOS COMERCIO DE MATERIAIS DE",
                        "id": 47665,
                        "createdAt": "2026-09-25T16:00:06.8395753",
                        "clienteId": 8231,
                        "pedido": "2052675735",
                        "dataPedido": "2026-08-21T00:00:00",
                        "previsaoEntrega": "2026-10-01T00:00:00",
                        "previsaoEntregaAjustada": "2026-10-01T00:00:00",
                        "statusPrazo": 1,
                        "statusEntrega": 2
                    },
                    {
                        "tag": "Todos",
                        "codigoCliente": "1367137",
                        "razaoSocial": "ELOS COMERCIO DE MATERIAIS DE",
                        "id": 47666,
                        "createdAt": "2026-09-25T16:00:06.8395759",
                        "clienteId": 8231,
                        "pedido": "2052675735",
                        "dataPedido": "2026-08-21T00:00:00",
                        "previsaoEntrega": "2026-10-01T00:00:00",
                        "previsaoEntregaAjustada": "2026-10-01T00:00:00",
                        "statusPrazo": 1,
                        "statusEntrega": 2
                    },
                    {
                        "tag": "Todos",
                        "codigoCliente": "1367137",
                        "razaoSocial": "ELOS COMERCIO DE MATERIAIS DE",
                        "id": 47669,
                        "createdAt": "2026-09-25T16:00:06.8395775",
                        "clienteId": 8231,
                        "pedido": "2052686637",
                        "dataPedido": "2026-08-21T00:00:00",
                        "previsaoEntrega": "2026-09-28T00:00:00",
                        "previsaoEntregaAjustada": "2026-09-28T00:00:00",
                        "statusPrazo": 1,
                        "statusEntrega": 2
                    },
                    {
                        "tag": "Todos",
                        "codigoCliente": "1367137",
                        "razaoSocial": "ELOS COMERCIO DE MATERIAIS DE",
                        "id": 47670,
                        "createdAt": "2026-09-25T16:00:06.839578",
                        "clienteId": 8231,
                        "pedido": "2052686637",
                        "dataPedido": "2026-08-21T00:00:00",
                        "previsaoEntrega": "2026-09-28T00:00:00",
                        "previsaoEntregaAjustada": "2026-09-28T00:00:00",
                        "statusPrazo": 1,
                        "statusEntrega": 2
                    },
                    {
                        "tag": "Todos",
                        "codigoCliente": "1367137",
                        "razaoSocial": "ELOS COMERCIO DE MATERIAIS DE",
                        "id": 47673,
                        "createdAt": "2026-09-25T16:00:06.8395801",
                        "clienteId": 8231,
                        "pedido": "2052675727",
                        "dataPedido": "2026-08-21T00:00:00",
                        "previsaoEntrega": "2026-09-24T00:00:00",
                        "previsaoEntregaAjustada": "2026-09-25T00:00:00",
                        "statusPrazo": 1,
                        "statusEntrega": 3
                    },
                    {
                        "tag": "Todos",
                        "codigoCliente": "1367137",
                        "razaoSocial": "ELOS COMERCIO DE MATERIAIS DE",
                        "id": 47674,
                        "createdAt": "2026-09-25T16:00:06.8395807",
                        "clienteId": 8231,
                        "pedido": "2052675727",
                        "dataPedido": "2026-08-21T00:00:00",
                        "previsaoEntrega": "2026-09-24T00:00:00",
                        "previsaoEntregaAjustada": "2026-09-25T00:00:00",
                        "statusPrazo": 1,
                        "statusEntrega": 3
                    },
                    {
                        "tag": "Todos",
                        "codigoCliente": "1391694",
                        "razaoSocial": "LEROY MERLIN COMPANHIA BRASILEIRA",
                        "id": 45872,
                        "createdAt": "2026-09-25T16:00:06.8385849",
                        "clienteId": 57075,
                        "pedido": "2053062926",
                        "dataPedido": "2026-09-23T00:00:00",
                        "previsaoEntrega": "2026-09-28T00:00:00",
                        "previsaoEntregaAjustada": "2026-09-28T00:00:00",
                        "statusPrazo": 1,
                        "statusEntrega": 2
                    },
                    {
                        "tag": "Todos",
                        "codigoCliente": "1391694",
                        "razaoSocial": "LEROY MERLIN COMPANHIA BRASILEIRA",
                        "id": 45873,
                        "createdAt": "2026-09-25T16:00:06.8385854",
                        "clienteId": 57075,
                        "pedido": "2053062926",
                        "dataPedido": "2026-09-23T00:00:00",
                        "previsaoEntrega": "2026-09-28T00:00:00",
                        "previsaoEntregaAjustada": "2026-09-28T00:00:00",
                        "statusPrazo": 1,
                        "statusEntrega": 2
                    },
                    {
                        "tag": "Todos",
                        "codigoCliente": "1391694",
                        "razaoSocial": "LEROY MERLIN COMPANHIA BRASILEIRA",
                        "id": 45874,
                        "createdAt": "2026-09-25T16:00:06.8385859",
                        "clienteId": 57075,
                        "pedido": "2053044881",
                        "dataPedido": "2026-09-22T00:00:00",
                        "previsaoEntrega": "2026-09-25T00:00:00",
                        "previsaoEntregaAjustada": "2026-09-25T00:00:00",
                        "statusPrazo": 1,
                        "statusEntrega": 2
                    },
                    {
                        "tag": "Todos",
                        "codigoCliente": "1391694",
                        "razaoSocial": "LEROY MERLIN COMPANHIA BRASILEIRA",
                        "id": 45875,
                        "createdAt": "2026-09-25T16:00:06.8385864",
                        "clienteId": 57075,
                        "pedido": "2053044881",
                        "dataPedido": "2026-09-22T00:00:00",
                        "previsaoEntrega": "2026-09-25T00:00:00",
                        "previsaoEntregaAjustada": "2026-09-25T00:00:00",
                        "statusPrazo": 1,
                        "statusEntrega": 2
                    },
                    {
                        "tag": "Todos",
                        "codigoCliente": "1458429",
                        "razaoSocial": "AGRO SHOPPING LTDA",
                        "id": 47502,
                        "createdAt": "2026-09-25T16:00:06.8394853",
                        "clienteId": 15688,
                        "pedido": "2053082182",
                        "dataPedido": "2026-09-24T00:00:00",
                        "previsaoEntrega": "2026-09-28T00:00:00",
                        "previsaoEntregaAjustada": "2026-09-29T00:00:00",
                        "statusPrazo": 1,
                        "statusEntrega": 3
                    },
                    {
                        "tag": "Todos",
                        "codigoCliente": "1458429",
                        "razaoSocial": "AGRO SHOPPING LTDA",
                        "id": 47503,
                        "createdAt": "2026-09-25T16:00:06.8394859",
                        "clienteId": 15688,
                        "pedido": "2053082182",
                        "dataPedido": "2026-09-24T00:00:00",
                        "previsaoEntrega": "2026-09-28T00:00:00",
                        "previsaoEntregaAjustada": "2026-09-29T00:00:00",
                        "statusPrazo": 1,
                        "statusEntrega": 3
                    },
                    {
                        "tag": "Todos",
                        "codigoCliente": "1458429",
                        "razaoSocial": "AGRO SHOPPING LTDA",
                        "id": 47504,
                        "createdAt": "2026-09-25T16:00:06.8394864",
                        "clienteId": 15688,
                        "pedido": "2053082182",
                        "dataPedido": "2026-09-24T00:00:00",
                        "previsaoEntrega": "2026-09-28T00:00:00",
                        "previsaoEntregaAjustada": "2026-09-29T00:00:00",
                        "statusPrazo": 1,
                        "statusEntrega": 3
                    },
                    {
                        "tag": "Todos",
                        "codigoCliente": "1331022",
                        "razaoSocial": "COSTA MATERIAIS PARA CONSTRUCAO LTD",
                        "id": 47647,
                        "createdAt": "2026-09-25T16:00:06.8395653",
                        "clienteId": 15949,
                        "pedido": "2053083384",
                        "dataPedido": "2026-09-24T00:00:00",
                        "previsaoEntrega": "2026-09-28T00:00:00",
                        "previsaoEntregaAjustada": "2026-09-29T00:00:00",
                        "statusPrazo": 1,
                        "statusEntrega": 3
                    },
                    {
                        "tag": "Todos",
                        "codigoCliente": "1331022",
                        "razaoSocial": "COSTA MATERIAIS PARA CONSTRUCAO LTD",
                        "id": 47648,
                        "createdAt": "2026-09-25T16:00:06.8395658",
                        "clienteId": 15949,
                        "pedido": "2053083384",
                        "dataPedido": "2026-09-24T00:00:00",
                        "previsaoEntrega": "2026-09-28T00:00:00",
                        "previsaoEntregaAjustada": "2026-09-29T00:00:00",
                        "statusPrazo": 1,
                        "statusEntrega": 3
                    },
                    {
                        "tag": "Todos",
                        "codigoCliente": "1367137",
                        "razaoSocial": "ELOS COMERCIO DE MATERIAIS DE",
                        "id": 47651,
                        "createdAt": "2026-09-25T16:00:06.8395675",
                        "clienteId": 8231,
                        "pedido": "2053083399",
                        "dataPedido": "2026-09-24T00:00:00",
                        "previsaoEntrega": "2026-09-30T00:00:00",
                        "previsaoEntregaAjustada": "2026-09-29T00:00:00",
                        "statusPrazo": 1,
                        "statusEntrega": 3
                    },
                    {
                        "tag": "Todos",
                        "codigoCliente": "1367137",
                        "razaoSocial": "ELOS COMERCIO DE MATERIAIS DE",
                        "id": 47652,
                        "createdAt": "2026-09-25T16:00:06.839568",
                        "clienteId": 8231,
                        "pedido": "2053083399",
                        "dataPedido": "2026-09-24T00:00:00",
                        "previsaoEntrega": "2026-09-30T00:00:00",
                        "previsaoEntregaAjustada": "2026-09-29T00:00:00",
                        "statusPrazo": 1,
                        "statusEntrega": 3
                    },
                    {
                        "tag": "Todos",
                        "codigoCliente": "1367137",
                        "razaoSocial": "ELOS COMERCIO DE MATERIAIS DE",
                        "id": 47655,
                        "createdAt": "2026-09-25T16:00:06.8395697",
                        "clienteId": 8231,
                        "pedido": "2053083407",
                        "dataPedido": "2026-09-24T00:00:00",
                        "previsaoEntrega": "2026-09-30T00:00:00",
                        "previsaoEntregaAjustada": "2026-09-29T00:00:00",
                        "statusPrazo": 1,
                        "statusEntrega": 3
                    },
                    {
                        "tag": "Todos",
                        "codigoCliente": "1367137",
                        "razaoSocial": "ELOS COMERCIO DE MATERIAIS DE",
                        "id": 47656,
                        "createdAt": "2026-09-25T16:00:06.8395702",
                        "clienteId": 8231,
                        "pedido": "2053083407",
                        "dataPedido": "2026-09-24T00:00:00",
                        "previsaoEntrega": "2026-09-30T00:00:00",
                        "previsaoEntregaAjustada": "2026-09-29T00:00:00",
                        "statusPrazo": 1,
                        "statusEntrega": 3
                    },
                    {
                        "tag": "Todos",
                        "codigoCliente": "1367137",
                        "razaoSocial": "ELOS COMERCIO DE MATERIAIS DE",
                        "id": 47657,
                        "createdAt": "2026-09-25T16:00:06.8395707",
                        "clienteId": 8231,
                        "pedido": "2053072906",
                        "dataPedido": "2026-09-24T00:00:00",
                        "previsaoEntrega": "2026-09-26T00:00:00",
                        "previsaoEntregaAjustada": "2026-09-28T00:00:00",
                        "statusPrazo": 1,
                        "statusEntrega": 3
                    },
                    {
                        "tag": "Todos",
                        "codigoCliente": "1367137",
                        "razaoSocial": "ELOS COMERCIO DE MATERIAIS DE",
                        "id": 47658,
                        "createdAt": "2026-09-25T16:00:06.8395715",
                        "clienteId": 8231,
                        "pedido": "2053072906",
                        "dataPedido": "2026-09-24T00:00:00",
                        "previsaoEntrega": "2026-09-26T00:00:00",
                        "previsaoEntregaAjustada": "2026-09-28T00:00:00",
                        "statusPrazo": 1,
                        "statusEntrega": 3
                    },
                    {
                        "tag": "Todos",
                        "codigoCliente": "1367137",
                        "razaoSocial": "ELOS COMERCIO DE MATERIAIS DE",
                        "id": 47661,
                        "createdAt": "2026-09-25T16:00:06.8395732",
                        "clienteId": 8231,
                        "pedido": "2053073032",
                        "dataPedido": "2026-09-24T00:00:00",
                        "previsaoEntrega": "2026-09-28T00:00:00",
                        "previsaoEntregaAjustada": "2026-09-28T00:00:00",
                        "statusPrazo": 1,
                        "statusEntrega": 3
                    },
                    {
                        "tag": "Todos",
                        "codigoCliente": "1367137",
                        "razaoSocial": "ELOS COMERCIO DE MATERIAIS DE",
                        "id": 47662,
                        "createdAt": "2026-09-25T16:00:06.8395737",
                        "clienteId": 8231,
                        "pedido": "2053073032",
                        "dataPedido": "2026-09-24T00:00:00",
                        "previsaoEntrega": "2026-09-28T00:00:00",
                        "previsaoEntregaAjustada": "2026-09-28T00:00:00",
                        "statusPrazo": 1,
                        "statusEntrega": 3
                    },
                    {
                        "tag": "Todos",
                        "codigoCliente": "1367137",
                        "razaoSocial": "ELOS COMERCIO DE MATERIAIS DE",
                        "id": 47667,
                        "createdAt": "2026-09-25T16:00:06.8395764",
                        "clienteId": 8231,
                        "pedido": "2053091017",
                        "dataPedido": "2026-09-25T00:00:00",
                        "previsaoEntrega": "2026-10-05T00:00:00",
                        "previsaoEntregaAjustada": "2026-10-05T00:00:00",
                        "statusPrazo": 1,
                        "statusEntrega": 2
                    },
                    {
                        "tag": "Todos",
                        "codigoCliente": "1367137",
                        "razaoSocial": "ELOS COMERCIO DE MATERIAIS DE",
                        "id": 47668,
                        "createdAt": "2026-09-25T16:00:06.8395769",
                        "clienteId": 8231,
                        "pedido": "2053091017",
                        "dataPedido": "2026-09-25T00:00:00",
                        "previsaoEntrega": "2026-10-05T00:00:00",
                        "previsaoEntregaAjustada": "2026-10-05T00:00:00",
                        "statusPrazo": 1,
                        "statusEntrega": 2
                    },
                    {
                        "tag": "Todos",
                        "codigoCliente": "1367137",
                        "razaoSocial": "ELOS COMERCIO DE MATERIAIS DE",
                        "id": 47671,
                        "createdAt": "2026-09-25T16:00:06.8395785",
                        "clienteId": 8231,
                        "pedido": "2053057222",
                        "dataPedido": "2026-09-23T00:00:00",
                        "previsaoEntrega": "2026-09-25T00:00:00",
                        "previsaoEntregaAjustada": "2026-09-26T00:00:00",
                        "statusPrazo": 1,
                        "statusEntrega": 3
                    },
                    {
                        "tag": "Todos",
                        "codigoCliente": "1367137",
                        "razaoSocial": "ELOS COMERCIO DE MATERIAIS DE",
                        "id": 47672,
                        "createdAt": "2026-09-25T16:00:06.8395791",
                        "clienteId": 8231,
                        "pedido": "2053057222",
                        "dataPedido": "2026-09-23T00:00:00",
                        "previsaoEntrega": "2026-09-25T00:00:00",
                        "previsaoEntregaAjustada": "2026-09-26T00:00:00",
                        "statusPrazo": 1,
                        "statusEntrega": 3
                    },
                    {
                        "tag": "Todos",
                        "codigoCliente": "1367137",
                        "razaoSocial": "ELOS COMERCIO DE MATERIAIS DE",
                        "id": 47675,
                        "createdAt": "2026-09-25T16:00:06.8395812",
                        "clienteId": 8231,
                        "pedido": "2053089740",
                        "dataPedido": "2026-09-25T00:00:00",
                        "previsaoEntrega": "2026-10-01T00:00:00",
                        "previsaoEntregaAjustada": "2026-10-01T00:00:00",
                        "statusPrazo": 1,
                        "statusEntrega": 2
                    },
                    {
                        "tag": "Todos",
                        "codigoCliente": "1367137",
                        "razaoSocial": "ELOS COMERCIO DE MATERIAIS DE",
                        "id": 47676,
                        "createdAt": "2026-09-25T16:00:06.8395818",
                        "clienteId": 8231,
                        "pedido": "2053089740",
                        "dataPedido": "2026-09-25T00:00:00",
                        "previsaoEntrega": "2026-10-01T00:00:00",
                        "previsaoEntregaAjustada": "2026-10-01T00:00:00",
                        "statusPrazo": 1,
                        "statusEntrega": 2
                    },
                    {
                        "tag": "Todos",
                        "codigoCliente": "1367137",
                        "razaoSocial": "ELOS COMERCIO DE MATERIAIS DE",
                        "id": 47677,
                        "createdAt": "2026-09-25T16:00:06.8395823",
                        "clienteId": 8231,
                        "pedido": "2053089752",
                        "dataPedido": "2026-09-25T00:00:00",
                        "previsaoEntrega": "2026-10-01T00:00:00",
                        "previsaoEntregaAjustada": "2026-10-01T00:00:00",
                        "statusPrazo": 1,
                        "statusEntrega": 2
                    },
                    {
                        "tag": "Todos",
                        "codigoCliente": "1367137",
                        "razaoSocial": "ELOS COMERCIO DE MATERIAIS DE",
                        "id": 47678,
                        "createdAt": "2026-09-25T16:00:06.8395829",
                        "clienteId": 8231,
                        "pedido": "2053089752",
                        "dataPedido": "2026-09-25T00:00:00",
                        "previsaoEntrega": "2026-10-01T00:00:00",
                        "previsaoEntregaAjustada": "2026-10-01T00:00:00",
                        "statusPrazo": 1,
                        "statusEntrega": 2
                    },
                    {
                        "tag": "Todos",
                        "codigoCliente": "1217329",
                        "razaoSocial": "LUIZ ANTONIO NANTES DE SOUZA",
                        "id": 52239,
                        "createdAt": "2026-09-25T16:00:06.8478924",
                        "clienteId": 16133,
                        "pedido": "2053063401",
                        "dataPedido": "2026-09-23T00:00:00",
                        "previsaoEntrega": "2026-09-25T00:00:00",
                        "previsaoEntregaAjustada": "2026-09-28T00:00:00",
                        "statusPrazo": 1,
                        "statusEntrega": 3
                    },
                    {
                        "tag": "Todos",
                        "codigoCliente": "1217329",
                        "razaoSocial": "LUIZ ANTONIO NANTES DE SOUZA",
                        "id": 52240,
                        "createdAt": "2026-09-25T16:00:06.8478929",
                        "clienteId": 16133,
                        "pedido": "2053063401",
                        "dataPedido": "2026-09-23T00:00:00",
                        "previsaoEntrega": "2026-09-25T00:00:00",
                        "previsaoEntregaAjustada": "2026-09-28T00:00:00",
                        "statusPrazo": 1,
                        "statusEntrega": 3
                    },
                    {
                        "tag": "Todos",
                        "codigoCliente": "1217329",
                        "razaoSocial": "LUIZ ANTONIO NANTES DE SOUZA",
                        "id": 52241,
                        "createdAt": "2026-09-25T16:00:06.8478934",
                        "clienteId": 16133,
                        "pedido": "2053063401",
                        "dataPedido": "2026-09-23T00:00:00",
                        "previsaoEntrega": "2026-09-25T00:00:00",
                        "previsaoEntregaAjustada": "2026-09-28T00:00:00",
                        "statusPrazo": 1,
                        "statusEntrega": 3
                    },
                    {
                        "tag": "Todos",
                        "codigoCliente": "1217329",
                        "razaoSocial": "LUIZ ANTONIO NANTES DE SOUZA",
                        "id": 52242,
                        "createdAt": "2026-09-25T16:00:06.847894",
                        "clienteId": 16133,
                        "pedido": "2053063401",
                        "dataPedido": "2026-09-23T00:00:00",
                        "previsaoEntrega": "2026-09-25T00:00:00",
                        "previsaoEntregaAjustada": "2026-09-28T00:00:00",
                        "statusPrazo": 1,
                        "statusEntrega": 3
                    },
                    {
                        "tag": "Todos",
                        "codigoCliente": "1217329",
                        "razaoSocial": "LUIZ ANTONIO NANTES DE SOUZA",
                        "id": 52243,
                        "createdAt": "2026-09-25T16:00:06.8478945",
                        "clienteId": 16133,
                        "pedido": "2053063401",
                        "dataPedido": "2026-09-23T00:00:00",
                        "previsaoEntrega": "2026-09-25T00:00:00",
                        "previsaoEntregaAjustada": "2026-09-28T00:00:00",
                        "statusPrazo": 1,
                        "statusEntrega": 3
                    },
                    {
                        "tag": "Todos",
                        "codigoCliente": "1058365",
                        "razaoSocial": "JOAO MARIA NANTES DE SOUZA",
                        "id": 52293,
                        "createdAt": "2026-09-25T16:00:06.8479238",
                        "clienteId": 16295,
                        "pedido": "2053063856",
                        "dataPedido": "2026-09-23T00:00:00",
                        "previsaoEntrega": "2026-09-25T00:00:00",
                        "previsaoEntregaAjustada": "2026-09-28T00:00:00",
                        "statusPrazo": 1,
                        "statusEntrega": 3
                    },
                    {
                        "tag": "Todos",
                        "codigoCliente": "1058365",
                        "razaoSocial": "JOAO MARIA NANTES DE SOUZA",
                        "id": 52294,
                        "createdAt": "2026-09-25T16:00:06.8479243",
                        "clienteId": 16295,
                        "pedido": "2053063856",
                        "dataPedido": "2026-09-23T00:00:00",
                        "previsaoEntrega": "2026-09-25T00:00:00",
                        "previsaoEntregaAjustada": "2026-09-28T00:00:00",
                        "statusPrazo": 1,
                        "statusEntrega": 3
                    },
                    {
                        "tag": "Todos",
                        "codigoCliente": "1790769",
                        "razaoSocial": "J&F SOLUCOES EM MATERIAIS DE",
                        "id": 52486,
                        "createdAt": "2026-09-25T16:00:06.8480329",
                        "clienteId": 14629,
                        "pedido": "2053066423",
                        "dataPedido": "2026-09-23T00:00:00",
                        "previsaoEntrega": "2026-09-25T00:00:00",
                        "previsaoEntregaAjustada": "2026-09-28T00:00:00",
                        "statusPrazo": 1,
                        "statusEntrega": 3
                    },
                    {
                        "tag": "Todos",
                        "codigoCliente": "1790769",
                        "razaoSocial": "J&F SOLUCOES EM MATERIAIS DE",
                        "id": 52487,
                        "createdAt": "2026-09-25T16:00:06.8480334",
                        "clienteId": 14629,
                        "pedido": "2053066423",
                        "dataPedido": "2026-09-23T00:00:00",
                        "previsaoEntrega": "2026-09-25T00:00:00",
                        "previsaoEntregaAjustada": "2026-09-28T00:00:00",
                        "statusPrazo": 1,
                        "statusEntrega": 3
                    },
                    {
                        "tag": "Todos",
                        "codigoCliente": "1790769",
                        "razaoSocial": "J&F SOLUCOES EM MATERIAIS DE",
                        "id": 52488,
                        "createdAt": "2026-09-25T16:00:06.848034",
                        "clienteId": 14629,
                        "pedido": "2053066423",
                        "dataPedido": "2026-09-23T00:00:00",
                        "previsaoEntrega": "2026-09-25T00:00:00",
                        "previsaoEntregaAjustada": "2026-09-28T00:00:00",
                        "statusPrazo": 1,
                        "statusEntrega": 3
                    },
                    {
                        "tag": "Todos",
                        "codigoCliente": "1702388",
                        "razaoSocial": "BRENO ANTHONY LACERDA",
                        "id": 52552,
                        "createdAt": "2026-09-25T16:00:06.8480695",
                        "clienteId": 15199,
                        "pedido": "2053067226",
                        "dataPedido": "2026-09-23T00:00:00",
                        "previsaoEntrega": "2026-09-25T00:00:00",
                        "previsaoEntregaAjustada": "2026-09-28T00:00:00",
                        "statusPrazo": 1,
                        "statusEntrega": 3
                    },
                    {
                        "tag": "Todos",
                        "codigoCliente": "1702388",
                        "razaoSocial": "BRENO ANTHONY LACERDA",
                        "id": 52553,
                        "createdAt": "2026-09-25T16:00:06.84807",
                        "clienteId": 15199,
                        "pedido": "2053067226",
                        "dataPedido": "2026-09-23T00:00:00",
                        "previsaoEntrega": "2026-09-25T00:00:00",
                        "previsaoEntregaAjustada": "2026-09-28T00:00:00",
                        "statusPrazo": 1,
                        "statusEntrega": 3
                    },
                    {
                        "tag": "Todos",
                        "codigoCliente": "1097413",
                        "razaoSocial": "JEFERSON DIAS DE VASCONCELOS",
                        "id": 53335,
                        "createdAt": "2026-09-25T16:00:06.848517",
                        "clienteId": 16268,
                        "pedido": "2053078517",
                        "dataPedido": "2026-09-24T00:00:00",
                        "previsaoEntrega": "2026-09-28T00:00:00",
                        "previsaoEntregaAjustada": "2026-09-28T00:00:00",
                        "statusPrazo": 1,
                        "statusEntrega": 3
                    },
                    {
                        "tag": "Todos",
                        "codigoCliente": "1097413",
                        "razaoSocial": "JEFERSON DIAS DE VASCONCELOS",
                        "id": 53336,
                        "createdAt": "2026-09-25T16:00:06.8485176",
                        "clienteId": 16268,
                        "pedido": "2053078517",
                        "dataPedido": "2026-09-24T00:00:00",
                        "previsaoEntrega": "2026-09-28T00:00:00",
                        "previsaoEntregaAjustada": "2026-09-28T00:00:00",
                        "statusPrazo": 1,
                        "statusEntrega": 3
                    },
                    {
                        "tag": "Todos",
                        "codigoCliente": "1793420",
                        "razaoSocial": "TALITA COSTA DE SOUZA",
                        "id": 55065,
                        "createdAt": "2026-09-25T16:00:06.8495536",
                        "clienteId": 14643,
                        "pedido": "2053025731",
                        "dataPedido": "2026-09-21T00:00:00",
                        "previsaoEntrega": "2026-09-23T00:00:00",
                        "previsaoEntregaAjustada": "2026-09-26T00:00:00",
                        "statusPrazo": 1,
                        "statusEntrega": 3
                    },
                    {
                        "tag": "Todos",
                        "codigoCliente": "1793420",
                        "razaoSocial": "TALITA COSTA DE SOUZA",
                        "id": 55066,
                        "createdAt": "2026-09-25T16:00:06.8495544",
                        "clienteId": 14643,
                        "pedido": "2053025731",
                        "dataPedido": "2026-09-21T00:00:00",
                        "previsaoEntrega": "2026-09-23T00:00:00",
                        "previsaoEntregaAjustada": "2026-09-26T00:00:00",
                        "statusPrazo": 1,
                        "statusEntrega": 3
                    },
                    {
                        "tag": "Todos",
                        "codigoCliente": "1793420",
                        "razaoSocial": "TALITA COSTA DE SOUZA",
                        "id": 55067,
                        "createdAt": "2026-09-25T16:00:06.8495549",
                        "clienteId": 14643,
                        "pedido": "2053025731",
                        "dataPedido": "2026-09-21T00:00:00",
                        "previsaoEntrega": "2026-09-23T00:00:00",
                        "previsaoEntregaAjustada": "2026-09-26T00:00:00",
                        "statusPrazo": 1,
                        "statusEntrega": 3
                    },
                    {
                        "tag": "Todos",
                        "codigoCliente": "1793420",
                        "razaoSocial": "TALITA COSTA DE SOUZA",
                        "id": 55068,
                        "createdAt": "2026-09-25T16:00:06.8495557",
                        "clienteId": 14643,
                        "pedido": "2053026407",
                        "dataPedido": "2026-09-21T00:00:00",
                        "previsaoEntrega": "2026-09-23T00:00:00",
                        "previsaoEntregaAjustada": "2026-09-26T00:00:00",
                        "statusPrazo": 1,
                        "statusEntrega": 3
                    },
                    {
                        "tag": "Todos",
                        "codigoCliente": "1793420",
                        "razaoSocial": "TALITA COSTA DE SOUZA",
                        "id": 55069,
                        "createdAt": "2026-09-25T16:00:06.8495562",
                        "clienteId": 14643,
                        "pedido": "2053026407",
                        "dataPedido": "2026-09-21T00:00:00",
                        "previsaoEntrega": "2026-09-23T00:00:00",
                        "previsaoEntregaAjustada": "2026-09-26T00:00:00",
                        "statusPrazo": 1,
                        "statusEntrega": 3
                    },
                    {
                        "tag": "Todos",
                        "codigoCliente": "1793420",
                        "razaoSocial": "TALITA COSTA DE SOUZA",
                        "id": 55070,
                        "createdAt": "2026-09-25T16:00:06.8495567",
                        "clienteId": 14643,
                        "pedido": "2053026407",
                        "dataPedido": "2026-09-21T00:00:00",
                        "previsaoEntrega": "2026-09-23T00:00:00",
                        "previsaoEntregaAjustada": "2026-09-26T00:00:00",
                        "statusPrazo": 1,
                        "statusEntrega": 3
                    },
                    {
                        "tag": "Todos",
                        "codigoCliente": "1476567",
                        "razaoSocial": "CONSTRU UTIL MATERIAIS DE CONSTRUCA",
                        "id": 56518,
                        "createdAt": "2026-09-25T16:00:06.8503765",
                        "clienteId": 15629,
                        "pedido": "2053052899",
                        "dataPedido": "2026-09-23T00:00:00",
                        "previsaoEntrega": "2026-09-24T00:00:00",
                        "previsaoEntregaAjustada": "2026-09-26T00:00:00",
                        "statusPrazo": 1,
                        "statusEntrega": 3
                    },
                    {
                        "tag": "Todos",
                        "codigoCliente": "1476567",
                        "razaoSocial": "CONSTRU UTIL MATERIAIS DE CONSTRUCA",
                        "id": 56519,
                        "createdAt": "2026-09-25T16:00:06.850377",
                        "clienteId": 15629,
                        "pedido": "2053052899",
                        "dataPedido": "2026-09-23T00:00:00",
                        "previsaoEntrega": "2026-09-24T00:00:00",
                        "previsaoEntregaAjustada": "2026-09-26T00:00:00",
                        "statusPrazo": 1,
                        "statusEntrega": 3
                    },
                    {
                        "tag": "Todos",
                        "codigoCliente": "1699502",
                        "razaoSocial": "M  M  DE MATTOS LTDA",
                        "id": 56704,
                        "createdAt": "2026-09-25T16:00:06.8504792",
                        "clienteId": 15139,
                        "pedido": "2053056666",
                        "dataPedido": "2026-09-23T00:00:00",
                        "previsaoEntrega": "2026-09-24T00:00:00",
                        "previsaoEntregaAjustada": "2026-09-26T00:00:00",
                        "statusPrazo": 1,
                        "statusEntrega": 3
                    },
                    {
                        "tag": "Todos",
                        "codigoCliente": "1699502",
                        "razaoSocial": "M  M  DE MATTOS LTDA",
                        "id": 56705,
                        "createdAt": "2026-09-25T16:00:06.8504797",
                        "clienteId": 15139,
                        "pedido": "2053056666",
                        "dataPedido": "2026-09-23T00:00:00",
                        "previsaoEntrega": "2026-09-24T00:00:00",
                        "previsaoEntregaAjustada": "2026-09-26T00:00:00",
                        "statusPrazo": 1,
                        "statusEntrega": 3
                    },
                    {
                        "tag": "Todos",
                        "codigoCliente": "1699502",
                        "razaoSocial": "M  M  DE MATTOS LTDA",
                        "id": 56706,
                        "createdAt": "2026-09-25T16:00:06.8504802",
                        "clienteId": 15139,
                        "pedido": "2053056666",
                        "dataPedido": "2026-09-23T00:00:00",
                        "previsaoEntrega": "2026-09-24T00:00:00",
                        "previsaoEntregaAjustada": "2026-09-26T00:00:00",
                        "statusPrazo": 1,
                        "statusEntrega": 3
                    },
                    {
                        "tag": "Todos",
                        "codigoCliente": "1699502",
                        "razaoSocial": "M  M  DE MATTOS LTDA",
                        "id": 56707,
                        "createdAt": "2026-09-25T16:00:06.8504808",
                        "clienteId": 15139,
                        "pedido": "2053056666",
                        "dataPedido": "2026-09-23T00:00:00",
                        "previsaoEntrega": "2026-09-24T00:00:00",
                        "previsaoEntregaAjustada": "2026-09-26T00:00:00",
                        "statusPrazo": 1,
                        "statusEntrega": 3
                    },
                    {
                        "tag": "Todos",
                        "codigoCliente": "1699502",
                        "razaoSocial": "M  M  DE MATTOS LTDA",
                        "id": 56708,
                        "createdAt": "2026-09-25T16:00:06.8504813",
                        "clienteId": 15139,
                        "pedido": "2053056666",
                        "dataPedido": "2026-09-23T00:00:00",
                        "previsaoEntrega": "2026-09-24T00:00:00",
                        "previsaoEntregaAjustada": "2026-09-26T00:00:00",
                        "statusPrazo": 1,
                        "statusEntrega": 3
                    },
                    {
                        "tag": "Todos",
                        "codigoCliente": "1186391",
                        "razaoSocial": "ROCHA MATERIAIS PARA CONSTRUCAO LTD",
                        "id": 57065,
                        "createdAt": "2026-09-25T16:00:06.8564007",
                        "clienteId": 16081,
                        "pedido": "2053064291",
                        "dataPedido": "2026-09-23T00:00:00",
                        "previsaoEntrega": "2026-09-25T00:00:00",
                        "previsaoEntregaAjustada": "2026-09-26T00:00:00",
                        "statusPrazo": 1,
                        "statusEntrega": 3
                    },
                    {
                        "tag": "Todos",
                        "codigoCliente": "1186391",
                        "razaoSocial": "ROCHA MATERIAIS PARA CONSTRUCAO LTD",
                        "id": 57066,
                        "createdAt": "2026-09-25T16:00:06.8564012",
                        "clienteId": 16081,
                        "pedido": "2053064291",
                        "dataPedido": "2026-09-23T00:00:00",
                        "previsaoEntrega": "2026-09-25T00:00:00",
                        "previsaoEntregaAjustada": "2026-09-26T00:00:00",
                        "statusPrazo": 1,
                        "statusEntrega": 3
                    },
                    {
                        "tag": "Todos",
                        "codigoCliente": "1186391",
                        "razaoSocial": "ROCHA MATERIAIS PARA CONSTRUCAO LTD",
                        "id": 57067,
                        "createdAt": "2026-09-25T16:00:06.8564018",
                        "clienteId": 16081,
                        "pedido": "2053064291",
                        "dataPedido": "2026-09-23T00:00:00",
                        "previsaoEntrega": "2026-09-25T00:00:00",
                        "previsaoEntregaAjustada": "2026-09-26T00:00:00",
                        "statusPrazo": 1,
                        "statusEntrega": 3
                    },
                    {
                        "tag": "Todos",
                        "codigoCliente": "1938785",
                        "razaoSocial": "CIMENTAO PANTANAL LTDA",
                        "id": 60919,
                        "createdAt": "2026-09-25T16:00:06.8583841",
                        "clienteId": 1175950,
                        "pedido": "2053018568",
                        "dataPedido": "2026-09-21T00:00:00",
                        "previsaoEntrega": "2026-09-23T00:00:00",
                        "previsaoEntregaAjustada": "2026-09-29T00:00:00",
                        "statusPrazo": 1,
                        "statusEntrega": 2
                    },
                    {
                        "tag": "Todos",
                        "codigoCliente": "1206763",
                        "razaoSocial": "WANDERSON S GALVAO",
                        "id": 61932,
                        "createdAt": "2026-09-25T16:00:06.8589175",
                        "clienteId": 16139,
                        "pedido": "2053064496",
                        "dataPedido": "2026-09-23T00:00:00",
                        "previsaoEntrega": "2026-09-28T00:00:00",
                        "previsaoEntregaAjustada": "2026-09-28T00:00:00",
                        "statusPrazo": 1,
                        "statusEntrega": 2
                    },
                    {
                        "tag": "Todos",
                        "codigoCliente": "1206763",
                        "razaoSocial": "WANDERSON S GALVAO",
                        "id": 61933,
                        "createdAt": "2026-09-25T16:00:06.8589195",
                        "clienteId": 16139,
                        "pedido": "2053064496",
                        "dataPedido": "2026-09-23T00:00:00",
                        "previsaoEntrega": "2026-09-28T00:00:00",
                        "previsaoEntregaAjustada": "2026-09-28T00:00:00",
                        "statusPrazo": 1,
                        "statusEntrega": 2
                    },
                    {
                        "tag": "Todos",
                        "codigoCliente": "1415861",
                        "razaoSocial": "LUANA CLAUDIA GALESKI PESUSKI",
                        "id": 62228,
                        "createdAt": "2026-09-25T16:00:06.8591227",
                        "clienteId": 15850,
                        "pedido": "2053069896",
                        "dataPedido": "2026-09-24T00:00:00",
                        "previsaoEntrega": "2026-09-28T00:00:00",
                        "previsaoEntregaAjustada": "2026-09-28T00:00:00",
                        "statusPrazo": 1,
                        "statusEntrega": 2
                    },
                    {
                        "tag": "Todos",
                        "codigoCliente": "1415861",
                        "razaoSocial": "LUANA CLAUDIA GALESKI PESUSKI",
                        "id": 62229,
                        "createdAt": "2026-09-25T16:00:06.8591232",
                        "clienteId": 15850,
                        "pedido": "2053069896",
                        "dataPedido": "2026-09-24T00:00:00",
                        "previsaoEntrega": "2026-09-28T00:00:00",
                        "previsaoEntregaAjustada": "2026-09-28T00:00:00",
                        "statusPrazo": 1,
                        "statusEntrega": 2
                    },
                    {
                        "tag": "Todos",
                        "codigoCliente": "1415861",
                        "razaoSocial": "LUANA CLAUDIA GALESKI PESUSKI",
                        "id": 62230,
                        "createdAt": "2026-09-25T16:00:06.859124",
                        "clienteId": 15850,
                        "pedido": "2053069941",
                        "dataPedido": "2026-09-24T00:00:00",
                        "previsaoEntrega": "2026-09-28T00:00:00",
                        "previsaoEntregaAjustada": "2026-09-28T00:00:00",
                        "statusPrazo": 1,
                        "statusEntrega": 2
                    },
                    {
                        "tag": "Todos",
                        "codigoCliente": "1415861",
                        "razaoSocial": "LUANA CLAUDIA GALESKI PESUSKI",
                        "id": 62231,
                        "createdAt": "2026-09-25T16:00:06.8591248",
                        "clienteId": 15850,
                        "pedido": "2053069941",
                        "dataPedido": "2026-09-24T00:00:00",
                        "previsaoEntrega": "2026-09-28T00:00:00",
                        "previsaoEntregaAjustada": "2026-09-28T00:00:00",
                        "statusPrazo": 1,
                        "statusEntrega": 2
                    },
                    {
                        "tag": "Todos",
                        "codigoCliente": "1141525",
                        "razaoSocial": "MARIMAR MATERIAIS PARA CONSTRUCAO",
                        "id": 63269,
                        "createdAt": "2026-09-25T16:00:06.8616174",
                        "clienteId": 16276,
                        "pedido": "2053080503",
                        "dataPedido": "2026-09-24T00:00:00",
                        "previsaoEntrega": "2026-09-28T00:00:00",
                        "previsaoEntregaAjustada": "2026-09-28T00:00:00",
                        "statusPrazo": 1,
                        "statusEntrega": 2
                    },
                    {
                        "tag": "Todos",
                        "codigoCliente": "1141525",
                        "razaoSocial": "MARIMAR MATERIAIS PARA CONSTRUCAO",
                        "id": 63270,
                        "createdAt": "2026-09-25T16:00:06.861618",
                        "clienteId": 16276,
                        "pedido": "2053080503",
                        "dataPedido": "2026-09-24T00:00:00",
                        "previsaoEntrega": "2026-09-28T00:00:00",
                        "previsaoEntregaAjustada": "2026-09-28T00:00:00",
                        "statusPrazo": 1,
                        "statusEntrega": 2
                    },
                    {
                        "tag": "Todos",
                        "codigoCliente": "1141525",
                        "razaoSocial": "MARIMAR MATERIAIS PARA CONSTRUCAO",
                        "id": 63271,
                        "createdAt": "2026-09-25T16:00:06.8616188",
                        "clienteId": 16276,
                        "pedido": "2053080503",
                        "dataPedido": "2026-09-24T00:00:00",
                        "previsaoEntrega": "2026-09-28T00:00:00",
                        "previsaoEntregaAjustada": "2026-09-28T00:00:00",
                        "statusPrazo": 1,
                        "statusEntrega": 2
                    },
                    {
                        "tag": "Todos",
                        "codigoCliente": "1141525",
                        "razaoSocial": "MARIMAR MATERIAIS PARA CONSTRUCAO",
                        "id": 63272,
                        "createdAt": "2026-09-25T16:00:06.8616194",
                        "clienteId": 16276,
                        "pedido": "2053083402",
                        "dataPedido": "2026-09-24T00:00:00",
                        "previsaoEntrega": "2026-09-28T00:00:00",
                        "previsaoEntregaAjustada": "2026-09-28T00:00:00",
                        "statusPrazo": 1,
                        "statusEntrega": 2
                    },
                    {
                        "tag": "Todos",
                        "codigoCliente": "1141525",
                        "razaoSocial": "MARIMAR MATERIAIS PARA CONSTRUCAO",
                        "id": 63273,
                        "createdAt": "2026-09-25T16:00:06.8616199",
                        "clienteId": 16276,
                        "pedido": "2053083402",
                        "dataPedido": "2026-09-24T00:00:00",
                        "previsaoEntrega": "2026-09-28T00:00:00",
                        "previsaoEntregaAjustada": "2026-09-28T00:00:00",
                        "statusPrazo": 1,
                        "statusEntrega": 2
                    },
                    {
                        "tag": "Todos",
                        "codigoCliente": "1141525",
                        "razaoSocial": "MARIMAR MATERIAIS PARA CONSTRUCAO",
                        "id": 63274,
                        "createdAt": "2026-09-25T16:00:06.8616205",
                        "clienteId": 16276,
                        "pedido": "2053083402",
                        "dataPedido": "2026-09-24T00:00:00",
                        "previsaoEntrega": "2026-09-28T00:00:00",
                        "previsaoEntregaAjustada": "2026-09-28T00:00:00",
                        "statusPrazo": 1,
                        "statusEntrega": 2
                    },
                    {
                        "tag": "Todos",
                        "codigoCliente": "1060252",
                        "razaoSocial": "CLODOMIRO SANTOS DA SILVA",
                        "id": 64102,
                        "createdAt": "2026-09-25T16:00:06.8621312",
                        "clienteId": 16234,
                        "pedido": "2053088083",
                        "dataPedido": "2026-09-25T00:00:00",
                        "previsaoEntrega": "2026-09-29T00:00:00",
                        "previsaoEntregaAjustada": "2026-09-29T00:00:00",
                        "statusPrazo": 1,
                        "statusEntrega": 2
                    },
                    {
                        "tag": "Todos",
                        "codigoCliente": "1060252",
                        "razaoSocial": "CLODOMIRO SANTOS DA SILVA",
                        "id": 64103,
                        "createdAt": "2026-09-25T16:00:06.8621317",
                        "clienteId": 16234,
                        "pedido": "2053088083",
                        "dataPedido": "2026-09-25T00:00:00",
                        "previsaoEntrega": "2026-09-29T00:00:00",
                        "previsaoEntregaAjustada": "2026-09-29T00:00:00",
                        "statusPrazo": 1,
                        "statusEntrega": 2
                    },
                    {
                        "tag": "Todos",
                        "codigoCliente": "1527581",
                        "razaoSocial": "ALVES CONSTRUCAO E AGRO LTDA",
                        "id": 64207,
                        "createdAt": "2026-09-25T16:00:06.8661094",
                        "clienteId": 15429,
                        "pedido": "2053088894",
                        "dataPedido": "2026-09-25T00:00:00",
                        "previsaoEntrega": "2026-09-28T00:00:00",
                        "previsaoEntregaAjustada": "2026-09-28T00:00:00",
                        "statusPrazo": 1,
                        "statusEntrega": 2
                    },
                    {
                        "tag": "Todos",
                        "codigoCliente": "1527581",
                        "razaoSocial": "ALVES CONSTRUCAO E AGRO LTDA",
                        "id": 64208,
                        "createdAt": "2026-09-25T16:00:06.8661099",
                        "clienteId": 15429,
                        "pedido": "2053088894",
                        "dataPedido": "2026-09-25T00:00:00",
                        "previsaoEntrega": "2026-09-28T00:00:00",
                        "previsaoEntregaAjustada": "2026-09-28T00:00:00",
                        "statusPrazo": 1,
                        "statusEntrega": 2
                    },
                    {
                        "tag": "Todos",
                        "codigoCliente": "1366654",
                        "razaoSocial": "GONCALVES E CASTRO LTDA",
                        "id": 64209,
                        "createdAt": "2026-09-25T16:00:06.8661105",
                        "clienteId": 16028,
                        "pedido": "2053088908",
                        "dataPedido": "2026-09-25T00:00:00",
                        "previsaoEntrega": "2026-09-29T00:00:00",
                        "previsaoEntregaAjustada": "2026-09-29T00:00:00",
                        "statusPrazo": 1,
                        "statusEntrega": 2
                    },
                    {
                        "tag": "Todos",
                        "codigoCliente": "1366654",
                        "razaoSocial": "GONCALVES E CASTRO LTDA",
                        "id": 64210,
                        "createdAt": "2026-09-25T16:00:06.8661111",
                        "clienteId": 16028,
                        "pedido": "2053088908",
                        "dataPedido": "2026-09-25T00:00:00",
                        "previsaoEntrega": "2026-09-29T00:00:00",
                        "previsaoEntregaAjustada": "2026-09-29T00:00:00",
                        "statusPrazo": 1,
                        "statusEntrega": 2
                    }
                ]
            },
            {
                "id": 1077,
                "codigoVendedor": "251281",
                "nomeVendedor": "JONATHAS SIQUEIRA DE OLIVEIRA",
                "basesPosicaoCarga": [
                    {
                        "tag": "Card-Rota",
                        "card": {
                            "totalPedidos": 18,
                            "percentTotalPedidos": 1,
                            "totalEntregues": 0,
                            "percentTotalEntregues": 1,
                            "totalEmTransito": 6,
                            "totalEmAtraso": 0
                        },
                        "id": -1
                    },
                    {
                        "tag": "Card-Todos",
                        "card": {
                            "totalPedidos": 416,
                            "percentTotalPedidos": 1,
                            "totalEntregues": 0,
                            "percentTotalEntregues": 1,
                            "totalEmTransito": 251,
                            "totalEmAtraso": 24
                        },
                        "id": -2
                    },
                    {
                        "tag": "Rota",
                        "codigoCliente": "1478679",
                        "razaoSocial": "LOJAS QUERO QUERO S A",
                        "id": 76135,
                        "createdAt": "2026-09-25T16:00:06.9027181",
                        "clienteId": 131390,
                        "pedido": "2053050561",
                        "dataPedido": "2026-09-22T00:00:00",
                        "previsaoEntrega": "2026-09-30T00:00:00",
                        "previsaoEntregaAjustada": "2026-09-30T00:00:00",
                        "statusPrazo": 1,
                        "statusEntrega": 2
                    },
                    {
                        "tag": "Rota",
                        "codigoCliente": "1478679",
                        "razaoSocial": "LOJAS QUERO QUERO S A",
                        "id": 76136,
                        "createdAt": "2026-09-25T16:00:06.9027186",
                        "clienteId": 131390,
                        "pedido": "2053050561",
                        "dataPedido": "2026-09-22T00:00:00",
                        "previsaoEntrega": "2026-09-30T00:00:00",
                        "previsaoEntregaAjustada": "2026-09-30T00:00:00",
                        "statusPrazo": 1,
                        "statusEntrega": 2
                    },
                    {
                        "tag": "Rota",
                        "codigoCliente": "1478679",
                        "razaoSocial": "LOJAS QUERO QUERO S A",
                        "id": 76137,
                        "createdAt": "2026-09-25T16:00:06.9027192",
                        "clienteId": 131390,
                        "pedido": "2053050561",
                        "dataPedido": "2026-09-22T00:00:00",
                        "previsaoEntrega": "2026-09-30T00:00:00",
                        "previsaoEntregaAjustada": "2026-09-30T00:00:00",
                        "statusPrazo": 1,
                        "statusEntrega": 2
                    },
                    {
                        "tag": "Rota",
                        "codigoCliente": "1478679",
                        "razaoSocial": "LOJAS QUERO QUERO S A",
                        "id": 76138,
                        "createdAt": "2026-09-25T16:00:06.9027197",
                        "clienteId": 131390,
                        "pedido": "2053010200",
                        "dataPedido": "2026-09-18T00:00:00",
                        "previsaoEntrega": "2026-09-25T00:00:00",
                        "previsaoEntregaAjustada": "2026-09-25T00:00:00",
                        "statusPrazo": 1,
                        "statusEntrega": 2
                    },
                    {
                        "tag": "Rota",
                        "codigoCliente": "1478679",
                        "razaoSocial": "LOJAS QUERO QUERO S A",
                        "id": 76139,
                        "createdAt": "2026-09-25T16:00:06.9027205",
                        "clienteId": 131390,
                        "pedido": "2053010200",
                        "dataPedido": "2026-09-18T00:00:00",
                        "previsaoEntrega": "2026-09-25T00:00:00",
                        "previsaoEntregaAjustada": "2026-09-25T00:00:00",
                        "statusPrazo": 1,
                        "statusEntrega": 2
                    },
                    {
                        "tag": "Rota",
                        "codigoCliente": "1478679",
                        "razaoSocial": "LOJAS QUERO QUERO S A",
                        "id": 76140,
                        "createdAt": "2026-09-25T16:00:06.902721",
                        "clienteId": 131390,
                        "pedido": "2053010200",
                        "dataPedido": "2026-09-18T00:00:00",
                        "previsaoEntrega": "2026-09-25T00:00:00",
                        "previsaoEntregaAjustada": "2026-09-25T00:00:00",
                        "statusPrazo": 1,
                        "statusEntrega": 2
                    },
                    {
                        "tag": "Rota",
                        "codigoCliente": "1478679",
                        "razaoSocial": "LOJAS QUERO QUERO S A",
                        "id": 76141,
                        "createdAt": "2026-09-25T16:00:06.9027215",
                        "clienteId": 131390,
                        "pedido": "2052970373",
                        "dataPedido": "2026-09-16T00:00:00",
                        "previsaoEntrega": "2026-09-18T00:00:00",
                        "previsaoEntregaAjustada": "2026-09-25T00:00:00",
                        "statusPrazo": 1,
                        "statusEntrega": 3
                    },
                    {
                        "tag": "Rota",
                        "codigoCliente": "1478679",
                        "razaoSocial": "LOJAS QUERO QUERO S A",
                        "id": 76142,
                        "createdAt": "2026-09-25T16:00:06.9027221",
                        "clienteId": 131390,
                        "pedido": "2052970373",
                        "dataPedido": "2026-09-16T00:00:00",
                        "previsaoEntrega": "2026-09-18T00:00:00",
                        "previsaoEntregaAjustada": "2026-09-25T00:00:00",
                        "statusPrazo": 1,
                        "statusEntrega": 3
                    },
                    {
                        "tag": "Rota",
                        "codigoCliente": "1478679",
                        "razaoSocial": "LOJAS QUERO QUERO S A",
                        "id": 76143,
                        "createdAt": "2026-09-25T16:00:06.9027228",
                        "clienteId": 131390,
                        "pedido": "2052970373",
                        "dataPedido": "2026-09-16T00:00:00",
                        "previsaoEntrega": "2026-09-18T00:00:00",
                        "previsaoEntregaAjustada": "2026-09-25T00:00:00",
                        "statusPrazo": 1,
                        "statusEntrega": 3
                    },
                    {
                        "tag": "Rota",
                        "codigoCliente": "1478679",
                        "razaoSocial": "LOJAS QUERO QUERO S A",
                        "id": 76144,
                        "createdAt": "2026-09-25T16:00:06.9027236",
                        "clienteId": 131390,
                        "pedido": "2052941318",
                        "dataPedido": "2026-09-14T00:00:00",
                        "previsaoEntrega": "2026-09-22T00:00:00",
                        "previsaoEntregaAjustada": "2026-09-26T00:00:00",
                        "statusPrazo": 1,
                        "statusEntrega": 3
                    },
                    {
                        "tag": "Rota",
                        "codigoCliente": "1478679",
                        "razaoSocial": "LOJAS QUERO QUERO S A",
                        "id": 76145,
                        "createdAt": "2026-09-25T16:00:06.9027242",
                        "clienteId": 131390,
                        "pedido": "2052941318",
                        "dataPedido": "2026-09-14T00:00:00",
                        "previsaoEntrega": "2026-09-22T00:00:00",
                        "previsaoEntregaAjustada": "2026-09-26T00:00:00",
                        "statusPrazo": 1,
                        "statusEntrega": 3
                    },
                    {
                        "tag": "Rota",
                        "codigoCliente": "1478679",
                        "razaoSocial": "LOJAS QUERO QUERO S A",
                        "id": 76146,
                        "createdAt": "2026-09-25T16:00:06.9027248",
                        "clienteId": 131390,
                        "pedido": "2052941318",
                        "dataPedido": "2026-09-14T00:00:00",
                        "previsaoEntrega": "2026-09-22T00:00:00",
                        "previsaoEntregaAjustada": "2026-09-26T00:00:00",
                        "statusPrazo": 1,
                        "statusEntrega": 3
                    },
                    {
                        "tag": "Rota",
                        "codigoCliente": "1260407",
                        "razaoSocial": "LOJAS BECKER LTDA",
                        "id": 85748,
                        "createdAt": "2026-09-25T16:00:06.9144407",
                        "clienteId": 139117,
                        "pedido": "2053030162",
                        "dataPedido": "2026-09-21T00:00:00",
                        "previsaoEntrega": "2026-09-28T00:00:00",
                        "previsaoEntregaAjustada": "2026-09-28T00:00:00",
                        "statusPrazo": 1,
                        "statusEntrega": 2
                    },
                    {
                        "tag": "Rota",
                        "codigoCliente": "1260407",
                        "razaoSocial": "LOJAS BECKER LTDA",
                        "id": 85749,
                        "createdAt": "2026-09-25T16:00:06.9144415",
                        "clienteId": 139117,
                        "pedido": "2053030162",
                        "dataPedido": "2026-09-21T00:00:00",
                        "previsaoEntrega": "2026-09-28T00:00:00",
                        "previsaoEntregaAjustada": "2026-09-28T00:00:00",
                        "statusPrazo": 1,
                        "statusEntrega": 2
                    },
                    {
                        "tag": "Rota",
                        "codigoCliente": "1260407",
                        "razaoSocial": "LOJAS BECKER LTDA",
                        "id": 85750,
                        "createdAt": "2026-09-25T16:00:06.9144421",
                        "clienteId": 139117,
                        "pedido": "2053030162",
                        "dataPedido": "2026-09-21T00:00:00",
                        "previsaoEntrega": "2026-09-28T00:00:00",
                        "previsaoEntregaAjustada": "2026-09-28T00:00:00",
                        "statusPrazo": 1,
                        "statusEntrega": 2
                    },
                    {
                        "tag": "Rota",
                        "codigoCliente": "1295404",
                        "razaoSocial": "BARCEMAG FERRAGEM & MATERIAIS DE",
                        "id": 87863,
                        "createdAt": "2026-09-25T16:00:06.9216948",
                        "clienteId": 14107,
                        "pedido": "2053078148",
                        "dataPedido": "2026-09-24T00:00:00",
                        "previsaoEntrega": "2026-09-29T00:00:00",
                        "previsaoEntregaAjustada": "2026-09-29T00:00:00",
                        "statusPrazo": 1,
                        "statusEntrega": 2
                    },
                    {
                        "tag": "Rota",
                        "codigoCliente": "1295404",
                        "razaoSocial": "BARCEMAG FERRAGEM & MATERIAIS DE",
                        "id": 87864,
                        "createdAt": "2026-09-25T16:00:06.9216955",
                        "clienteId": 14107,
                        "pedido": "2053078148",
                        "dataPedido": "2026-09-24T00:00:00",
                        "previsaoEntrega": "2026-09-29T00:00:00",
                        "previsaoEntregaAjustada": "2026-09-29T00:00:00",
                        "statusPrazo": 1,
                        "statusEntrega": 2
                    },
                    {
                        "tag": "Rota",
                        "codigoCliente": "1295404",
                        "razaoSocial": "BARCEMAG FERRAGEM & MATERIAIS DE",
                        "id": 87865,
                        "createdAt": "2026-09-25T16:00:06.9216961",
                        "clienteId": 14107,
                        "pedido": "2053078148",
                        "dataPedido": "2026-09-24T00:00:00",
                        "previsaoEntrega": "2026-09-29T00:00:00",
                        "previsaoEntregaAjustada": "2026-09-29T00:00:00",
                        "statusPrazo": 1,
                        "statusEntrega": 2
                    },
                    {
                        "tag": "Todos",
                        "codigoCliente": "1497313",
                        "razaoSocial": "LOJAS QUERO QUERO S A",
                        "id": 65473,
                        "createdAt": "2026-09-25T16:00:06.866877",
                        "clienteId": 131386,
                        "pedido": "2052957282",
                        "dataPedido": "2026-09-15T00:00:00",
                        "previsaoEntrega": "2026-09-24T00:00:00",
                        "previsaoEntregaAjustada": "2026-10-08T00:00:00",
                        "statusPrazo": 1,
                        "statusEntrega": 3
                    },
                    {
                        "tag": "Todos",
                        "codigoCliente": "1497313",
                        "razaoSocial": "LOJAS QUERO QUERO S A",
                        "id": 65474,
                        "createdAt": "2026-09-25T16:00:06.8668776",
                        "clienteId": 131386,
                        "pedido": "2052957282",
                        "dataPedido": "2026-09-15T00:00:00",
                        "previsaoEntrega": "2026-09-24T00:00:00",
                        "previsaoEntregaAjustada": "2026-10-08T00:00:00",
                        "statusPrazo": 1,
                        "statusEntrega": 3
                    },
                    {
                        "tag": "Todos",
                        "codigoCliente": "1497313",
                        "razaoSocial": "LOJAS QUERO QUERO S A",
                        "id": 65475,
                        "createdAt": "2026-09-25T16:00:06.8668781",
                        "clienteId": 131386,
                        "pedido": "2052957282",
                        "dataPedido": "2026-09-15T00:00:00",
                        "previsaoEntrega": "2026-09-24T00:00:00",
                        "previsaoEntregaAjustada": "2026-10-08T00:00:00",
                        "statusPrazo": 1,
                        "statusEntrega": 3
                    },
                    {
                        "tag": "Todos",
                        "codigoCliente": "1497313",
                        "razaoSocial": "LOJAS QUERO QUERO S A",
                        "id": 65476,
                        "createdAt": "2026-09-25T16:00:06.8668786",
                        "clienteId": 131386,
                        "pedido": "2052941357",
                        "dataPedido": "2026-09-14T00:00:00",
                        "previsaoEntrega": "2026-09-21T00:00:00",
                        "previsaoEntregaAjustada": "2026-10-06T00:00:00",
                        "statusPrazo": 1,
                        "statusEntrega": 3
                    },
                    {
                        "tag": "Todos",
                        "codigoCliente": "1497313",
                        "razaoSocial": "LOJAS QUERO QUERO S A",
                        "id": 65477,
                        "createdAt": "2026-09-25T16:00:06.8668792",
                        "clienteId": 131386,
                        "pedido": "2052941357",
                        "dataPedido": "2026-09-14T00:00:00",
                        "previsaoEntrega": "2026-09-21T00:00:00",
                        "previsaoEntregaAjustada": "2026-10-06T00:00:00",
                        "statusPrazo": 1,
                        "statusEntrega": 3
                    },
                    {
                        "tag": "Todos",
                        "codigoCliente": "1497313",
                        "razaoSocial": "LOJAS QUERO QUERO S A",
                        "id": 65478,
                        "createdAt": "2026-09-25T16:00:06.8668797",
                        "clienteId": 131386,
                        "pedido": "2052941357",
                        "dataPedido": "2026-09-14T00:00:00",
                        "previsaoEntrega": "2026-09-21T00:00:00",
                        "previsaoEntregaAjustada": "2026-10-06T00:00:00",
                        "statusPrazo": 1,
                        "statusEntrega": 3
                    },
                    {
                        "tag": "Todos",
                        "codigoCliente": "1497313",
                        "razaoSocial": "LOJAS QUERO QUERO S A",
                        "id": 65479,
                        "createdAt": "2026-09-25T16:00:06.8668802",
                        "clienteId": 131386,
                        "pedido": "2052998434",
                        "dataPedido": "2026-09-18T00:00:00",
                        "previsaoEntrega": "2026-09-23T00:00:00",
                        "previsaoEntregaAjustada": "2026-10-06T00:00:00",
                        "statusPrazo": 1,
                        "statusEntrega": 3
                    },
                    {
                        "tag": "Todos",
                        "codigoCliente": "1497313",
                        "razaoSocial": "LOJAS QUERO QUERO S A",
                        "id": 65480,
                        "createdAt": "2026-09-25T16:00:06.8668809",
                        "clienteId": 131386,
                        "pedido": "2052998434",
                        "dataPedido": "2026-09-18T00:00:00",
                        "previsaoEntrega": "2026-09-23T00:00:00",
                        "previsaoEntregaAjustada": "2026-10-06T00:00:00",
                        "statusPrazo": 1,
                        "statusEntrega": 3
                    },
                    {
                        "tag": "Todos",
                        "codigoCliente": "1497313",
                        "razaoSocial": "LOJAS QUERO QUERO S A",
                        "id": 65481,
                        "createdAt": "2026-09-25T16:00:06.8668814",
                        "clienteId": 131386,
                        "pedido": "2052998434",
                        "dataPedido": "2026-09-18T00:00:00",
                        "previsaoEntrega": "2026-09-23T00:00:00",
                        "previsaoEntregaAjustada": "2026-10-06T00:00:00",
                        "statusPrazo": 1,
                        "statusEntrega": 3
                    },
                    {
                        "tag": "Todos",
                        "codigoCliente": "1497313",
                        "razaoSocial": "LOJAS QUERO QUERO S A",
                        "id": 65482,
                        "createdAt": "2026-09-25T16:00:06.8668819",
                        "clienteId": 131386,
                        "pedido": "2053030640",
                        "dataPedido": "2026-09-21T00:00:00",
                        "previsaoEntrega": "2026-09-24T00:00:00",
                        "previsaoEntregaAjustada": "2026-10-09T00:00:00",
                        "statusPrazo": 1,
                        "statusEntrega": 3
                    },
                    {
                        "tag": "Todos",
                        "codigoCliente": "1497313",
                        "razaoSocial": "LOJAS QUERO QUERO S A",
                        "id": 65483,
                        "createdAt": "2026-09-25T16:00:06.8668826",
                        "clienteId": 131386,
                        "pedido": "2053030640",
                        "dataPedido": "2026-09-21T00:00:00",
                        "previsaoEntrega": "2026-09-24T00:00:00",
                        "previsaoEntregaAjustada": "2026-10-09T00:00:00",
                        "statusPrazo": 1,
                        "statusEntrega": 3
                    },
                    {
                        "tag": "Todos",
                        "codigoCliente": "1497313",
                        "razaoSocial": "LOJAS QUERO QUERO S A",
                        "id": 65484,
                        "createdAt": "2026-09-25T16:00:06.8668831",
                        "clienteId": 131386,
                        "pedido": "2053030640",
                        "dataPedido": "2026-09-21T00:00:00",
                        "previsaoEntrega": "2026-09-24T00:00:00",
                        "previsaoEntregaAjustada": "2026-10-09T00:00:00",
                        "statusPrazo": 1,
                        "statusEntrega": 3
                    },
                    {
                        "tag": "Todos",
                        "codigoCliente": "1497313",
                        "razaoSocial": "LOJAS QUERO QUERO S A",
                        "id": 65485,
                        "createdAt": "2026-09-25T16:00:06.8668837",
                        "clienteId": 131386,
                        "pedido": "2053050575",
                        "dataPedido": "2026-09-22T00:00:00",
                        "previsaoEntrega": "2026-09-29T00:00:00",
                        "previsaoEntregaAjustada": "2026-10-09T00:00:00",
                        "statusPrazo": 1,
                        "statusEntrega": 2
                    },
                    {
                        "tag": "Todos",
                        "codigoCliente": "1497313",
                        "razaoSocial": "LOJAS QUERO QUERO S A",
                        "id": 65486,
                        "createdAt": "2026-09-25T16:00:06.8668842",
                        "clienteId": 131386,
                        "pedido": "2053050575",
                        "dataPedido": "2026-09-22T00:00:00",
                        "previsaoEntrega": "2026-09-29T00:00:00",
                        "previsaoEntregaAjustada": "2026-10-09T00:00:00",
                        "statusPrazo": 1,
                        "statusEntrega": 2
                    },
                    {
                        "tag": "Todos",
                        "codigoCliente": "1497313",
                        "razaoSocial": "LOJAS QUERO QUERO S A",
                        "id": 65487,
                        "createdAt": "2026-09-25T16:00:06.8668848",
                        "clienteId": 131386,
                        "pedido": "2053050575",
                        "dataPedido": "2026-09-22T00:00:00",
                        "previsaoEntrega": "2026-09-29T00:00:00",
                        "previsaoEntregaAjustada": "2026-10-09T00:00:00",
                        "statusPrazo": 1,
                        "statusEntrega": 2
                    },
                    {
                        "tag": "Todos",
                        "codigoCliente": "1497313",
                        "razaoSocial": "LOJAS QUERO QUERO S A",
                        "id": 65488,
                        "createdAt": "2026-09-25T16:00:06.8668855",
                        "clienteId": 131386,
                        "pedido": "2052970583",
                        "dataPedido": "2026-09-16T00:00:00",
                        "previsaoEntrega": "2026-09-18T00:00:00",
                        "previsaoEntregaAjustada": "2026-10-09T00:00:00",
                        "statusPrazo": 1,
                        "statusEntrega": 3
                    },
                    {
                        "tag": "Todos",
                        "codigoCliente": "1497313",
                        "razaoSocial": "LOJAS QUERO QUERO S A",
                        "id": 65489,
                        "createdAt": "2026-09-25T16:00:06.866886",
                        "clienteId": 131386,
                        "pedido": "2052970583",
                        "dataPedido": "2026-09-16T00:00:00",
                        "previsaoEntrega": "2026-09-18T00:00:00",
                        "previsaoEntregaAjustada": "2026-10-09T00:00:00",
                        "statusPrazo": 1,
                        "statusEntrega": 3
                    },
                    {
                        "tag": "Todos",
                        "codigoCliente": "1497313",
                        "razaoSocial": "LOJAS QUERO QUERO S A",
                        "id": 65490,
                        "createdAt": "2026-09-25T16:00:06.8668865",
                        "clienteId": 131386,
                        "pedido": "2052970583",
                        "dataPedido": "2026-09-16T00:00:00",
                        "previsaoEntrega": "2026-09-18T00:00:00",
                        "previsaoEntregaAjustada": "2026-10-09T00:00:00",
                        "statusPrazo": 1,
                        "statusEntrega": 3
                    },
                    {
                        "tag": "Todos",
                        "codigoCliente": "1497313",
                        "razaoSocial": "LOJAS QUERO QUERO S A",
                        "id": 65491,
                        "createdAt": "2026-09-25T16:00:06.866887",
                        "clienteId": 131386,
                        "pedido": "2052957277",
                        "dataPedido": "2026-09-15T00:00:00",
                        "previsaoEntrega": "2026-09-21T00:00:00",
                        "previsaoEntregaAjustada": "2026-10-06T00:00:00",
                        "statusPrazo": 1,
                        "statusEntrega": 3
                    },
                    {
                        "tag": "Todos",
                        "codigoCliente": "1497313",
                        "razaoSocial": "LOJAS QUERO QUERO S A",
                        "id": 65492,
                        "createdAt": "2026-09-25T16:00:06.8668876",
                        "clienteId": 131386,
                        "pedido": "2052957277",
                        "dataPedido": "2026-09-15T00:00:00",
                        "previsaoEntrega": "2026-09-21T00:00:00",
                        "previsaoEntregaAjustada": "2026-10-06T00:00:00",
                        "statusPrazo": 1,
                        "statusEntrega": 3
                    },
                    {
                        "tag": "Todos",
                        "codigoCliente": "1497313",
                        "razaoSocial": "LOJAS QUERO QUERO S A",
                        "id": 65493,
                        "createdAt": "2026-09-25T16:00:06.8668881",
                        "clienteId": 131386,
                        "pedido": "2052957277",
                        "dataPedido": "2026-09-15T00:00:00",
                        "previsaoEntrega": "2026-09-21T00:00:00",
                        "previsaoEntregaAjustada": "2026-10-06T00:00:00",
                        "statusPrazo": 1,
                        "statusEntrega": 3
                    },
                    {
                        "tag": "Todos",
                        "codigoCliente": "1635653",
                        "razaoSocial": "LOJAS QUERO QUERO S A",
                        "id": 65494,
                        "createdAt": "2026-09-25T16:00:06.8668886",
                        "clienteId": 124942,
                        "pedido": "2052970936",
                        "dataPedido": "2026-09-16T00:00:00",
                        "previsaoEntrega": "2026-09-18T00:00:00",
                        "previsaoEntregaAjustada": "2026-09-29T00:00:00",
                        "statusPrazo": 1,
                        "statusEntrega": 3
                    },
                    {
                        "tag": "Todos",
                        "codigoCliente": "1635653",
                        "razaoSocial": "LOJAS QUERO QUERO S A",
                        "id": 65495,
                        "createdAt": "2026-09-25T16:00:06.8668891",
                        "clienteId": 124942,
                        "pedido": "2052970936",
                        "dataPedido": "2026-09-16T00:00:00",
                        "previsaoEntrega": "2026-09-18T00:00:00",
                        "previsaoEntregaAjustada": "2026-09-29T00:00:00",
                        "statusPrazo": 1,
                        "statusEntrega": 3
                    },
                    {
                        "tag": "Todos",
                        "codigoCliente": "1635653",
                        "razaoSocial": "LOJAS QUERO QUERO S A",
                        "id": 65496,
                        "createdAt": "2026-09-25T16:00:06.8668898",
                        "clienteId": 124942,
                        "pedido": "2052970936",
                        "dataPedido": "2026-09-16T00:00:00",
                        "previsaoEntrega": "2026-09-18T00:00:00",
                        "previsaoEntregaAjustada": "2026-09-29T00:00:00",
                        "statusPrazo": 1,
                        "statusEntrega": 3
                    },
                    {
                        "tag": "Todos",
                        "codigoCliente": "1635653",
                        "razaoSocial": "LOJAS QUERO QUERO S A",
                        "id": 65497,
                        "createdAt": "2026-09-25T16:00:06.8668904",
                        "clienteId": 124942,
                        "pedido": "2052970936",
                        "dataPedido": "2026-09-16T00:00:00",
                        "previsaoEntrega": "2026-09-18T00:00:00",
                        "previsaoEntregaAjustada": "2026-09-29T00:00:00",
                        "statusPrazo": 1,
                        "statusEntrega": 3
                    },
                    {
                        "tag": "Todos",
                        "codigoCliente": "1635653",
                        "razaoSocial": "LOJAS QUERO QUERO S A",
                        "id": 65498,
                        "createdAt": "2026-09-25T16:00:06.8668909",
                        "clienteId": 124942,
                        "pedido": "2052913709",
                        "dataPedido": "2026-09-11T00:00:00",
                        "previsaoEntrega": "2026-09-15T00:00:00",
                        "previsaoEntregaAjustada": "2026-09-26T00:00:00",
                        "statusPrazo": 1,
                        "statusEntrega": 3
                    },
                    {
                        "tag": "Todos",
                        "codigoCliente": "1635653",
                        "razaoSocial": "LOJAS QUERO QUERO S A",
                        "id": 65499,
                        "createdAt": "2026-09-25T16:00:06.8668914",
                        "clienteId": 124942,
                        "pedido": "2052913709",
                        "dataPedido": "2026-09-11T00:00:00",
                        "previsaoEntrega": "2026-09-15T00:00:00",
                        "previsaoEntregaAjustada": "2026-09-26T00:00:00",
                        "statusPrazo": 1,
                        "statusEntrega": 3
                    },
                    {
                        "tag": "Todos",
                        "codigoCliente": "1635653",
                        "razaoSocial": "LOJAS QUERO QUERO S A",
                        "id": 65500,
                        "createdAt": "2026-09-25T16:00:06.866892",
                        "clienteId": 124942,
                        "pedido": "2052913709",
                        "dataPedido": "2026-09-11T00:00:00",
                        "previsaoEntrega": "2026-09-15T00:00:00",
                        "previsaoEntregaAjustada": "2026-09-26T00:00:00",
                        "statusPrazo": 1,
                        "statusEntrega": 3
                    },
                    {
                        "tag": "Todos",
                        "codigoCliente": "1635653",
                        "razaoSocial": "LOJAS QUERO QUERO S A",
                        "id": 65501,
                        "createdAt": "2026-09-25T16:00:06.8668925",
                        "clienteId": 124942,
                        "pedido": "2052913709",
                        "dataPedido": "2026-09-11T00:00:00",
                        "previsaoEntrega": "2026-09-15T00:00:00",
                        "previsaoEntregaAjustada": "2026-09-26T00:00:00",
                        "statusPrazo": 1,
                        "statusEntrega": 3
                    },
                    {
                        "tag": "Todos",
                        "codigoCliente": "1635653",
                        "razaoSocial": "LOJAS QUERO QUERO S A",
                        "id": 65502,
                        "createdAt": "2026-09-25T16:00:06.866893",
                        "clienteId": 124942,
                        "pedido": "2052957317",
                        "dataPedido": "2026-09-15T00:00:00",
                        "previsaoEntrega": "2026-09-18T00:00:00",
                        "previsaoEntregaAjustada": "2026-09-25T00:00:00",
                        "statusPrazo": 1,
                        "statusEntrega": 3
                    },
                    {
                        "tag": "Todos",
                        "codigoCliente": "1635653",
                        "razaoSocial": "LOJAS QUERO QUERO S A",
                        "id": 65503,
                        "createdAt": "2026-09-25T16:00:06.8668935",
                        "clienteId": 124942,
                        "pedido": "2052957317",
                        "dataPedido": "2026-09-15T00:00:00",
                        "previsaoEntrega": "2026-09-18T00:00:00",
                        "previsaoEntregaAjustada": "2026-09-25T00:00:00",
                        "statusPrazo": 1,
                        "statusEntrega": 3
                    },
                    {
                        "tag": "Todos",
                        "codigoCliente": "1635653",
                        "razaoSocial": "LOJAS QUERO QUERO S A",
                        "id": 65504,
                        "createdAt": "2026-09-25T16:00:06.866894",
                        "clienteId": 124942,
                        "pedido": "2052957317",
                        "dataPedido": "2026-09-15T00:00:00",
                        "previsaoEntrega": "2026-09-18T00:00:00",
                        "previsaoEntregaAjustada": "2026-09-25T00:00:00",
                        "statusPrazo": 1,
                        "statusEntrega": 3
                    },
                    {
                        "tag": "Todos",
                        "codigoCliente": "1635653",
                        "razaoSocial": "LOJAS QUERO QUERO S A",
                        "id": 65505,
                        "createdAt": "2026-09-25T16:00:06.8668946",
                        "clienteId": 124942,
                        "pedido": "2052957317",
                        "dataPedido": "2026-09-15T00:00:00",
                        "previsaoEntrega": "2026-09-18T00:00:00",
                        "previsaoEntregaAjustada": "2026-09-25T00:00:00",
                        "statusPrazo": 1,
                        "statusEntrega": 3
                    },
                    {
                        "tag": "Todos",
                        "codigoCliente": "1635653",
                        "razaoSocial": "LOJAS QUERO QUERO S A",
                        "id": 65506,
                        "createdAt": "2026-09-25T16:00:06.8668951",
                        "clienteId": 124942,
                        "pedido": "2052970915",
                        "dataPedido": "2026-09-16T00:00:00",
                        "previsaoEntrega": "2026-09-18T00:00:00",
                        "previsaoEntregaAjustada": "2026-09-26T00:00:00",
                        "statusPrazo": 1,
                        "statusEntrega": 3
                    },
                    {
                        "tag": "Todos",
                        "codigoCliente": "1635653",
                        "razaoSocial": "LOJAS QUERO QUERO S A",
                        "id": 65507,
                        "createdAt": "2026-09-25T16:00:06.8668956",
                        "clienteId": 124942,
                        "pedido": "2052970915",
                        "dataPedido": "2026-09-16T00:00:00",
                        "previsaoEntrega": "2026-09-18T00:00:00",
                        "previsaoEntregaAjustada": "2026-09-26T00:00:00",
                        "statusPrazo": 1,
                        "statusEntrega": 3
                    },
                    {
                        "tag": "Todos",
                        "codigoCliente": "1635653",
                        "razaoSocial": "LOJAS QUERO QUERO S A",
                        "id": 65508,
                        "createdAt": "2026-09-25T16:00:06.8668964",
                        "clienteId": 124942,
                        "pedido": "2052970915",
                        "dataPedido": "2026-09-16T00:00:00",
                        "previsaoEntrega": "2026-09-18T00:00:00",
                        "previsaoEntregaAjustada": "2026-09-26T00:00:00",
                        "statusPrazo": 1,
                        "statusEntrega": 3
                    },
                    {
                        "tag": "Todos",
                        "codigoCliente": "1635653",
                        "razaoSocial": "LOJAS QUERO QUERO S A",
                        "id": 65509,
                        "createdAt": "2026-09-25T16:00:06.8668969",
                        "clienteId": 124942,
                        "pedido": "2052970915",
                        "dataPedido": "2026-09-16T00:00:00",
                        "previsaoEntrega": "2026-09-18T00:00:00",
                        "previsaoEntregaAjustada": "2026-09-26T00:00:00",
                        "statusPrazo": 1,
                        "statusEntrega": 3
                    },
                    {
                        "tag": "Todos",
                        "codigoCliente": "1635653",
                        "razaoSocial": "LOJAS QUERO QUERO S A",
                        "id": 65510,
                        "createdAt": "2026-09-25T16:00:06.8668974",
                        "clienteId": 124942,
                        "pedido": "2052970958",
                        "dataPedido": "2026-09-16T00:00:00",
                        "previsaoEntrega": "2026-09-18T00:00:00",
                        "previsaoEntregaAjustada": "2026-09-26T00:00:00",
                        "statusPrazo": 1,
                        "statusEntrega": 3
                    },
                    {
                        "tag": "Todos",
                        "codigoCliente": "1635653",
                        "razaoSocial": "LOJAS QUERO QUERO S A",
                        "id": 65511,
                        "createdAt": "2026-09-25T16:00:06.8668979",
                        "clienteId": 124942,
                        "pedido": "2052970958",
                        "dataPedido": "2026-09-16T00:00:00",
                        "previsaoEntrega": "2026-09-18T00:00:00",
                        "previsaoEntregaAjustada": "2026-09-26T00:00:00",
                        "statusPrazo": 1,
                        "statusEntrega": 3
                    },
                    {
                        "tag": "Todos",
                        "codigoCliente": "1635653",
                        "razaoSocial": "LOJAS QUERO QUERO S A",
                        "id": 65512,
                        "createdAt": "2026-09-25T16:00:06.8668985",
                        "clienteId": 124942,
                        "pedido": "2052970958",
                        "dataPedido": "2026-09-16T00:00:00",
                        "previsaoEntrega": "2026-09-18T00:00:00",
                        "previsaoEntregaAjustada": "2026-09-26T00:00:00",
                        "statusPrazo": 1,
                        "statusEntrega": 3
                    },
                    {
                        "tag": "Todos",
                        "codigoCliente": "1635653",
                        "razaoSocial": "LOJAS QUERO QUERO S A",
                        "id": 65513,
                        "createdAt": "2026-09-25T16:00:06.866899",
                        "clienteId": 124942,
                        "pedido": "2052970958",
                        "dataPedido": "2026-09-16T00:00:00",
                        "previsaoEntrega": "2026-09-18T00:00:00",
                        "previsaoEntregaAjustada": "2026-09-26T00:00:00",
                        "statusPrazo": 1,
                        "statusEntrega": 3
                    },
                    {
                        "tag": "Todos",
                        "codigoCliente": "1635653",
                        "razaoSocial": "LOJAS QUERO QUERO S A",
                        "id": 65514,
                        "createdAt": "2026-09-25T16:00:06.8668995",
                        "clienteId": 124942,
                        "pedido": "2052941372",
                        "dataPedido": "2026-09-14T00:00:00",
                        "previsaoEntrega": "2026-09-22T00:00:00",
                        "previsaoEntregaAjustada": "2026-09-26T00:00:00",
                        "statusPrazo": 1,
                        "statusEntrega": 3
                    },
                    {
                        "tag": "Todos",
                        "codigoCliente": "1635653",
                        "razaoSocial": "LOJAS QUERO QUERO S A",
                        "id": 65515,
                        "createdAt": "2026-09-25T16:00:06.8669001",
                        "clienteId": 124942,
                        "pedido": "2052941372",
                        "dataPedido": "2026-09-14T00:00:00",
                        "previsaoEntrega": "2026-09-22T00:00:00",
                        "previsaoEntregaAjustada": "2026-09-26T00:00:00",
                        "statusPrazo": 1,
                        "statusEntrega": 3
                    },
                    {
                        "tag": "Todos",
                        "codigoCliente": "1635653",
                        "razaoSocial": "LOJAS QUERO QUERO S A",
                        "id": 65516,
                        "createdAt": "2026-09-25T16:00:06.8669006",
                        "clienteId": 124942,
                        "pedido": "2052941372",
                        "dataPedido": "2026-09-14T00:00:00",
                        "previsaoEntrega": "2026-09-22T00:00:00",
                        "previsaoEntregaAjustada": "2026-09-26T00:00:00",
                        "statusPrazo": 1,
                        "statusEntrega": 3
                    },
                    {
                        "tag": "Todos",
                        "codigoCliente": "1635653",
                        "razaoSocial": "LOJAS QUERO QUERO S A",
                        "id": 65517,
                        "createdAt": "2026-09-25T16:00:06.8669011",
                        "clienteId": 124942,
                        "pedido": "2052941372",
                        "dataPedido": "2026-09-14T00:00:00",
                        "previsaoEntrega": "2026-09-22T00:00:00",
                        "previsaoEntregaAjustada": "2026-09-26T00:00:00",
                        "statusPrazo": 1,
                        "statusEntrega": 3
                    },
                    {
                        "tag": "Todos",
                        "codigoCliente": "1635653",
                        "razaoSocial": "LOJAS QUERO QUERO S A",
                        "id": 65518,
                        "createdAt": "2026-09-25T16:00:06.8669016",
                        "clienteId": 124942,
                        "pedido": "2052970893",
                        "dataPedido": "2026-09-16T00:00:00",
                        "previsaoEntrega": "2026-09-18T00:00:00",
                        "previsaoEntregaAjustada": "2026-09-26T00:00:00",
                        "statusPrazo": 1,
                        "statusEntrega": 3
                    },
                    {
                        "tag": "Todos",
                        "codigoCliente": "1635653",
                        "razaoSocial": "LOJAS QUERO QUERO S A",
                        "id": 65519,
                        "createdAt": "2026-09-25T16:00:06.8669023",
                        "clienteId": 124942,
                        "pedido": "2052970893",
                        "dataPedido": "2026-09-16T00:00:00",
                        "previsaoEntrega": "2026-09-18T00:00:00",
                        "previsaoEntregaAjustada": "2026-09-26T00:00:00",
                        "statusPrazo": 1,
                        "statusEntrega": 3
                    },
                    {
                        "tag": "Todos",
                        "codigoCliente": "1635653",
                        "razaoSocial": "LOJAS QUERO QUERO S A",
                        "id": 65520,
                        "createdAt": "2026-09-25T16:00:06.8669028",
                        "clienteId": 124942,
                        "pedido": "2052970893",
                        "dataPedido": "2026-09-16T00:00:00",
                        "previsaoEntrega": "2026-09-18T00:00:00",
                        "previsaoEntregaAjustada": "2026-09-26T00:00:00",
                        "statusPrazo": 1,
                        "statusEntrega": 3
                    },
                    {
                        "tag": "Todos",
                        "codigoCliente": "1635653",
                        "razaoSocial": "LOJAS QUERO QUERO S A",
                        "id": 65521,
                        "createdAt": "2026-09-25T16:00:06.8669036",
                        "clienteId": 124942,
                        "pedido": "2052970893",
                        "dataPedido": "2026-09-16T00:00:00",
                        "previsaoEntrega": "2026-09-18T00:00:00",
                        "previsaoEntregaAjustada": "2026-09-26T00:00:00",
                        "statusPrazo": 1,
                        "statusEntrega": 3
                    },
                    {
                        "tag": "Todos",
                        "codigoCliente": "1051165",
                        "razaoSocial": "LOJAS BECKER LTDA",
                        "id": 66227,
                        "createdAt": "2026-09-25T16:00:06.876186",
                        "clienteId": 131405,
                        "pedido": "2052987421",
                        "dataPedido": "2026-09-17T00:00:00",
                        "previsaoEntrega": "2026-09-23T00:00:00",
                        "previsaoEntregaAjustada": "2026-10-06T00:00:00",
                        "statusPrazo": 1,
                        "statusEntrega": 3
                    },
                    {
                        "tag": "Todos",
                        "codigoCliente": "1051165",
                        "razaoSocial": "LOJAS BECKER LTDA",
                        "id": 66228,
                        "createdAt": "2026-09-25T16:00:06.8761865",
                        "clienteId": 131405,
                        "pedido": "2052987421",
                        "dataPedido": "2026-09-17T00:00:00",
                        "previsaoEntrega": "2026-09-23T00:00:00",
                        "previsaoEntregaAjustada": "2026-10-06T00:00:00",
                        "statusPrazo": 1,
                        "statusEntrega": 3
                    },
                    {
                        "tag": "Todos",
                        "codigoCliente": "1051165",
                        "razaoSocial": "LOJAS BECKER LTDA",
                        "id": 66229,
                        "createdAt": "2026-09-25T16:00:06.8761872",
                        "clienteId": 131405,
                        "pedido": "2052987421",
                        "dataPedido": "2026-09-17T00:00:00",
                        "previsaoEntrega": "2026-09-23T00:00:00",
                        "previsaoEntregaAjustada": "2026-10-06T00:00:00",
                        "statusPrazo": 1,
                        "statusEntrega": 3
                    },
                    {
                        "tag": "Todos",
                        "codigoCliente": "1051165",
                        "razaoSocial": "LOJAS BECKER LTDA",
                        "id": 66230,
                        "createdAt": "2026-09-25T16:00:06.8761877",
                        "clienteId": 131405,
                        "pedido": "2053023632",
                        "dataPedido": "2026-09-21T00:00:00",
                        "previsaoEntrega": "2026-09-25T00:00:00",
                        "previsaoEntregaAjustada": "2026-10-09T00:00:00",
                        "statusPrazo": 1,
                        "statusEntrega": 3
                    },
                    {
                        "tag": "Todos",
                        "codigoCliente": "1051165",
                        "razaoSocial": "LOJAS BECKER LTDA",
                        "id": 66231,
                        "createdAt": "2026-09-25T16:00:06.8761884",
                        "clienteId": 131405,
                        "pedido": "2053023632",
                        "dataPedido": "2026-09-21T00:00:00",
                        "previsaoEntrega": "2026-09-25T00:00:00",
                        "previsaoEntregaAjustada": "2026-10-09T00:00:00",
                        "statusPrazo": 1,
                        "statusEntrega": 3
                    },
                    {
                        "tag": "Todos",
                        "codigoCliente": "1051165",
                        "razaoSocial": "LOJAS BECKER LTDA",
                        "id": 66232,
                        "createdAt": "2026-09-25T16:00:06.876189",
                        "clienteId": 131405,
                        "pedido": "2053023632",
                        "dataPedido": "2026-09-21T00:00:00",
                        "previsaoEntrega": "2026-09-25T00:00:00",
                        "previsaoEntregaAjustada": "2026-10-09T00:00:00",
                        "statusPrazo": 1,
                        "statusEntrega": 3
                    },
                    {
                        "tag": "Todos",
                        "codigoCliente": "1935348",
                        "razaoSocial": "CARMEM M  R  SEVERO",
                        "id": 66483,
                        "createdAt": "2026-09-25T16:00:06.8763396",
                        "clienteId": 1171312,
                        "pedido": "2053046782",
                        "dataPedido": "2026-09-22T00:00:00",
                        "previsaoEntrega": "2026-09-28T00:00:00",
                        "previsaoEntregaAjustada": "2026-10-09T00:00:00",
                        "statusPrazo": 1,
                        "statusEntrega": 3
                    },
                    {
                        "tag": "Todos",
                        "codigoCliente": "1759159",
                        "razaoSocial": "FERRAGEM TRES CORACOES LTDA",
                        "id": 66657,
                        "createdAt": "2026-09-25T16:00:06.8764424",
                        "clienteId": 7749,
                        "pedido": "2053055482",
                        "dataPedido": "2026-09-23T00:00:00",
                        "previsaoEntrega": "2026-09-28T00:00:00",
                        "previsaoEntregaAjustada": "2026-10-09T00:00:00",
                        "statusPrazo": 1,
                        "statusEntrega": 3
                    },
                    {
                        "tag": "Todos",
                        "codigoCliente": "1759159",
                        "razaoSocial": "FERRAGEM TRES CORACOES LTDA",
                        "id": 66658,
                        "createdAt": "2026-09-25T16:00:06.876443",
                        "clienteId": 7749,
                        "pedido": "2053055482",
                        "dataPedido": "2026-09-23T00:00:00",
                        "previsaoEntrega": "2026-09-28T00:00:00",
                        "previsaoEntregaAjustada": "2026-10-09T00:00:00",
                        "statusPrazo": 1,
                        "statusEntrega": 3
                    },
                    {
                        "tag": "Todos",
                        "codigoCliente": "1759159",
                        "razaoSocial": "FERRAGEM TRES CORACOES LTDA",
                        "id": 66659,
                        "createdAt": "2026-09-25T16:00:06.8764439",
                        "clienteId": 7749,
                        "pedido": "2053055482",
                        "dataPedido": "2026-09-23T00:00:00",
                        "previsaoEntrega": "2026-09-28T00:00:00",
                        "previsaoEntregaAjustada": "2026-10-09T00:00:00",
                        "statusPrazo": 1,
                        "statusEntrega": 3
                    },
                    {
                        "tag": "Todos",
                        "codigoCliente": "1759159",
                        "razaoSocial": "FERRAGEM TRES CORACOES LTDA",
                        "id": 66660,
                        "createdAt": "2026-09-25T16:00:06.8764444",
                        "clienteId": 7749,
                        "pedido": "2053055482",
                        "dataPedido": "2026-09-23T00:00:00",
                        "previsaoEntrega": "2026-09-28T00:00:00",
                        "previsaoEntregaAjustada": "2026-10-09T00:00:00",
                        "statusPrazo": 1,
                        "statusEntrega": 3
                    },
                    {
                        "tag": "Todos",
                        "codigoCliente": "1456992",
                        "razaoSocial": "LOJAS QUERO QUERO S A",
                        "id": 69541,
                        "createdAt": "2026-09-25T16:00:06.8928073",
                        "clienteId": 131389,
                        "pedido": "2052941299",
                        "dataPedido": "2026-09-14T00:00:00",
                        "previsaoEntrega": "2026-09-23T00:00:00",
                        "previsaoEntregaAjustada": "2026-09-28T00:00:00",
                        "statusPrazo": 1,
                        "statusEntrega": 3
                    },
                    {
                        "tag": "Todos",
                        "codigoCliente": "1456992",
                        "razaoSocial": "LOJAS QUERO QUERO S A",
                        "id": 69542,
                        "createdAt": "2026-09-25T16:00:06.8928079",
                        "clienteId": 131389,
                        "pedido": "2052941299",
                        "dataPedido": "2026-09-14T00:00:00",
                        "previsaoEntrega": "2026-09-23T00:00:00",
                        "previsaoEntregaAjustada": "2026-09-28T00:00:00",
                        "statusPrazo": 1,
                        "statusEntrega": 3
                    },
                    {
                        "tag": "Todos",
                        "codigoCliente": "1456992",
                        "razaoSocial": "LOJAS QUERO QUERO S A",
                        "id": 69543,
                        "createdAt": "2026-09-25T16:00:06.8928084",
                        "clienteId": 131389,
                        "pedido": "2052941299",
                        "dataPedido": "2026-09-14T00:00:00",
                        "previsaoEntrega": "2026-09-23T00:00:00",
                        "previsaoEntregaAjustada": "2026-09-28T00:00:00",
                        "statusPrazo": 1,
                        "statusEntrega": 3
                    },
                    {
                        "tag": "Todos",
                        "codigoCliente": "1456992",
                        "razaoSocial": "LOJAS QUERO QUERO S A",
                        "id": 69544,
                        "createdAt": "2026-09-25T16:00:06.8928091",
                        "clienteId": 131389,
                        "pedido": "2053003794",
                        "dataPedido": "2026-09-18T00:00:00",
                        "previsaoEntrega": "2026-09-28T00:00:00",
                        "previsaoEntregaAjustada": "2026-09-28T00:00:00",
                        "statusPrazo": 1,
                        "statusEntrega": 2
                    },
                    {
                        "tag": "Todos",
                        "codigoCliente": "1456992",
                        "razaoSocial": "LOJAS QUERO QUERO S A",
                        "id": 69545,
                        "createdAt": "2026-09-25T16:00:06.8928096",
                        "clienteId": 131389,
                        "pedido": "2053003794",
                        "dataPedido": "2026-09-18T00:00:00",
                        "previsaoEntrega": "2026-09-28T00:00:00",
                        "previsaoEntregaAjustada": "2026-09-28T00:00:00",
                        "statusPrazo": 1,
                        "statusEntrega": 2
                    },
                    {
                        "tag": "Todos",
                        "codigoCliente": "1456992",
                        "razaoSocial": "LOJAS QUERO QUERO S A",
                        "id": 69546,
                        "createdAt": "2026-09-25T16:00:06.8928103",
                        "clienteId": 131389,
                        "pedido": "2053003794",
                        "dataPedido": "2026-09-18T00:00:00",
                        "previsaoEntrega": "2026-09-28T00:00:00",
                        "previsaoEntregaAjustada": "2026-09-28T00:00:00",
                        "statusPrazo": 1,
                        "statusEntrega": 2
                    },
                    {
                        "tag": "Todos",
                        "codigoCliente": "1456992",
                        "razaoSocial": "LOJAS QUERO QUERO S A",
                        "id": 69547,
                        "createdAt": "2026-09-25T16:00:06.8928108",
                        "clienteId": 131389,
                        "pedido": "2052970293",
                        "dataPedido": "2026-09-16T00:00:00",
                        "previsaoEntrega": "2026-09-18T00:00:00",
                        "previsaoEntregaAjustada": "2026-09-26T00:00:00",
                        "statusPrazo": 1,
                        "statusEntrega": 3
                    },
                    {
                        "tag": "Todos",
                        "codigoCliente": "1456992",
                        "razaoSocial": "LOJAS QUERO QUERO S A",
                        "id": 69548,
                        "createdAt": "2026-09-25T16:00:06.8928114",
                        "clienteId": 131389,
                        "pedido": "2052970293",
                        "dataPedido": "2026-09-16T00:00:00",
                        "previsaoEntrega": "2026-09-18T00:00:00",
                        "previsaoEntregaAjustada": "2026-09-26T00:00:00",
                        "statusPrazo": 1,
                        "statusEntrega": 3
                    },
                    {
                        "tag": "Todos",
                        "codigoCliente": "1456992",
                        "razaoSocial": "LOJAS QUERO QUERO S A",
                        "id": 69549,
                        "createdAt": "2026-09-25T16:00:06.8928119",
                        "clienteId": 131389,
                        "pedido": "2052970293",
                        "dataPedido": "2026-09-16T00:00:00",
                        "previsaoEntrega": "2026-09-18T00:00:00",
                        "previsaoEntregaAjustada": "2026-09-26T00:00:00",
                        "statusPrazo": 1,
                        "statusEntrega": 3
                    },
                    {
                        "tag": "Todos",
                        "codigoCliente": "1456992",
                        "razaoSocial": "LOJAS QUERO QUERO S A",
                        "id": 69550,
                        "createdAt": "2026-09-25T16:00:06.8928125",
                        "clienteId": 131389,
                        "pedido": "2053030622",
                        "dataPedido": "2026-09-21T00:00:00",
                        "previsaoEntrega": "2026-09-24T00:00:00",
                        "previsaoEntregaAjustada": "2026-09-28T00:00:00",
                        "statusPrazo": 1,
                        "statusEntrega": 3
                    },
                    {
                        "tag": "Todos",
                        "codigoCliente": "1456992",
                        "razaoSocial": "LOJAS QUERO QUERO S A",
                        "id": 69551,
                        "createdAt": "2026-09-25T16:00:06.8928131",
                        "clienteId": 131389,
                        "pedido": "2053030622",
                        "dataPedido": "2026-09-21T00:00:00",
                        "previsaoEntrega": "2026-09-24T00:00:00",
                        "previsaoEntregaAjustada": "2026-09-28T00:00:00",
                        "statusPrazo": 1,
                        "statusEntrega": 3
                    },
                    {
                        "tag": "Todos",
                        "codigoCliente": "1456992",
                        "razaoSocial": "LOJAS QUERO QUERO S A",
                        "id": 69552,
                        "createdAt": "2026-09-25T16:00:06.8928138",
                        "clienteId": 131389,
                        "pedido": "2053030622",
                        "dataPedido": "2026-09-21T00:00:00",
                        "previsaoEntrega": "2026-09-24T00:00:00",
                        "previsaoEntregaAjustada": "2026-09-28T00:00:00",
                        "statusPrazo": 1,
                        "statusEntrega": 3
                    },
                    {
                        "tag": "Todos",
                        "codigoCliente": "1456992",
                        "razaoSocial": "LOJAS QUERO QUERO S A",
                        "id": 69553,
                        "createdAt": "2026-09-25T16:00:06.8928146",
                        "clienteId": 131389,
                        "pedido": "2052970258",
                        "dataPedido": "2026-09-16T00:00:00",
                        "previsaoEntrega": "2026-09-18T00:00:00",
                        "previsaoEntregaAjustada": "2026-09-26T00:00:00",
                        "statusPrazo": 1,
                        "statusEntrega": 3
                    },
                    {
                        "tag": "Todos",
                        "codigoCliente": "1456992",
                        "razaoSocial": "LOJAS QUERO QUERO S A",
                        "id": 69554,
                        "createdAt": "2026-09-25T16:00:06.8928151",
                        "clienteId": 131389,
                        "pedido": "2052970258",
                        "dataPedido": "2026-09-16T00:00:00",
                        "previsaoEntrega": "2026-09-18T00:00:00",
                        "previsaoEntregaAjustada": "2026-09-26T00:00:00",
                        "statusPrazo": 1,
                        "statusEntrega": 3
                    },
                    {
                        "tag": "Todos",
                        "codigoCliente": "1456992",
                        "razaoSocial": "LOJAS QUERO QUERO S A",
                        "id": 69555,
                        "createdAt": "2026-09-25T16:00:06.8928158",
                        "clienteId": 131389,
                        "pedido": "2052970258",
                        "dataPedido": "2026-09-16T00:00:00",
                        "previsaoEntrega": "2026-09-18T00:00:00",
                        "previsaoEntregaAjustada": "2026-09-26T00:00:00",
                        "statusPrazo": 1,
                        "statusEntrega": 3
                    },
                    {
                        "tag": "Todos",
                        "codigoCliente": "1456992",
                        "razaoSocial": "LOJAS QUERO QUERO S A",
                        "id": 69556,
                        "createdAt": "2026-09-25T16:00:06.8928163",
                        "clienteId": 131389,
                        "pedido": "2052998406",
                        "dataPedido": "2026-09-18T00:00:00",
                        "previsaoEntrega": "2026-09-22T00:00:00",
                        "previsaoEntregaAjustada": "2026-09-26T00:00:00",
                        "statusPrazo": 1,
                        "statusEntrega": 3
                    },
                    {
                        "tag": "Todos",
                        "codigoCliente": "1456992",
                        "razaoSocial": "LOJAS QUERO QUERO S A",
                        "id": 69557,
                        "createdAt": "2026-09-25T16:00:06.892817",
                        "clienteId": 131389,
                        "pedido": "2052998406",
                        "dataPedido": "2026-09-18T00:00:00",
                        "previsaoEntrega": "2026-09-22T00:00:00",
                        "previsaoEntregaAjustada": "2026-09-26T00:00:00",
                        "statusPrazo": 1,
                        "statusEntrega": 3
                    },
                    {
                        "tag": "Todos",
                        "codigoCliente": "1456992",
                        "razaoSocial": "LOJAS QUERO QUERO S A",
                        "id": 69558,
                        "createdAt": "2026-09-25T16:00:06.8928175",
                        "clienteId": 131389,
                        "pedido": "2052998406",
                        "dataPedido": "2026-09-18T00:00:00",
                        "previsaoEntrega": "2026-09-22T00:00:00",
                        "previsaoEntregaAjustada": "2026-09-26T00:00:00",
                        "statusPrazo": 1,
                        "statusEntrega": 3
                    },
                    {
                        "tag": "Todos",
                        "codigoCliente": "1126065",
                        "razaoSocial": "LOJAS QUERO QUERO S A",
                        "id": 70281,
                        "createdAt": "2026-09-25T16:00:06.8932462",
                        "clienteId": 50621,
                        "pedido": "2053050474",
                        "dataPedido": "2026-09-22T00:00:00",
                        "previsaoEntrega": "2026-09-25T00:00:00",
                        "previsaoEntregaAjustada": "2026-09-25T00:00:00",
                        "statusPrazo": 1,
                        "statusEntrega": 2
                    },
                    {
                        "tag": "Todos",
                        "codigoCliente": "1126065",
                        "razaoSocial": "LOJAS QUERO QUERO S A",
                        "id": 70282,
                        "createdAt": "2026-09-25T16:00:06.8932467",
                        "clienteId": 50621,
                        "pedido": "2053050474",
                        "dataPedido": "2026-09-22T00:00:00",
                        "previsaoEntrega": "2026-09-25T00:00:00",
                        "previsaoEntregaAjustada": "2026-09-25T00:00:00",
                        "statusPrazo": 1,
                        "statusEntrega": 2
                    },
                    {
                        "tag": "Todos",
                        "codigoCliente": "1126065",
                        "razaoSocial": "LOJAS QUERO QUERO S A",
                        "id": 70283,
                        "createdAt": "2026-09-25T16:00:06.8932473",
                        "clienteId": 50621,
                        "pedido": "2053050474",
                        "dataPedido": "2026-09-22T00:00:00",
                        "previsaoEntrega": "2026-09-25T00:00:00",
                        "previsaoEntregaAjustada": "2026-09-25T00:00:00",
                        "statusPrazo": 1,
                        "statusEntrega": 2
                    },
                    {
                        "tag": "Todos",
                        "codigoCliente": "1126065",
                        "razaoSocial": "LOJAS QUERO QUERO S A",
                        "id": 70284,
                        "createdAt": "2026-09-25T16:00:06.8932479",
                        "clienteId": 50621,
                        "pedido": "2053050492",
                        "dataPedido": "2026-09-22T00:00:00",
                        "previsaoEntrega": "2026-09-28T00:00:00",
                        "previsaoEntregaAjustada": "2026-09-28T00:00:00",
                        "statusPrazo": 1,
                        "statusEntrega": 2
                    },
                    {
                        "tag": "Todos",
                        "codigoCliente": "1126065",
                        "razaoSocial": "LOJAS QUERO QUERO S A",
                        "id": 70285,
                        "createdAt": "2026-09-25T16:00:06.8932484",
                        "clienteId": 50621,
                        "pedido": "2053050492",
                        "dataPedido": "2026-09-22T00:00:00",
                        "previsaoEntrega": "2026-09-28T00:00:00",
                        "previsaoEntregaAjustada": "2026-09-28T00:00:00",
                        "statusPrazo": 1,
                        "statusEntrega": 2
                    },
                    {
                        "tag": "Todos",
                        "codigoCliente": "1126065",
                        "razaoSocial": "LOJAS QUERO QUERO S A",
                        "id": 70286,
                        "createdAt": "2026-09-25T16:00:06.8932488",
                        "clienteId": 50621,
                        "pedido": "2053050492",
                        "dataPedido": "2026-09-22T00:00:00",
                        "previsaoEntrega": "2026-09-28T00:00:00",
                        "previsaoEntregaAjustada": "2026-09-28T00:00:00",
                        "statusPrazo": 1,
                        "statusEntrega": 2
                    },
                    {
                        "tag": "Todos",
                        "codigoCliente": "1126065",
                        "razaoSocial": "LOJAS QUERO QUERO S A",
                        "id": 70287,
                        "createdAt": "2026-09-25T16:00:06.8932493",
                        "clienteId": 50621,
                        "pedido": "2053010140",
                        "dataPedido": "2026-09-18T00:00:00",
                        "previsaoEntrega": "2026-09-24T00:00:00",
                        "previsaoEntregaAjustada": "2026-09-28T00:00:00",
                        "statusPrazo": 1,
                        "statusEntrega": 2
                    },
                    {
                        "tag": "Todos",
                        "codigoCliente": "1126065",
                        "razaoSocial": "LOJAS QUERO QUERO S A",
                        "id": 70288,
                        "createdAt": "2026-09-25T16:00:06.8932498",
                        "clienteId": 50621,
                        "pedido": "2053010140",
                        "dataPedido": "2026-09-18T00:00:00",
                        "previsaoEntrega": "2026-09-24T00:00:00",
                        "previsaoEntregaAjustada": "2026-09-28T00:00:00",
                        "statusPrazo": 1,
                        "statusEntrega": 2
                    },
                    {
                        "tag": "Todos",
                        "codigoCliente": "1126065",
                        "razaoSocial": "LOJAS QUERO QUERO S A",
                        "id": 70289,
                        "createdAt": "2026-09-25T16:00:06.8932504",
                        "clienteId": 50621,
                        "pedido": "2053010140",
                        "dataPedido": "2026-09-18T00:00:00",
                        "previsaoEntrega": "2026-09-24T00:00:00",
                        "previsaoEntregaAjustada": "2026-09-28T00:00:00",
                        "statusPrazo": 1,
                        "statusEntrega": 2
                    },
                    {
                        "tag": "Todos",
                        "codigoCliente": "1126065",
                        "razaoSocial": "LOJAS QUERO QUERO S A",
                        "id": 70290,
                        "createdAt": "2026-09-25T16:00:06.893251",
                        "clienteId": 50621,
                        "pedido": "2052969436",
                        "dataPedido": "2026-09-16T00:00:00",
                        "previsaoEntrega": "2026-09-18T00:00:00",
                        "previsaoEntregaAjustada": "2026-09-28T00:00:00",
                        "statusPrazo": 1,
                        "statusEntrega": 3
                    },
                    {
                        "tag": "Todos",
                        "codigoCliente": "1126065",
                        "razaoSocial": "LOJAS QUERO QUERO S A",
                        "id": 70291,
                        "createdAt": "2026-09-25T16:00:06.8932517",
                        "clienteId": 50621,
                        "pedido": "2052969436",
                        "dataPedido": "2026-09-16T00:00:00",
                        "previsaoEntrega": "2026-09-18T00:00:00",
                        "previsaoEntregaAjustada": "2026-09-28T00:00:00",
                        "statusPrazo": 1,
                        "statusEntrega": 3
                    },
                    {
                        "tag": "Todos",
                        "codigoCliente": "1126065",
                        "razaoSocial": "LOJAS QUERO QUERO S A",
                        "id": 70292,
                        "createdAt": "2026-09-25T16:00:06.8932522",
                        "clienteId": 50621,
                        "pedido": "2052969436",
                        "dataPedido": "2026-09-16T00:00:00",
                        "previsaoEntrega": "2026-09-18T00:00:00",
                        "previsaoEntregaAjustada": "2026-09-28T00:00:00",
                        "statusPrazo": 1,
                        "statusEntrega": 3
                    },
                    {
                        "tag": "Todos",
                        "codigoCliente": "1126065",
                        "razaoSocial": "LOJAS QUERO QUERO S A",
                        "id": 70293,
                        "createdAt": "2026-09-25T16:00:06.8932529",
                        "clienteId": 50621,
                        "pedido": "2052969415",
                        "dataPedido": "2026-09-16T00:00:00",
                        "previsaoEntrega": "2026-09-18T00:00:00",
                        "previsaoEntregaAjustada": "2026-09-28T00:00:00",
                        "statusPrazo": 1,
                        "statusEntrega": 3
                    },
                    {
                        "tag": "Todos",
                        "codigoCliente": "1126065",
                        "razaoSocial": "LOJAS QUERO QUERO S A",
                        "id": 70294,
                        "createdAt": "2026-09-25T16:00:06.8932535",
                        "clienteId": 50621,
                        "pedido": "2052969415",
                        "dataPedido": "2026-09-16T00:00:00",
                        "previsaoEntrega": "2026-09-18T00:00:00",
                        "previsaoEntregaAjustada": "2026-09-28T00:00:00",
                        "statusPrazo": 1,
                        "statusEntrega": 3
                    },
                    {
                        "tag": "Todos",
                        "codigoCliente": "1126065",
                        "razaoSocial": "LOJAS QUERO QUERO S A",
                        "id": 70295,
                        "createdAt": "2026-09-25T16:00:06.893254",
                        "clienteId": 50621,
                        "pedido": "2052969415",
                        "dataPedido": "2026-09-16T00:00:00",
                        "previsaoEntrega": "2026-09-18T00:00:00",
                        "previsaoEntregaAjustada": "2026-09-28T00:00:00",
                        "statusPrazo": 1,
                        "statusEntrega": 3
                    },
                    {
                        "tag": "Todos",
                        "codigoCliente": "1057696",
                        "razaoSocial": "LOJAS QUERO QUERO S A",
                        "id": 70390,
                        "createdAt": "2026-09-25T16:00:06.8933102",
                        "clienteId": 131409,
                        "pedido": "2053010570",
                        "dataPedido": "2026-09-18T00:00:00",
                        "previsaoEntrega": "2026-09-25T00:00:00",
                        "previsaoEntregaAjustada": "2026-09-25T00:00:00",
                        "statusPrazo": 1,
                        "statusEntrega": 2
                    },
                    {
                        "tag": "Todos",
                        "codigoCliente": "1057696",
                        "razaoSocial": "LOJAS QUERO QUERO S A",
                        "id": 70391,
                        "createdAt": "2026-09-25T16:00:06.8933107",
                        "clienteId": 131409,
                        "pedido": "2053010570",
                        "dataPedido": "2026-09-18T00:00:00",
                        "previsaoEntrega": "2026-09-25T00:00:00",
                        "previsaoEntregaAjustada": "2026-09-25T00:00:00",
                        "statusPrazo": 1,
                        "statusEntrega": 2
                    },
                    {
                        "tag": "Todos",
                        "codigoCliente": "1057696",
                        "razaoSocial": "LOJAS QUERO QUERO S A",
                        "id": 70392,
                        "createdAt": "2026-09-25T16:00:06.8933114",
                        "clienteId": 131409,
                        "pedido": "2053010570",
                        "dataPedido": "2026-09-18T00:00:00",
                        "previsaoEntrega": "2026-09-25T00:00:00",
                        "previsaoEntregaAjustada": "2026-09-25T00:00:00",
                        "statusPrazo": 1,
                        "statusEntrega": 2
                    },
                    {
                        "tag": "Todos",
                        "codigoCliente": "1057696",
                        "razaoSocial": "LOJAS QUERO QUERO S A",
                        "id": 70393,
                        "createdAt": "2026-09-25T16:00:06.893312",
                        "clienteId": 131409,
                        "pedido": "2052999176",
                        "dataPedido": "2026-09-18T00:00:00",
                        "previsaoEntrega": "2026-09-24T00:00:00",
                        "previsaoEntregaAjustada": "2026-09-28T00:00:00",
                        "statusPrazo": 1,
                        "statusEntrega": 3
                    },
                    {
                        "tag": "Todos",
                        "codigoCliente": "1057696",
                        "razaoSocial": "LOJAS QUERO QUERO S A",
                        "id": 70394,
                        "createdAt": "2026-09-25T16:00:06.8933127",
                        "clienteId": 131409,
                        "pedido": "2052999176",
                        "dataPedido": "2026-09-18T00:00:00",
                        "previsaoEntrega": "2026-09-24T00:00:00",
                        "previsaoEntregaAjustada": "2026-09-28T00:00:00",
                        "statusPrazo": 1,
                        "statusEntrega": 3
                    },
                    {
                        "tag": "Todos",
                        "codigoCliente": "1057696",
                        "razaoSocial": "LOJAS QUERO QUERO S A",
                        "id": 70395,
                        "createdAt": "2026-09-25T16:00:06.8933133",
                        "clienteId": 131409,
                        "pedido": "2052999176",
                        "dataPedido": "2026-09-18T00:00:00",
                        "previsaoEntrega": "2026-09-24T00:00:00",
                        "previsaoEntregaAjustada": "2026-09-28T00:00:00",
                        "statusPrazo": 1,
                        "statusEntrega": 3
                    },
                    {
                        "tag": "Todos",
                        "codigoCliente": "1057696",
                        "razaoSocial": "LOJAS QUERO QUERO S A",
                        "id": 70396,
                        "createdAt": "2026-09-25T16:00:06.8933143",
                        "clienteId": 131409,
                        "pedido": "2053077050",
                        "dataPedido": "2026-09-24T00:00:00",
                        "previsaoEntrega": "2026-10-02T00:00:00",
                        "previsaoEntregaAjustada": "2026-10-02T00:00:00",
                        "statusPrazo": 1,
                        "statusEntrega": 2
                    },
                    {
                        "tag": "Todos",
                        "codigoCliente": "1057696",
                        "razaoSocial": "LOJAS QUERO QUERO S A",
                        "id": 70397,
                        "createdAt": "2026-09-25T16:00:06.8933148",
                        "clienteId": 131409,
                        "pedido": "2053077050",
                        "dataPedido": "2026-09-24T00:00:00",
                        "previsaoEntrega": "2026-10-02T00:00:00",
                        "previsaoEntregaAjustada": "2026-10-02T00:00:00",
                        "statusPrazo": 1,
                        "statusEntrega": 2
                    },
                    {
                        "tag": "Todos",
                        "codigoCliente": "1057696",
                        "razaoSocial": "LOJAS QUERO QUERO S A",
                        "id": 70398,
                        "createdAt": "2026-09-25T16:00:06.8933153",
                        "clienteId": 131409,
                        "pedido": "2053077050",
                        "dataPedido": "2026-09-24T00:00:00",
                        "previsaoEntrega": "2026-10-02T00:00:00",
                        "previsaoEntregaAjustada": "2026-10-02T00:00:00",
                        "statusPrazo": 1,
                        "statusEntrega": 2
                    },
                    {
                        "tag": "Todos",
                        "codigoCliente": "1057696",
                        "razaoSocial": "LOJAS QUERO QUERO S A",
                        "id": 70399,
                        "createdAt": "2026-09-25T16:00:06.8933159",
                        "clienteId": 131409,
                        "pedido": "2053063729",
                        "dataPedido": "2026-09-23T00:00:00",
                        "previsaoEntrega": "2026-09-29T00:00:00",
                        "previsaoEntregaAjustada": "2026-09-29T00:00:00",
                        "statusPrazo": 1,
                        "statusEntrega": 2
                    },
                    {
                        "tag": "Todos",
                        "codigoCliente": "1057696",
                        "razaoSocial": "LOJAS QUERO QUERO S A",
                        "id": 70400,
                        "createdAt": "2026-09-25T16:00:06.8933166",
                        "clienteId": 131409,
                        "pedido": "2053063729",
                        "dataPedido": "2026-09-23T00:00:00",
                        "previsaoEntrega": "2026-09-29T00:00:00",
                        "previsaoEntregaAjustada": "2026-09-29T00:00:00",
                        "statusPrazo": 1,
                        "statusEntrega": 2
                    },
                    {
                        "tag": "Todos",
                        "codigoCliente": "1057696",
                        "razaoSocial": "LOJAS QUERO QUERO S A",
                        "id": 70401,
                        "createdAt": "2026-09-25T16:00:06.8933174",
                        "clienteId": 131409,
                        "pedido": "2053063729",
                        "dataPedido": "2026-09-23T00:00:00",
                        "previsaoEntrega": "2026-09-29T00:00:00",
                        "previsaoEntregaAjustada": "2026-09-29T00:00:00",
                        "statusPrazo": 1,
                        "statusEntrega": 2
                    },
                    {
                        "tag": "Todos",
                        "codigoCliente": "1057696",
                        "razaoSocial": "LOJAS QUERO QUERO S A",
                        "id": 70402,
                        "createdAt": "2026-09-25T16:00:06.8933179",
                        "clienteId": 131409,
                        "pedido": "2052981685",
                        "dataPedido": "2026-09-17T00:00:00",
                        "previsaoEntrega": "2026-09-25T00:00:00",
                        "previsaoEntregaAjustada": "2026-09-25T00:00:00",
                        "statusPrazo": 1,
                        "statusEntrega": 2
                    },
                    {
                        "tag": "Todos",
                        "codigoCliente": "1057696",
                        "razaoSocial": "LOJAS QUERO QUERO S A",
                        "id": 70403,
                        "createdAt": "2026-09-25T16:00:06.8933188",
                        "clienteId": 131409,
                        "pedido": "2052981685",
                        "dataPedido": "2026-09-17T00:00:00",
                        "previsaoEntrega": "2026-09-25T00:00:00",
                        "previsaoEntregaAjustada": "2026-09-25T00:00:00",
                        "statusPrazo": 1,
                        "statusEntrega": 2
                    },
                    {
                        "tag": "Todos",
                        "codigoCliente": "1057696",
                        "razaoSocial": "LOJAS QUERO QUERO S A",
                        "id": 70404,
                        "createdAt": "2026-09-25T16:00:06.8933193",
                        "clienteId": 131409,
                        "pedido": "2052981685",
                        "dataPedido": "2026-09-17T00:00:00",
                        "previsaoEntrega": "2026-09-25T00:00:00",
                        "previsaoEntregaAjustada": "2026-09-25T00:00:00",
                        "statusPrazo": 1,
                        "statusEntrega": 2
                    },
                    {
                        "tag": "Todos",
                        "codigoCliente": "1057696",
                        "razaoSocial": "LOJAS QUERO QUERO S A",
                        "id": 70405,
                        "createdAt": "2026-09-25T16:00:06.89332",
                        "clienteId": 131409,
                        "pedido": "2052974631",
                        "dataPedido": "2026-09-16T00:00:00",
                        "previsaoEntrega": "2026-09-18T00:00:00",
                        "previsaoEntregaAjustada": "2026-09-28T00:00:00",
                        "statusPrazo": 1,
                        "statusEntrega": 3
                    },
                    {
                        "tag": "Todos",
                        "codigoCliente": "1057696",
                        "razaoSocial": "LOJAS QUERO QUERO S A",
                        "id": 70406,
                        "createdAt": "2026-09-25T16:00:06.8933206",
                        "clienteId": 131409,
                        "pedido": "2052974631",
                        "dataPedido": "2026-09-16T00:00:00",
                        "previsaoEntrega": "2026-09-18T00:00:00",
                        "previsaoEntregaAjustada": "2026-09-28T00:00:00",
                        "statusPrazo": 1,
                        "statusEntrega": 3
                    },
                    {
                        "tag": "Todos",
                        "codigoCliente": "1057696",
                        "razaoSocial": "LOJAS QUERO QUERO S A",
                        "id": 70407,
                        "createdAt": "2026-09-25T16:00:06.8933213",
                        "clienteId": 131409,
                        "pedido": "2052974631",
                        "dataPedido": "2026-09-16T00:00:00",
                        "previsaoEntrega": "2026-09-18T00:00:00",
                        "previsaoEntregaAjustada": "2026-09-28T00:00:00",
                        "statusPrazo": 1,
                        "statusEntrega": 3
                    },
                    {
                        "tag": "Todos",
                        "codigoCliente": "1203028",
                        "razaoSocial": "LOJAS QUERO QUERO S A",
                        "id": 70408,
                        "createdAt": "2026-09-25T16:00:06.8933218",
                        "clienteId": 139109,
                        "pedido": "2052905050",
                        "dataPedido": "2026-09-10T00:00:00",
                        "previsaoEntrega": "2026-09-17T00:00:00",
                        "previsaoEntregaAjustada": "2026-09-26T00:00:00",
                        "statusPrazo": 1,
                        "statusEntrega": 3
                    },
                    {
                        "tag": "Todos",
                        "codigoCliente": "1203028",
                        "razaoSocial": "LOJAS QUERO QUERO S A",
                        "id": 70409,
                        "createdAt": "2026-09-25T16:00:06.8933223",
                        "clienteId": 139109,
                        "pedido": "2052905050",
                        "dataPedido": "2026-09-10T00:00:00",
                        "previsaoEntrega": "2026-09-17T00:00:00",
                        "previsaoEntregaAjustada": "2026-09-26T00:00:00",
                        "statusPrazo": 1,
                        "statusEntrega": 3
                    },
                    {
                        "tag": "Todos",
                        "codigoCliente": "1203028",
                        "razaoSocial": "LOJAS QUERO QUERO S A",
                        "id": 70410,
                        "createdAt": "2026-09-25T16:00:06.893323",
                        "clienteId": 139109,
                        "pedido": "2052905050",
                        "dataPedido": "2026-09-10T00:00:00",
                        "previsaoEntrega": "2026-09-17T00:00:00",
                        "previsaoEntregaAjustada": "2026-09-26T00:00:00",
                        "statusPrazo": 1,
                        "statusEntrega": 3
                    },
                    {
                        "tag": "Todos",
                        "codigoCliente": "1203028",
                        "razaoSocial": "LOJAS QUERO QUERO S A",
                        "id": 70411,
                        "createdAt": "2026-09-25T16:00:06.8933235",
                        "clienteId": 139109,
                        "pedido": "2052974715",
                        "dataPedido": "2026-09-16T00:00:00",
                        "previsaoEntrega": "2026-09-18T00:00:00",
                        "previsaoEntregaAjustada": "2026-09-28T00:00:00",
                        "statusPrazo": 1,
                        "statusEntrega": 3
                    },
                    {
                        "tag": "Todos",
                        "codigoCliente": "1203028",
                        "razaoSocial": "LOJAS QUERO QUERO S A",
                        "id": 70412,
                        "createdAt": "2026-09-25T16:00:06.893324",
                        "clienteId": 139109,
                        "pedido": "2052974715",
                        "dataPedido": "2026-09-16T00:00:00",
                        "previsaoEntrega": "2026-09-18T00:00:00",
                        "previsaoEntregaAjustada": "2026-09-28T00:00:00",
                        "statusPrazo": 1,
                        "statusEntrega": 3
                    },
                    {
                        "tag": "Todos",
                        "codigoCliente": "1203028",
                        "razaoSocial": "LOJAS QUERO QUERO S A",
                        "id": 70413,
                        "createdAt": "2026-09-25T16:00:06.8933248",
                        "clienteId": 139109,
                        "pedido": "2052974715",
                        "dataPedido": "2026-09-16T00:00:00",
                        "previsaoEntrega": "2026-09-18T00:00:00",
                        "previsaoEntregaAjustada": "2026-09-28T00:00:00",
                        "statusPrazo": 1,
                        "statusEntrega": 3
                    },
                    {
                        "tag": "Todos",
                        "codigoCliente": "1203028",
                        "razaoSocial": "LOJAS QUERO QUERO S A",
                        "id": 70414,
                        "createdAt": "2026-09-25T16:00:06.8933253",
                        "clienteId": 139109,
                        "pedido": "2052974710",
                        "dataPedido": "2026-09-16T00:00:00",
                        "previsaoEntrega": "2026-09-18T00:00:00",
                        "previsaoEntregaAjustada": "2026-09-28T00:00:00",
                        "statusPrazo": 1,
                        "statusEntrega": 3
                    },
                    {
                        "tag": "Todos",
                        "codigoCliente": "1203028",
                        "razaoSocial": "LOJAS QUERO QUERO S A",
                        "id": 70415,
                        "createdAt": "2026-09-25T16:00:06.893326",
                        "clienteId": 139109,
                        "pedido": "2052974710",
                        "dataPedido": "2026-09-16T00:00:00",
                        "previsaoEntrega": "2026-09-18T00:00:00",
                        "previsaoEntregaAjustada": "2026-09-28T00:00:00",
                        "statusPrazo": 1,
                        "statusEntrega": 3
                    },
                    {
                        "tag": "Todos",
                        "codigoCliente": "1203028",
                        "razaoSocial": "LOJAS QUERO QUERO S A",
                        "id": 70416,
                        "createdAt": "2026-09-25T16:00:06.8933266",
                        "clienteId": 139109,
                        "pedido": "2052974710",
                        "dataPedido": "2026-09-16T00:00:00",
                        "previsaoEntrega": "2026-09-18T00:00:00",
                        "previsaoEntregaAjustada": "2026-09-28T00:00:00",
                        "statusPrazo": 1,
                        "statusEntrega": 3
                    },
                    {
                        "tag": "Todos",
                        "codigoCliente": "1438329",
                        "razaoSocial": "LOJAS QUERO QUERO S A",
                        "id": 70417,
                        "createdAt": "2026-09-25T16:00:06.8933273",
                        "clienteId": 137742,
                        "pedido": "2052974725",
                        "dataPedido": "2026-09-16T00:00:00",
                        "previsaoEntrega": "2026-09-18T00:00:00",
                        "previsaoEntregaAjustada": "2026-09-28T00:00:00",
                        "statusPrazo": 1,
                        "statusEntrega": 3
                    },
                    {
                        "tag": "Todos",
                        "codigoCliente": "1438329",
                        "razaoSocial": "LOJAS QUERO QUERO S A",
                        "id": 70418,
                        "createdAt": "2026-09-25T16:00:06.8933279",
                        "clienteId": 137742,
                        "pedido": "2052974725",
                        "dataPedido": "2026-09-16T00:00:00",
                        "previsaoEntrega": "2026-09-18T00:00:00",
                        "previsaoEntregaAjustada": "2026-09-28T00:00:00",
                        "statusPrazo": 1,
                        "statusEntrega": 3
                    },
                    {
                        "tag": "Todos",
                        "codigoCliente": "1438329",
                        "razaoSocial": "LOJAS QUERO QUERO S A",
                        "id": 70419,
                        "createdAt": "2026-09-25T16:00:06.8933286",
                        "clienteId": 137742,
                        "pedido": "2052974725",
                        "dataPedido": "2026-09-16T00:00:00",
                        "previsaoEntrega": "2026-09-18T00:00:00",
                        "previsaoEntregaAjustada": "2026-09-28T00:00:00",
                        "statusPrazo": 1,
                        "statusEntrega": 3
                    },
                    {
                        "tag": "Todos",
                        "codigoCliente": "1438329",
                        "razaoSocial": "LOJAS QUERO QUERO S A",
                        "id": 70420,
                        "createdAt": "2026-09-25T16:00:06.8933291",
                        "clienteId": 137742,
                        "pedido": "2052974730",
                        "dataPedido": "2026-09-16T00:00:00",
                        "previsaoEntrega": "2026-09-18T00:00:00",
                        "previsaoEntregaAjustada": "2026-09-28T00:00:00",
                        "statusPrazo": 1,
                        "statusEntrega": 3
                    },
                    {
                        "tag": "Todos",
                        "codigoCliente": "1438329",
                        "razaoSocial": "LOJAS QUERO QUERO S A",
                        "id": 70421,
                        "createdAt": "2026-09-25T16:00:06.8933299",
                        "clienteId": 137742,
                        "pedido": "2052974730",
                        "dataPedido": "2026-09-16T00:00:00",
                        "previsaoEntrega": "2026-09-18T00:00:00",
                        "previsaoEntregaAjustada": "2026-09-28T00:00:00",
                        "statusPrazo": 1,
                        "statusEntrega": 3
                    },
                    {
                        "tag": "Todos",
                        "codigoCliente": "1438329",
                        "razaoSocial": "LOJAS QUERO QUERO S A",
                        "id": 70422,
                        "createdAt": "2026-09-25T16:00:06.8933304",
                        "clienteId": 137742,
                        "pedido": "2052974730",
                        "dataPedido": "2026-09-16T00:00:00",
                        "previsaoEntrega": "2026-09-18T00:00:00",
                        "previsaoEntregaAjustada": "2026-09-28T00:00:00",
                        "statusPrazo": 1,
                        "statusEntrega": 3
                    },
                    {
                        "tag": "Todos",
                        "codigoCliente": "1438329",
                        "razaoSocial": "LOJAS QUERO QUERO S A",
                        "id": 70423,
                        "createdAt": "2026-09-25T16:00:06.8933309",
                        "clienteId": 137742,
                        "pedido": "2052941756",
                        "dataPedido": "2026-09-14T00:00:00",
                        "previsaoEntrega": "2026-09-17T00:00:00",
                        "previsaoEntregaAjustada": "2026-09-26T00:00:00",
                        "statusPrazo": 1,
                        "statusEntrega": 3
                    },
                    {
                        "tag": "Todos",
                        "codigoCliente": "1438329",
                        "razaoSocial": "LOJAS QUERO QUERO S A",
                        "id": 70424,
                        "createdAt": "2026-09-25T16:00:06.8933315",
                        "clienteId": 137742,
                        "pedido": "2052941756",
                        "dataPedido": "2026-09-14T00:00:00",
                        "previsaoEntrega": "2026-09-17T00:00:00",
                        "previsaoEntregaAjustada": "2026-09-26T00:00:00",
                        "statusPrazo": 1,
                        "statusEntrega": 3
                    },
                    {
                        "tag": "Todos",
                        "codigoCliente": "1438329",
                        "razaoSocial": "LOJAS QUERO QUERO S A",
                        "id": 70425,
                        "createdAt": "2026-09-25T16:00:06.8933322",
                        "clienteId": 137742,
                        "pedido": "2052941756",
                        "dataPedido": "2026-09-14T00:00:00",
                        "previsaoEntrega": "2026-09-17T00:00:00",
                        "previsaoEntregaAjustada": "2026-09-26T00:00:00",
                        "statusPrazo": 1,
                        "statusEntrega": 3
                    },
                    {
                        "tag": "Todos",
                        "codigoCliente": "1053239",
                        "razaoSocial": "LOJAS QUERO QUERO S A",
                        "id": 70501,
                        "createdAt": "2026-09-25T16:00:06.8933772",
                        "clienteId": 26680,
                        "pedido": "2052981095",
                        "dataPedido": "2026-09-17T00:00:00",
                        "previsaoEntrega": "2026-09-24T00:00:00",
                        "previsaoEntregaAjustada": "2026-09-28T00:00:00",
                        "statusPrazo": 1,
                        "statusEntrega": 3
                    },
                    {
                        "tag": "Todos",
                        "codigoCliente": "1053239",
                        "razaoSocial": "LOJAS QUERO QUERO S A",
                        "id": 70502,
                        "createdAt": "2026-09-25T16:00:06.8933778",
                        "clienteId": 26680,
                        "pedido": "2052981095",
                        "dataPedido": "2026-09-17T00:00:00",
                        "previsaoEntrega": "2026-09-24T00:00:00",
                        "previsaoEntregaAjustada": "2026-09-28T00:00:00",
                        "statusPrazo": 1,
                        "statusEntrega": 3
                    },
                    {
                        "tag": "Todos",
                        "codigoCliente": "1053239",
                        "razaoSocial": "LOJAS QUERO QUERO S A",
                        "id": 70503,
                        "createdAt": "2026-09-25T16:00:06.8933784",
                        "clienteId": 26680,
                        "pedido": "2052981095",
                        "dataPedido": "2026-09-17T00:00:00",
                        "previsaoEntrega": "2026-09-24T00:00:00",
                        "previsaoEntregaAjustada": "2026-09-28T00:00:00",
                        "statusPrazo": 1,
                        "statusEntrega": 3
                    },
                    {
                        "tag": "Todos",
                        "codigoCliente": "1053239",
                        "razaoSocial": "LOJAS QUERO QUERO S A",
                        "id": 70504,
                        "createdAt": "2026-09-25T16:00:06.8933789",
                        "clienteId": 26680,
                        "pedido": "2052981078",
                        "dataPedido": "2026-09-17T00:00:00",
                        "previsaoEntrega": "2026-09-21T00:00:00",
                        "previsaoEntregaAjustada": "2026-09-25T00:00:00",
                        "statusPrazo": 1,
                        "statusEntrega": 3
                    },
                    {
                        "tag": "Todos",
                        "codigoCliente": "1053239",
                        "razaoSocial": "LOJAS QUERO QUERO S A",
                        "id": 70505,
                        "createdAt": "2026-09-25T16:00:06.8933794",
                        "clienteId": 26680,
                        "pedido": "2052981078",
                        "dataPedido": "2026-09-17T00:00:00",
                        "previsaoEntrega": "2026-09-21T00:00:00",
                        "previsaoEntregaAjustada": "2026-09-25T00:00:00",
                        "statusPrazo": 1,
                        "statusEntrega": 3
                    },
                    {
                        "tag": "Todos",
                        "codigoCliente": "1053239",
                        "razaoSocial": "LOJAS QUERO QUERO S A",
                        "id": 70506,
                        "createdAt": "2026-09-25T16:00:06.89338",
                        "clienteId": 26680,
                        "pedido": "2052981078",
                        "dataPedido": "2026-09-17T00:00:00",
                        "previsaoEntrega": "2026-09-21T00:00:00",
                        "previsaoEntregaAjustada": "2026-09-25T00:00:00",
                        "statusPrazo": 1,
                        "statusEntrega": 3
                    },
                    {
                        "tag": "Todos",
                        "codigoCliente": "1053239",
                        "razaoSocial": "LOJAS QUERO QUERO S A",
                        "id": 70507,
                        "createdAt": "2026-09-25T16:00:06.8933805",
                        "clienteId": 26680,
                        "pedido": "2053073377",
                        "dataPedido": "2026-09-24T00:00:00",
                        "previsaoEntrega": "2026-10-01T00:00:00",
                        "previsaoEntregaAjustada": "2026-10-01T00:00:00",
                        "statusPrazo": 1,
                        "statusEntrega": 2
                    },
                    {
                        "tag": "Todos",
                        "codigoCliente": "1053239",
                        "razaoSocial": "LOJAS QUERO QUERO S A",
                        "id": 70508,
                        "createdAt": "2026-09-25T16:00:06.8933812",
                        "clienteId": 26680,
                        "pedido": "2053073377",
                        "dataPedido": "2026-09-24T00:00:00",
                        "previsaoEntrega": "2026-10-01T00:00:00",
                        "previsaoEntregaAjustada": "2026-10-01T00:00:00",
                        "statusPrazo": 1,
                        "statusEntrega": 2
                    },
                    {
                        "tag": "Todos",
                        "codigoCliente": "1053239",
                        "razaoSocial": "LOJAS QUERO QUERO S A",
                        "id": 70509,
                        "createdAt": "2026-09-25T16:00:06.8933818",
                        "clienteId": 26680,
                        "pedido": "2053073377",
                        "dataPedido": "2026-09-24T00:00:00",
                        "previsaoEntrega": "2026-10-01T00:00:00",
                        "previsaoEntregaAjustada": "2026-10-01T00:00:00",
                        "statusPrazo": 1,
                        "statusEntrega": 2
                    },
                    {
                        "tag": "Todos",
                        "codigoCliente": "1053239",
                        "razaoSocial": "LOJAS QUERO QUERO S A",
                        "id": 70510,
                        "createdAt": "2026-09-25T16:00:06.8933824",
                        "clienteId": 26680,
                        "pedido": "2053003286",
                        "dataPedido": "2026-09-18T00:00:00",
                        "previsaoEntrega": "2026-09-23T00:00:00",
                        "previsaoEntregaAjustada": "2026-09-28T00:00:00",
                        "statusPrazo": 1,
                        "statusEntrega": 3
                    },
                    {
                        "tag": "Todos",
                        "codigoCliente": "1053239",
                        "razaoSocial": "LOJAS QUERO QUERO S A",
                        "id": 70511,
                        "createdAt": "2026-09-25T16:00:06.893383",
                        "clienteId": 26680,
                        "pedido": "2053003286",
                        "dataPedido": "2026-09-18T00:00:00",
                        "previsaoEntrega": "2026-09-23T00:00:00",
                        "previsaoEntregaAjustada": "2026-09-28T00:00:00",
                        "statusPrazo": 1,
                        "statusEntrega": 3
                    },
                    {
                        "tag": "Todos",
                        "codigoCliente": "1053239",
                        "razaoSocial": "LOJAS QUERO QUERO S A",
                        "id": 70512,
                        "createdAt": "2026-09-25T16:00:06.8933836",
                        "clienteId": 26680,
                        "pedido": "2053003286",
                        "dataPedido": "2026-09-18T00:00:00",
                        "previsaoEntrega": "2026-09-23T00:00:00",
                        "previsaoEntregaAjustada": "2026-09-28T00:00:00",
                        "statusPrazo": 1,
                        "statusEntrega": 3
                    },
                    {
                        "tag": "Todos",
                        "codigoCliente": "1053239",
                        "razaoSocial": "LOJAS QUERO QUERO S A",
                        "id": 70513,
                        "createdAt": "2026-09-25T16:00:06.8933842",
                        "clienteId": 26680,
                        "pedido": "2053010067",
                        "dataPedido": "2026-09-18T00:00:00",
                        "previsaoEntrega": "2026-09-24T00:00:00",
                        "previsaoEntregaAjustada": "2026-09-28T00:00:00",
                        "statusPrazo": 1,
                        "statusEntrega": 3
                    },
                    {
                        "tag": "Todos",
                        "codigoCliente": "1053239",
                        "razaoSocial": "LOJAS QUERO QUERO S A",
                        "id": 70514,
                        "createdAt": "2026-09-25T16:00:06.8933847",
                        "clienteId": 26680,
                        "pedido": "2053010067",
                        "dataPedido": "2026-09-18T00:00:00",
                        "previsaoEntrega": "2026-09-24T00:00:00",
                        "previsaoEntregaAjustada": "2026-09-28T00:00:00",
                        "statusPrazo": 1,
                        "statusEntrega": 3
                    },
                    {
                        "tag": "Todos",
                        "codigoCliente": "1053239",
                        "razaoSocial": "LOJAS QUERO QUERO S A",
                        "id": 70515,
                        "createdAt": "2026-09-25T16:00:06.8933852",
                        "clienteId": 26680,
                        "pedido": "2053010067",
                        "dataPedido": "2026-09-18T00:00:00",
                        "previsaoEntrega": "2026-09-24T00:00:00",
                        "previsaoEntregaAjustada": "2026-09-28T00:00:00",
                        "statusPrazo": 1,
                        "statusEntrega": 3
                    },
                    {
                        "tag": "Todos",
                        "codigoCliente": "1144268",
                        "razaoSocial": "LOJAS QUERO QUERO S A",
                        "id": 70838,
                        "createdAt": "2026-09-25T16:00:06.8935753",
                        "clienteId": 7145,
                        "pedido": "2052998294",
                        "dataPedido": "2026-09-18T00:00:00",
                        "previsaoEntrega": "2026-09-23T00:00:00",
                        "previsaoEntregaAjustada": "2026-09-28T00:00:00",
                        "statusPrazo": 1,
                        "statusEntrega": 3
                    },
                    {
                        "tag": "Todos",
                        "codigoCliente": "1144268",
                        "razaoSocial": "LOJAS QUERO QUERO S A",
                        "id": 70839,
                        "createdAt": "2026-09-25T16:00:06.8935758",
                        "clienteId": 7145,
                        "pedido": "2052998294",
                        "dataPedido": "2026-09-18T00:00:00",
                        "previsaoEntrega": "2026-09-23T00:00:00",
                        "previsaoEntregaAjustada": "2026-09-28T00:00:00",
                        "statusPrazo": 1,
                        "statusEntrega": 3
                    },
                    {
                        "tag": "Todos",
                        "codigoCliente": "1144268",
                        "razaoSocial": "LOJAS QUERO QUERO S A",
                        "id": 70840,
                        "createdAt": "2026-09-25T16:00:06.8935763",
                        "clienteId": 7145,
                        "pedido": "2052998294",
                        "dataPedido": "2026-09-18T00:00:00",
                        "previsaoEntrega": "2026-09-23T00:00:00",
                        "previsaoEntregaAjustada": "2026-09-28T00:00:00",
                        "statusPrazo": 1,
                        "statusEntrega": 3
                    },
                    {
                        "tag": "Todos",
                        "codigoCliente": "1133990",
                        "razaoSocial": "LOJAS QUERO QUERO S A",
                        "id": 71353,
                        "createdAt": "2026-09-25T16:00:06.8938884",
                        "clienteId": 131403,
                        "pedido": "2053010117",
                        "dataPedido": "2026-09-18T00:00:00",
                        "previsaoEntrega": "2026-09-24T00:00:00",
                        "previsaoEntregaAjustada": "2026-09-28T00:00:00",
                        "statusPrazo": 1,
                        "statusEntrega": 2
                    },
                    {
                        "tag": "Todos",
                        "codigoCliente": "1133990",
                        "razaoSocial": "LOJAS QUERO QUERO S A",
                        "id": 71354,
                        "createdAt": "2026-09-25T16:00:06.8938889",
                        "clienteId": 131403,
                        "pedido": "2053010117",
                        "dataPedido": "2026-09-18T00:00:00",
                        "previsaoEntrega": "2026-09-24T00:00:00",
                        "previsaoEntregaAjustada": "2026-09-28T00:00:00",
                        "statusPrazo": 1,
                        "statusEntrega": 2
                    },
                    {
                        "tag": "Todos",
                        "codigoCliente": "1133990",
                        "razaoSocial": "LOJAS QUERO QUERO S A",
                        "id": 71355,
                        "createdAt": "2026-09-25T16:00:06.8938896",
                        "clienteId": 131403,
                        "pedido": "2053010117",
                        "dataPedido": "2026-09-18T00:00:00",
                        "previsaoEntrega": "2026-09-24T00:00:00",
                        "previsaoEntregaAjustada": "2026-09-28T00:00:00",
                        "statusPrazo": 1,
                        "statusEntrega": 2
                    },
                    {
                        "tag": "Todos",
                        "codigoCliente": "1133990",
                        "razaoSocial": "LOJAS QUERO QUERO S A",
                        "id": 71356,
                        "createdAt": "2026-09-25T16:00:06.8938901",
                        "clienteId": 131403,
                        "pedido": "2053010127",
                        "dataPedido": "2026-09-18T00:00:00",
                        "previsaoEntrega": "2026-09-24T00:00:00",
                        "previsaoEntregaAjustada": "2026-09-28T00:00:00",
                        "statusPrazo": 1,
                        "statusEntrega": 3
                    },
                    {
                        "tag": "Todos",
                        "codigoCliente": "1133990",
                        "razaoSocial": "LOJAS QUERO QUERO S A",
                        "id": 71357,
                        "createdAt": "2026-09-25T16:00:06.8938907",
                        "clienteId": 131403,
                        "pedido": "2053010127",
                        "dataPedido": "2026-09-18T00:00:00",
                        "previsaoEntrega": "2026-09-24T00:00:00",
                        "previsaoEntregaAjustada": "2026-09-28T00:00:00",
                        "statusPrazo": 1,
                        "statusEntrega": 3
                    },
                    {
                        "tag": "Todos",
                        "codigoCliente": "1133990",
                        "razaoSocial": "LOJAS QUERO QUERO S A",
                        "id": 71358,
                        "createdAt": "2026-09-25T16:00:06.8938912",
                        "clienteId": 131403,
                        "pedido": "2053010127",
                        "dataPedido": "2026-09-18T00:00:00",
                        "previsaoEntrega": "2026-09-24T00:00:00",
                        "previsaoEntregaAjustada": "2026-09-28T00:00:00",
                        "statusPrazo": 1,
                        "statusEntrega": 3
                    },
                    {
                        "tag": "Todos",
                        "codigoCliente": "1140566",
                        "razaoSocial": "LOJAS QUERO QUERO S A",
                        "id": 71359,
                        "createdAt": "2026-09-25T16:00:06.8938917",
                        "clienteId": 135318,
                        "pedido": "2053010157",
                        "dataPedido": "2026-09-18T00:00:00",
                        "previsaoEntrega": "2026-09-24T00:00:00",
                        "previsaoEntregaAjustada": "2026-09-30T00:00:00",
                        "statusPrazo": 1,
                        "statusEntrega": 2
                    },
                    {
                        "tag": "Todos",
                        "codigoCliente": "1140566",
                        "razaoSocial": "LOJAS QUERO QUERO S A",
                        "id": 71360,
                        "createdAt": "2026-09-25T16:00:06.8938924",
                        "clienteId": 135318,
                        "pedido": "2053010157",
                        "dataPedido": "2026-09-18T00:00:00",
                        "previsaoEntrega": "2026-09-24T00:00:00",
                        "previsaoEntregaAjustada": "2026-09-30T00:00:00",
                        "statusPrazo": 1,
                        "statusEntrega": 2
                    },
                    {
                        "tag": "Todos",
                        "codigoCliente": "1140566",
                        "razaoSocial": "LOJAS QUERO QUERO S A",
                        "id": 71361,
                        "createdAt": "2026-09-25T16:00:06.893893",
                        "clienteId": 135318,
                        "pedido": "2053010157",
                        "dataPedido": "2026-09-18T00:00:00",
                        "previsaoEntrega": "2026-09-24T00:00:00",
                        "previsaoEntregaAjustada": "2026-09-30T00:00:00",
                        "statusPrazo": 1,
                        "statusEntrega": 2
                    },
                    {
                        "tag": "Todos",
                        "codigoCliente": "1549258",
                        "razaoSocial": "ORIOCILDO ROCHA MONTERO",
                        "id": 71716,
                        "createdAt": "2026-09-25T16:00:06.8941098",
                        "clienteId": 134573,
                        "pedido": "2053017162",
                        "dataPedido": "2026-09-21T00:00:00",
                        "previsaoEntrega": "2026-09-25T00:00:00",
                        "previsaoEntregaAjustada": "2026-10-08T00:00:00",
                        "statusPrazo": 1,
                        "statusEntrega": 3
                    },
                    {
                        "tag": "Todos",
                        "codigoCliente": "1549258",
                        "razaoSocial": "ORIOCILDO ROCHA MONTERO",
                        "id": 71717,
                        "createdAt": "2026-09-25T16:00:06.8941105",
                        "clienteId": 134573,
                        "pedido": "2053017162",
                        "dataPedido": "2026-09-21T00:00:00",
                        "previsaoEntrega": "2026-09-25T00:00:00",
                        "previsaoEntregaAjustada": "2026-10-08T00:00:00",
                        "statusPrazo": 1,
                        "statusEntrega": 3
                    },
                    {
                        "tag": "Todos",
                        "codigoCliente": "1549258",
                        "razaoSocial": "ORIOCILDO ROCHA MONTERO",
                        "id": 71718,
                        "createdAt": "2026-09-25T16:00:06.8941111",
                        "clienteId": 134573,
                        "pedido": "2053017162",
                        "dataPedido": "2026-09-21T00:00:00",
                        "previsaoEntrega": "2026-09-25T00:00:00",
                        "previsaoEntregaAjustada": "2026-10-08T00:00:00",
                        "statusPrazo": 1,
                        "statusEntrega": 3
                    },
                    {
                        "tag": "Todos",
                        "codigoCliente": "1549258",
                        "razaoSocial": "ORIOCILDO ROCHA MONTERO",
                        "id": 71719,
                        "createdAt": "2026-09-25T16:00:06.8941117",
                        "clienteId": 134573,
                        "pedido": "2052997570",
                        "dataPedido": "2026-09-18T00:00:00",
                        "previsaoEntrega": "2026-09-24T00:00:00",
                        "previsaoEntregaAjustada": "2026-10-06T00:00:00",
                        "statusPrazo": 1,
                        "statusEntrega": 3
                    },
                    {
                        "tag": "Todos",
                        "codigoCliente": "1549258",
                        "razaoSocial": "ORIOCILDO ROCHA MONTERO",
                        "id": 71720,
                        "createdAt": "2026-09-25T16:00:06.8941122",
                        "clienteId": 134573,
                        "pedido": "2052997570",
                        "dataPedido": "2026-09-18T00:00:00",
                        "previsaoEntrega": "2026-09-24T00:00:00",
                        "previsaoEntregaAjustada": "2026-10-06T00:00:00",
                        "statusPrazo": 1,
                        "statusEntrega": 3
                    },
                    {
                        "tag": "Todos",
                        "codigoCliente": "1549258",
                        "razaoSocial": "ORIOCILDO ROCHA MONTERO",
                        "id": 71721,
                        "createdAt": "2026-09-25T16:00:06.8941127",
                        "clienteId": 134573,
                        "pedido": "2052997570",
                        "dataPedido": "2026-09-18T00:00:00",
                        "previsaoEntrega": "2026-09-24T00:00:00",
                        "previsaoEntregaAjustada": "2026-10-06T00:00:00",
                        "statusPrazo": 1,
                        "statusEntrega": 3
                    },
                    {
                        "tag": "Todos",
                        "codigoCliente": "1549258",
                        "razaoSocial": "ORIOCILDO ROCHA MONTERO",
                        "id": 71722,
                        "createdAt": "2026-09-25T16:00:06.8941135",
                        "clienteId": 134573,
                        "pedido": "2053055237",
                        "dataPedido": "2026-09-23T00:00:00",
                        "previsaoEntrega": "2026-09-28T00:00:00",
                        "previsaoEntregaAjustada": "2026-10-08T00:00:00",
                        "statusPrazo": 1,
                        "statusEntrega": 3
                    },
                    {
                        "tag": "Todos",
                        "codigoCliente": "1549258",
                        "razaoSocial": "ORIOCILDO ROCHA MONTERO",
                        "id": 71723,
                        "createdAt": "2026-09-25T16:00:06.8941141",
                        "clienteId": 134573,
                        "pedido": "2053055237",
                        "dataPedido": "2026-09-23T00:00:00",
                        "previsaoEntrega": "2026-09-28T00:00:00",
                        "previsaoEntregaAjustada": "2026-10-08T00:00:00",
                        "statusPrazo": 1,
                        "statusEntrega": 3
                    },
                    {
                        "tag": "Todos",
                        "codigoCliente": "1549258",
                        "razaoSocial": "ORIOCILDO ROCHA MONTERO",
                        "id": 71724,
                        "createdAt": "2026-09-25T16:00:06.8941148",
                        "clienteId": 134573,
                        "pedido": "2053055237",
                        "dataPedido": "2026-09-23T00:00:00",
                        "previsaoEntrega": "2026-09-28T00:00:00",
                        "previsaoEntregaAjustada": "2026-10-08T00:00:00",
                        "statusPrazo": 1,
                        "statusEntrega": 3
                    },
                    {
                        "tag": "Todos",
                        "codigoCliente": "1056203",
                        "razaoSocial": "LOJAS BECKER LTDA",
                        "id": 71944,
                        "createdAt": "2026-09-25T16:00:06.8942524",
                        "clienteId": 49594,
                        "pedido": "2053023395",
                        "dataPedido": "2026-09-21T00:00:00",
                        "previsaoEntrega": "2026-09-28T00:00:00",
                        "previsaoEntregaAjustada": "2026-09-28T00:00:00",
                        "statusPrazo": 1,
                        "statusEntrega": 3
                    },
                    {
                        "tag": "Todos",
                        "codigoCliente": "1056203",
                        "razaoSocial": "LOJAS BECKER LTDA",
                        "id": 71945,
                        "createdAt": "2026-09-25T16:00:06.894253",
                        "clienteId": 49594,
                        "pedido": "2053023395",
                        "dataPedido": "2026-09-21T00:00:00",
                        "previsaoEntrega": "2026-09-28T00:00:00",
                        "previsaoEntregaAjustada": "2026-09-28T00:00:00",
                        "statusPrazo": 1,
                        "statusEntrega": 3
                    },
                    {
                        "tag": "Todos",
                        "codigoCliente": "1056203",
                        "razaoSocial": "LOJAS BECKER LTDA",
                        "id": 71946,
                        "createdAt": "2026-09-25T16:00:06.8942536",
                        "clienteId": 49594,
                        "pedido": "2053023395",
                        "dataPedido": "2026-09-21T00:00:00",
                        "previsaoEntrega": "2026-09-28T00:00:00",
                        "previsaoEntregaAjustada": "2026-09-28T00:00:00",
                        "statusPrazo": 1,
                        "statusEntrega": 3
                    },
                    {
                        "tag": "Todos",
                        "codigoCliente": "1056203",
                        "razaoSocial": "LOJAS BECKER LTDA",
                        "id": 71947,
                        "createdAt": "2026-09-25T16:00:06.8942542",
                        "clienteId": 49594,
                        "pedido": "2053023395",
                        "dataPedido": "2026-09-21T00:00:00",
                        "previsaoEntrega": "2026-09-28T00:00:00",
                        "previsaoEntregaAjustada": "2026-09-28T00:00:00",
                        "statusPrazo": 1,
                        "statusEntrega": 3
                    },
                    {
                        "tag": "Todos",
                        "codigoCliente": "1056203",
                        "razaoSocial": "LOJAS BECKER LTDA",
                        "id": 71948,
                        "createdAt": "2026-09-25T16:00:06.8942548",
                        "clienteId": 49594,
                        "pedido": "2053023395",
                        "dataPedido": "2026-09-21T00:00:00",
                        "previsaoEntrega": "2026-09-28T00:00:00",
                        "previsaoEntregaAjustada": "2026-09-28T00:00:00",
                        "statusPrazo": 1,
                        "statusEntrega": 3
                    },
                    {
                        "tag": "Todos",
                        "codigoCliente": "1056203",
                        "razaoSocial": "LOJAS BECKER LTDA",
                        "id": 71949,
                        "createdAt": "2026-09-25T16:00:06.8942555",
                        "clienteId": 49594,
                        "pedido": "2053023395",
                        "dataPedido": "2026-09-21T00:00:00",
                        "previsaoEntrega": "2026-09-28T00:00:00",
                        "previsaoEntregaAjustada": "2026-09-28T00:00:00",
                        "statusPrazo": 1,
                        "statusEntrega": 3
                    },
                    {
                        "tag": "Todos",
                        "codigoCliente": "1127641",
                        "razaoSocial": "LOJAS BECKER LTDA",
                        "id": 72033,
                        "createdAt": "2026-09-25T16:00:06.8943045",
                        "clienteId": 131398,
                        "pedido": "2053025492",
                        "dataPedido": "2026-09-21T00:00:00",
                        "previsaoEntrega": "2026-09-28T00:00:00",
                        "previsaoEntregaAjustada": "2026-09-28T00:00:00",
                        "statusPrazo": 1,
                        "statusEntrega": 3
                    },
                    {
                        "tag": "Todos",
                        "codigoCliente": "1127641",
                        "razaoSocial": "LOJAS BECKER LTDA",
                        "id": 72034,
                        "createdAt": "2026-09-25T16:00:06.8943051",
                        "clienteId": 131398,
                        "pedido": "2053025492",
                        "dataPedido": "2026-09-21T00:00:00",
                        "previsaoEntrega": "2026-09-28T00:00:00",
                        "previsaoEntregaAjustada": "2026-09-28T00:00:00",
                        "statusPrazo": 1,
                        "statusEntrega": 3
                    },
                    {
                        "tag": "Todos",
                        "codigoCliente": "1127641",
                        "razaoSocial": "LOJAS BECKER LTDA",
                        "id": 72035,
                        "createdAt": "2026-09-25T16:00:06.8943056",
                        "clienteId": 131398,
                        "pedido": "2053025492",
                        "dataPedido": "2026-09-21T00:00:00",
                        "previsaoEntrega": "2026-09-28T00:00:00",
                        "previsaoEntregaAjustada": "2026-09-28T00:00:00",
                        "statusPrazo": 1,
                        "statusEntrega": 3
                    },
                    {
                        "tag": "Todos",
                        "codigoCliente": "1354406",
                        "razaoSocial": "LOJAS QUERO QUERO S A",
                        "id": 72162,
                        "createdAt": "2026-09-25T16:00:06.8943802",
                        "clienteId": 131385,
                        "pedido": "2052969908",
                        "dataPedido": "2026-09-16T00:00:00",
                        "previsaoEntrega": "2026-09-21T00:00:00",
                        "previsaoEntregaAjustada": "2026-09-25T00:00:00",
                        "statusPrazo": 1,
                        "statusEntrega": 3
                    },
                    {
                        "tag": "Todos",
                        "codigoCliente": "1354406",
                        "razaoSocial": "LOJAS QUERO QUERO S A",
                        "id": 72163,
                        "createdAt": "2026-09-25T16:00:06.8943807",
                        "clienteId": 131385,
                        "pedido": "2052969908",
                        "dataPedido": "2026-09-16T00:00:00",
                        "previsaoEntrega": "2026-09-21T00:00:00",
                        "previsaoEntregaAjustada": "2026-09-25T00:00:00",
                        "statusPrazo": 1,
                        "statusEntrega": 3
                    },
                    {
                        "tag": "Todos",
                        "codigoCliente": "1354406",
                        "razaoSocial": "LOJAS QUERO QUERO S A",
                        "id": 72164,
                        "createdAt": "2026-09-25T16:00:06.8943813",
                        "clienteId": 131385,
                        "pedido": "2052969908",
                        "dataPedido": "2026-09-16T00:00:00",
                        "previsaoEntrega": "2026-09-21T00:00:00",
                        "previsaoEntregaAjustada": "2026-09-25T00:00:00",
                        "statusPrazo": 1,
                        "statusEntrega": 3
                    },
                    {
                        "tag": "Todos",
                        "codigoCliente": "1354406",
                        "razaoSocial": "LOJAS QUERO QUERO S A",
                        "id": 72165,
                        "createdAt": "2026-09-25T16:00:06.8943818",
                        "clienteId": 131385,
                        "pedido": "2053030510",
                        "dataPedido": "2026-09-21T00:00:00",
                        "previsaoEntrega": "2026-09-24T00:00:00",
                        "previsaoEntregaAjustada": "2026-09-28T00:00:00",
                        "statusPrazo": 1,
                        "statusEntrega": 3
                    },
                    {
                        "tag": "Todos",
                        "codigoCliente": "1354406",
                        "razaoSocial": "LOJAS QUERO QUERO S A",
                        "id": 72166,
                        "createdAt": "2026-09-25T16:00:06.8943823",
                        "clienteId": 131385,
                        "pedido": "2053030510",
                        "dataPedido": "2026-09-21T00:00:00",
                        "previsaoEntrega": "2026-09-24T00:00:00",
                        "previsaoEntregaAjustada": "2026-09-28T00:00:00",
                        "statusPrazo": 1,
                        "statusEntrega": 3
                    },
                    {
                        "tag": "Todos",
                        "codigoCliente": "1354406",
                        "razaoSocial": "LOJAS QUERO QUERO S A",
                        "id": 72167,
                        "createdAt": "2026-09-25T16:00:06.894383",
                        "clienteId": 131385,
                        "pedido": "2053030510",
                        "dataPedido": "2026-09-21T00:00:00",
                        "previsaoEntrega": "2026-09-24T00:00:00",
                        "previsaoEntregaAjustada": "2026-09-28T00:00:00",
                        "statusPrazo": 1,
                        "statusEntrega": 3
                    },
                    {
                        "tag": "Todos",
                        "codigoCliente": "1354406",
                        "razaoSocial": "LOJAS QUERO QUERO S A",
                        "id": 72168,
                        "createdAt": "2026-09-25T16:00:06.8943835",
                        "clienteId": 131385,
                        "pedido": "2052948913",
                        "dataPedido": "2026-09-15T00:00:00",
                        "previsaoEntrega": "2026-09-21T00:00:00",
                        "previsaoEntregaAjustada": "2026-09-25T00:00:00",
                        "statusPrazo": 1,
                        "statusEntrega": 3
                    },
                    {
                        "tag": "Todos",
                        "codigoCliente": "1354406",
                        "razaoSocial": "LOJAS QUERO QUERO S A",
                        "id": 72169,
                        "createdAt": "2026-09-25T16:00:06.894384",
                        "clienteId": 131385,
                        "pedido": "2052948913",
                        "dataPedido": "2026-09-15T00:00:00",
                        "previsaoEntrega": "2026-09-21T00:00:00",
                        "previsaoEntregaAjustada": "2026-09-25T00:00:00",
                        "statusPrazo": 1,
                        "statusEntrega": 3
                    },
                    {
                        "tag": "Todos",
                        "codigoCliente": "1354406",
                        "razaoSocial": "LOJAS QUERO QUERO S A",
                        "id": 72170,
                        "createdAt": "2026-09-25T16:00:06.8943845",
                        "clienteId": 131385,
                        "pedido": "2052948913",
                        "dataPedido": "2026-09-15T00:00:00",
                        "previsaoEntrega": "2026-09-21T00:00:00",
                        "previsaoEntregaAjustada": "2026-09-25T00:00:00",
                        "statusPrazo": 1,
                        "statusEntrega": 3
                    },
                    {
                        "tag": "Todos",
                        "codigoCliente": "1354406",
                        "razaoSocial": "LOJAS QUERO QUERO S A",
                        "id": 72171,
                        "createdAt": "2026-09-25T16:00:06.894385",
                        "clienteId": 131385,
                        "pedido": "2052998383",
                        "dataPedido": "2026-09-18T00:00:00",
                        "previsaoEntrega": "2026-09-25T00:00:00",
                        "previsaoEntregaAjustada": "2026-09-25T00:00:00",
                        "statusPrazo": 1,
                        "statusEntrega": 2
                    },
                    {
                        "tag": "Todos",
                        "codigoCliente": "1354406",
                        "razaoSocial": "LOJAS QUERO QUERO S A",
                        "id": 72172,
                        "createdAt": "2026-09-25T16:00:06.8943856",
                        "clienteId": 131385,
                        "pedido": "2052998383",
                        "dataPedido": "2026-09-18T00:00:00",
                        "previsaoEntrega": "2026-09-25T00:00:00",
                        "previsaoEntregaAjustada": "2026-09-25T00:00:00",
                        "statusPrazo": 1,
                        "statusEntrega": 2
                    },
                    {
                        "tag": "Todos",
                        "codigoCliente": "1354406",
                        "razaoSocial": "LOJAS QUERO QUERO S A",
                        "id": 72173,
                        "createdAt": "2026-09-25T16:00:06.8943861",
                        "clienteId": 131385,
                        "pedido": "2052998383",
                        "dataPedido": "2026-09-18T00:00:00",
                        "previsaoEntrega": "2026-09-25T00:00:00",
                        "previsaoEntregaAjustada": "2026-09-25T00:00:00",
                        "statusPrazo": 1,
                        "statusEntrega": 2
                    },
                    {
                        "tag": "Todos",
                        "codigoCliente": "1262528",
                        "razaoSocial": "LOJAS BECKER LTDA",
                        "id": 75398,
                        "createdAt": "2026-09-25T16:00:06.902283",
                        "clienteId": 27306,
                        "pedido": "2053070918",
                        "dataPedido": "2026-09-24T00:00:00",
                        "previsaoEntrega": "2026-09-29T00:00:00",
                        "previsaoEntregaAjustada": "2026-09-29T00:00:00",
                        "statusPrazo": 1,
                        "statusEntrega": 2
                    },
                    {
                        "tag": "Todos",
                        "codigoCliente": "1262528",
                        "razaoSocial": "LOJAS BECKER LTDA",
                        "id": 75399,
                        "createdAt": "2026-09-25T16:00:06.9022837",
                        "clienteId": 27306,
                        "pedido": "2053070918",
                        "dataPedido": "2026-09-24T00:00:00",
                        "previsaoEntrega": "2026-09-29T00:00:00",
                        "previsaoEntregaAjustada": "2026-09-29T00:00:00",
                        "statusPrazo": 1,
                        "statusEntrega": 2
                    },
                    {
                        "tag": "Todos",
                        "codigoCliente": "1262528",
                        "razaoSocial": "LOJAS BECKER LTDA",
                        "id": 75400,
                        "createdAt": "2026-09-25T16:00:06.9022843",
                        "clienteId": 27306,
                        "pedido": "2053070918",
                        "dataPedido": "2026-09-24T00:00:00",
                        "previsaoEntrega": "2026-09-29T00:00:00",
                        "previsaoEntregaAjustada": "2026-09-29T00:00:00",
                        "statusPrazo": 1,
                        "statusEntrega": 2
                    },
                    {
                        "tag": "Todos",
                        "codigoCliente": "1262528",
                        "razaoSocial": "LOJAS BECKER LTDA",
                        "id": 75401,
                        "createdAt": "2026-09-25T16:00:06.902285",
                        "clienteId": 27306,
                        "pedido": "2053070918",
                        "dataPedido": "2026-09-24T00:00:00",
                        "previsaoEntrega": "2026-09-29T00:00:00",
                        "previsaoEntregaAjustada": "2026-09-29T00:00:00",
                        "statusPrazo": 1,
                        "statusEntrega": 2
                    },
                    {
                        "tag": "Todos",
                        "codigoCliente": "1478679",
                        "razaoSocial": "LOJAS QUERO QUERO S A",
                        "id": 76135,
                        "createdAt": "2026-09-25T16:00:06.9027181",
                        "clienteId": 131390,
                        "pedido": "2053050561",
                        "dataPedido": "2026-09-22T00:00:00",
                        "previsaoEntrega": "2026-09-30T00:00:00",
                        "previsaoEntregaAjustada": "2026-09-30T00:00:00",
                        "statusPrazo": 1,
                        "statusEntrega": 2
                    },
                    {
                        "tag": "Todos",
                        "codigoCliente": "1478679",
                        "razaoSocial": "LOJAS QUERO QUERO S A",
                        "id": 76136,
                        "createdAt": "2026-09-25T16:00:06.9027186",
                        "clienteId": 131390,
                        "pedido": "2053050561",
                        "dataPedido": "2026-09-22T00:00:00",
                        "previsaoEntrega": "2026-09-30T00:00:00",
                        "previsaoEntregaAjustada": "2026-09-30T00:00:00",
                        "statusPrazo": 1,
                        "statusEntrega": 2
                    },
                    {
                        "tag": "Todos",
                        "codigoCliente": "1478679",
                        "razaoSocial": "LOJAS QUERO QUERO S A",
                        "id": 76137,
                        "createdAt": "2026-09-25T16:00:06.9027192",
                        "clienteId": 131390,
                        "pedido": "2053050561",
                        "dataPedido": "2026-09-22T00:00:00",
                        "previsaoEntrega": "2026-09-30T00:00:00",
                        "previsaoEntregaAjustada": "2026-09-30T00:00:00",
                        "statusPrazo": 1,
                        "statusEntrega": 2
                    },
                    {
                        "tag": "Todos",
                        "codigoCliente": "1478679",
                        "razaoSocial": "LOJAS QUERO QUERO S A",
                        "id": 76138,
                        "createdAt": "2026-09-25T16:00:06.9027197",
                        "clienteId": 131390,
                        "pedido": "2053010200",
                        "dataPedido": "2026-09-18T00:00:00",
                        "previsaoEntrega": "2026-09-25T00:00:00",
                        "previsaoEntregaAjustada": "2026-09-25T00:00:00",
                        "statusPrazo": 1,
                        "statusEntrega": 2
                    },
                    {
                        "tag": "Todos",
                        "codigoCliente": "1478679",
                        "razaoSocial": "LOJAS QUERO QUERO S A",
                        "id": 76139,
                        "createdAt": "2026-09-25T16:00:06.9027205",
                        "clienteId": 131390,
                        "pedido": "2053010200",
                        "dataPedido": "2026-09-18T00:00:00",
                        "previsaoEntrega": "2026-09-25T00:00:00",
                        "previsaoEntregaAjustada": "2026-09-25T00:00:00",
                        "statusPrazo": 1,
                        "statusEntrega": 2
                    },
                    {
                        "tag": "Todos",
                        "codigoCliente": "1478679",
                        "razaoSocial": "LOJAS QUERO QUERO S A",
                        "id": 76140,
                        "createdAt": "2026-09-25T16:00:06.902721",
                        "clienteId": 131390,
                        "pedido": "2053010200",
                        "dataPedido": "2026-09-18T00:00:00",
                        "previsaoEntrega": "2026-09-25T00:00:00",
                        "previsaoEntregaAjustada": "2026-09-25T00:00:00",
                        "statusPrazo": 1,
                        "statusEntrega": 2
                    },
                    {
                        "tag": "Todos",
                        "codigoCliente": "1478679",
                        "razaoSocial": "LOJAS QUERO QUERO S A",
                        "id": 76141,
                        "createdAt": "2026-09-25T16:00:06.9027215",
                        "clienteId": 131390,
                        "pedido": "2052970373",
                        "dataPedido": "2026-09-16T00:00:00",
                        "previsaoEntrega": "2026-09-18T00:00:00",
                        "previsaoEntregaAjustada": "2026-09-25T00:00:00",
                        "statusPrazo": 1,
                        "statusEntrega": 3
                    },
                    {
                        "tag": "Todos",
                        "codigoCliente": "1478679",
                        "razaoSocial": "LOJAS QUERO QUERO S A",
                        "id": 76142,
                        "createdAt": "2026-09-25T16:00:06.9027221",
                        "clienteId": 131390,
                        "pedido": "2052970373",
                        "dataPedido": "2026-09-16T00:00:00",
                        "previsaoEntrega": "2026-09-18T00:00:00",
                        "previsaoEntregaAjustada": "2026-09-25T00:00:00",
                        "statusPrazo": 1,
                        "statusEntrega": 3
                    },
                    {
                        "tag": "Todos",
                        "codigoCliente": "1478679",
                        "razaoSocial": "LOJAS QUERO QUERO S A",
                        "id": 76143,
                        "createdAt": "2026-09-25T16:00:06.9027228",
                        "clienteId": 131390,
                        "pedido": "2052970373",
                        "dataPedido": "2026-09-16T00:00:00",
                        "previsaoEntrega": "2026-09-18T00:00:00",
                        "previsaoEntregaAjustada": "2026-09-25T00:00:00",
                        "statusPrazo": 1,
                        "statusEntrega": 3
                    },
                    {
                        "tag": "Todos",
                        "codigoCliente": "1478679",
                        "razaoSocial": "LOJAS QUERO QUERO S A",
                        "id": 76144,
                        "createdAt": "2026-09-25T16:00:06.9027236",
                        "clienteId": 131390,
                        "pedido": "2052941318",
                        "dataPedido": "2026-09-14T00:00:00",
                        "previsaoEntrega": "2026-09-22T00:00:00",
                        "previsaoEntregaAjustada": "2026-09-26T00:00:00",
                        "statusPrazo": 1,
                        "statusEntrega": 3
                    },
                    {
                        "tag": "Todos",
                        "codigoCliente": "1478679",
                        "razaoSocial": "LOJAS QUERO QUERO S A",
                        "id": 76145,
                        "createdAt": "2026-09-25T16:00:06.9027242",
                        "clienteId": 131390,
                        "pedido": "2052941318",
                        "dataPedido": "2026-09-14T00:00:00",
                        "previsaoEntrega": "2026-09-22T00:00:00",
                        "previsaoEntregaAjustada": "2026-09-26T00:00:00",
                        "statusPrazo": 1,
                        "statusEntrega": 3
                    },
                    {
                        "tag": "Todos",
                        "codigoCliente": "1478679",
                        "razaoSocial": "LOJAS QUERO QUERO S A",
                        "id": 76146,
                        "createdAt": "2026-09-25T16:00:06.9027248",
                        "clienteId": 131390,
                        "pedido": "2052941318",
                        "dataPedido": "2026-09-14T00:00:00",
                        "previsaoEntrega": "2026-09-22T00:00:00",
                        "previsaoEntregaAjustada": "2026-09-26T00:00:00",
                        "statusPrazo": 1,
                        "statusEntrega": 3
                    },
                    {
                        "tag": "Todos",
                        "codigoCliente": "1481580",
                        "razaoSocial": "LOJAS QUERO QUERO S A",
                        "id": 76147,
                        "createdAt": "2026-09-25T16:00:06.9027253",
                        "clienteId": 131392,
                        "pedido": "2052970488",
                        "dataPedido": "2026-09-16T00:00:00",
                        "previsaoEntrega": "2026-09-21T00:00:00",
                        "previsaoEntregaAjustada": "2026-09-24T00:00:00",
                        "statusPrazo": 2,
                        "statusEntrega": 2
                    },
                    {
                        "tag": "Todos",
                        "codigoCliente": "1481580",
                        "razaoSocial": "LOJAS QUERO QUERO S A",
                        "id": 76148,
                        "createdAt": "2026-09-25T16:00:06.9027259",
                        "clienteId": 131392,
                        "pedido": "2052970488",
                        "dataPedido": "2026-09-16T00:00:00",
                        "previsaoEntrega": "2026-09-21T00:00:00",
                        "previsaoEntregaAjustada": "2026-09-24T00:00:00",
                        "statusPrazo": 2,
                        "statusEntrega": 2
                    },
                    {
                        "tag": "Todos",
                        "codigoCliente": "1481580",
                        "razaoSocial": "LOJAS QUERO QUERO S A",
                        "id": 76149,
                        "createdAt": "2026-09-25T16:00:06.9027264",
                        "clienteId": 131392,
                        "pedido": "2052970488",
                        "dataPedido": "2026-09-16T00:00:00",
                        "previsaoEntrega": "2026-09-21T00:00:00",
                        "previsaoEntregaAjustada": "2026-09-24T00:00:00",
                        "statusPrazo": 2,
                        "statusEntrega": 2
                    },
                    {
                        "tag": "Todos",
                        "codigoCliente": "1481580",
                        "razaoSocial": "LOJAS QUERO QUERO S A",
                        "id": 76150,
                        "createdAt": "2026-09-25T16:00:06.9027269",
                        "clienteId": 131392,
                        "pedido": "2052941336",
                        "dataPedido": "2026-09-14T00:00:00",
                        "previsaoEntrega": "2026-09-23T00:00:00",
                        "previsaoEntregaAjustada": "2026-09-26T00:00:00",
                        "statusPrazo": 1,
                        "statusEntrega": 3
                    },
                    {
                        "tag": "Todos",
                        "codigoCliente": "1481580",
                        "razaoSocial": "LOJAS QUERO QUERO S A",
                        "id": 76151,
                        "createdAt": "2026-09-25T16:00:06.9027275",
                        "clienteId": 131392,
                        "pedido": "2052941336",
                        "dataPedido": "2026-09-14T00:00:00",
                        "previsaoEntrega": "2026-09-23T00:00:00",
                        "previsaoEntregaAjustada": "2026-09-26T00:00:00",
                        "statusPrazo": 1,
                        "statusEntrega": 3
                    },
                    {
                        "tag": "Todos",
                        "codigoCliente": "1481580",
                        "razaoSocial": "LOJAS QUERO QUERO S A",
                        "id": 76152,
                        "createdAt": "2026-09-25T16:00:06.9027282",
                        "clienteId": 131392,
                        "pedido": "2052941336",
                        "dataPedido": "2026-09-14T00:00:00",
                        "previsaoEntrega": "2026-09-23T00:00:00",
                        "previsaoEntregaAjustada": "2026-09-26T00:00:00",
                        "statusPrazo": 1,
                        "statusEntrega": 3
                    },
                    {
                        "tag": "Todos",
                        "codigoCliente": "1481580",
                        "razaoSocial": "LOJAS QUERO QUERO S A",
                        "id": 76153,
                        "createdAt": "2026-09-25T16:00:06.9027288",
                        "clienteId": 131392,
                        "pedido": "2052970450",
                        "dataPedido": "2026-09-16T00:00:00",
                        "previsaoEntrega": "2026-09-21T00:00:00",
                        "previsaoEntregaAjustada": "2026-09-24T00:00:00",
                        "statusPrazo": 2,
                        "statusEntrega": 2
                    },
                    {
                        "tag": "Todos",
                        "codigoCliente": "1481580",
                        "razaoSocial": "LOJAS QUERO QUERO S A",
                        "id": 76154,
                        "createdAt": "2026-09-25T16:00:06.9027293",
                        "clienteId": 131392,
                        "pedido": "2052970450",
                        "dataPedido": "2026-09-16T00:00:00",
                        "previsaoEntrega": "2026-09-21T00:00:00",
                        "previsaoEntregaAjustada": "2026-09-24T00:00:00",
                        "statusPrazo": 2,
                        "statusEntrega": 2
                    },
                    {
                        "tag": "Todos",
                        "codigoCliente": "1481580",
                        "razaoSocial": "LOJAS QUERO QUERO S A",
                        "id": 76155,
                        "createdAt": "2026-09-25T16:00:06.90273",
                        "clienteId": 131392,
                        "pedido": "2052970450",
                        "dataPedido": "2026-09-16T00:00:00",
                        "previsaoEntrega": "2026-09-21T00:00:00",
                        "previsaoEntregaAjustada": "2026-09-24T00:00:00",
                        "statusPrazo": 2,
                        "statusEntrega": 2
                    },
                    {
                        "tag": "Todos",
                        "codigoCliente": "1481580",
                        "razaoSocial": "LOJAS QUERO QUERO S A",
                        "id": 76156,
                        "createdAt": "2026-09-25T16:00:06.9027306",
                        "clienteId": 131392,
                        "pedido": "2052970516",
                        "dataPedido": "2026-09-16T00:00:00",
                        "previsaoEntrega": "2026-09-21T00:00:00",
                        "previsaoEntregaAjustada": "2026-09-24T00:00:00",
                        "statusPrazo": 2,
                        "statusEntrega": 2
                    },
                    {
                        "tag": "Todos",
                        "codigoCliente": "1481580",
                        "razaoSocial": "LOJAS QUERO QUERO S A",
                        "id": 76157,
                        "createdAt": "2026-09-25T16:00:06.9027311",
                        "clienteId": 131392,
                        "pedido": "2052970516",
                        "dataPedido": "2026-09-16T00:00:00",
                        "previsaoEntrega": "2026-09-21T00:00:00",
                        "previsaoEntregaAjustada": "2026-09-24T00:00:00",
                        "statusPrazo": 2,
                        "statusEntrega": 2
                    },
                    {
                        "tag": "Todos",
                        "codigoCliente": "1481580",
                        "razaoSocial": "LOJAS QUERO QUERO S A",
                        "id": 76158,
                        "createdAt": "2026-09-25T16:00:06.9027316",
                        "clienteId": 131392,
                        "pedido": "2052970516",
                        "dataPedido": "2026-09-16T00:00:00",
                        "previsaoEntrega": "2026-09-21T00:00:00",
                        "previsaoEntregaAjustada": "2026-09-24T00:00:00",
                        "statusPrazo": 2,
                        "statusEntrega": 2
                    },
                    {
                        "tag": "Todos",
                        "codigoCliente": "1481580",
                        "razaoSocial": "LOJAS QUERO QUERO S A",
                        "id": 76159,
                        "createdAt": "2026-09-25T16:00:06.9027321",
                        "clienteId": 131392,
                        "pedido": "2052957271",
                        "dataPedido": "2026-09-15T00:00:00",
                        "previsaoEntrega": "2026-09-22T00:00:00",
                        "previsaoEntregaAjustada": "2026-09-26T00:00:00",
                        "statusPrazo": 1,
                        "statusEntrega": 3
                    },
                    {
                        "tag": "Todos",
                        "codigoCliente": "1481580",
                        "razaoSocial": "LOJAS QUERO QUERO S A",
                        "id": 76160,
                        "createdAt": "2026-09-25T16:00:06.9027329",
                        "clienteId": 131392,
                        "pedido": "2052957271",
                        "dataPedido": "2026-09-15T00:00:00",
                        "previsaoEntrega": "2026-09-22T00:00:00",
                        "previsaoEntregaAjustada": "2026-09-26T00:00:00",
                        "statusPrazo": 1,
                        "statusEntrega": 3
                    },
                    {
                        "tag": "Todos",
                        "codigoCliente": "1481580",
                        "razaoSocial": "LOJAS QUERO QUERO S A",
                        "id": 76161,
                        "createdAt": "2026-09-25T16:00:06.9027334",
                        "clienteId": 131392,
                        "pedido": "2052957271",
                        "dataPedido": "2026-09-15T00:00:00",
                        "previsaoEntrega": "2026-09-22T00:00:00",
                        "previsaoEntregaAjustada": "2026-09-26T00:00:00",
                        "statusPrazo": 1,
                        "statusEntrega": 3
                    },
                    {
                        "tag": "Todos",
                        "codigoCliente": "1139560",
                        "razaoSocial": "LOJAS QUERO QUERO S A",
                        "id": 76162,
                        "createdAt": "2026-09-25T16:00:06.9027339",
                        "clienteId": 131816,
                        "pedido": "2052941719",
                        "dataPedido": "2026-09-14T00:00:00",
                        "previsaoEntrega": "2026-09-23T00:00:00",
                        "previsaoEntregaAjustada": "2026-09-26T00:00:00",
                        "statusPrazo": 1,
                        "statusEntrega": 3
                    },
                    {
                        "tag": "Todos",
                        "codigoCliente": "1139560",
                        "razaoSocial": "LOJAS QUERO QUERO S A",
                        "id": 76163,
                        "createdAt": "2026-09-25T16:00:06.9027345",
                        "clienteId": 131816,
                        "pedido": "2052941719",
                        "dataPedido": "2026-09-14T00:00:00",
                        "previsaoEntrega": "2026-09-23T00:00:00",
                        "previsaoEntregaAjustada": "2026-09-26T00:00:00",
                        "statusPrazo": 1,
                        "statusEntrega": 3
                    },
                    {
                        "tag": "Todos",
                        "codigoCliente": "1139560",
                        "razaoSocial": "LOJAS QUERO QUERO S A",
                        "id": 76164,
                        "createdAt": "2026-09-25T16:00:06.902735",
                        "clienteId": 131816,
                        "pedido": "2052941719",
                        "dataPedido": "2026-09-14T00:00:00",
                        "previsaoEntrega": "2026-09-23T00:00:00",
                        "previsaoEntregaAjustada": "2026-09-26T00:00:00",
                        "statusPrazo": 1,
                        "statusEntrega": 3
                    },
                    {
                        "tag": "Todos",
                        "codigoCliente": "1139560",
                        "razaoSocial": "LOJAS QUERO QUERO S A",
                        "id": 76165,
                        "createdAt": "2026-09-25T16:00:06.9027355",
                        "clienteId": 131816,
                        "pedido": "2053063748",
                        "dataPedido": "2026-09-23T00:00:00",
                        "previsaoEntrega": "2026-09-29T00:00:00",
                        "previsaoEntregaAjustada": "2026-09-29T00:00:00",
                        "statusPrazo": 1,
                        "statusEntrega": 2
                    },
                    {
                        "tag": "Todos",
                        "codigoCliente": "1139560",
                        "razaoSocial": "LOJAS QUERO QUERO S A",
                        "id": 76166,
                        "createdAt": "2026-09-25T16:00:06.902736",
                        "clienteId": 131816,
                        "pedido": "2053063748",
                        "dataPedido": "2026-09-23T00:00:00",
                        "previsaoEntrega": "2026-09-29T00:00:00",
                        "previsaoEntregaAjustada": "2026-09-29T00:00:00",
                        "statusPrazo": 1,
                        "statusEntrega": 2
                    },
                    {
                        "tag": "Todos",
                        "codigoCliente": "1139560",
                        "razaoSocial": "LOJAS QUERO QUERO S A",
                        "id": 76167,
                        "createdAt": "2026-09-25T16:00:06.9027366",
                        "clienteId": 131816,
                        "pedido": "2053063748",
                        "dataPedido": "2026-09-23T00:00:00",
                        "previsaoEntrega": "2026-09-29T00:00:00",
                        "previsaoEntregaAjustada": "2026-09-29T00:00:00",
                        "statusPrazo": 1,
                        "statusEntrega": 2
                    },
                    {
                        "tag": "Todos",
                        "codigoCliente": "1050088",
                        "razaoSocial": "LOJAS QUERO QUERO S A",
                        "id": 76202,
                        "createdAt": "2026-09-25T16:00:06.9027572",
                        "clienteId": 131401,
                        "pedido": "2052969032",
                        "dataPedido": "2026-09-16T00:00:00",
                        "previsaoEntrega": "2026-09-18T00:00:00",
                        "previsaoEntregaAjustada": "2026-09-22T00:00:00",
                        "statusPrazo": 2,
                        "statusEntrega": 2
                    },
                    {
                        "tag": "Todos",
                        "codigoCliente": "1050088",
                        "razaoSocial": "LOJAS QUERO QUERO S A",
                        "id": 76203,
                        "createdAt": "2026-09-25T16:00:06.9027579",
                        "clienteId": 131401,
                        "pedido": "2052969032",
                        "dataPedido": "2026-09-16T00:00:00",
                        "previsaoEntrega": "2026-09-18T00:00:00",
                        "previsaoEntregaAjustada": "2026-09-22T00:00:00",
                        "statusPrazo": 2,
                        "statusEntrega": 2
                    },
                    {
                        "tag": "Todos",
                        "codigoCliente": "1050088",
                        "razaoSocial": "LOJAS QUERO QUERO S A",
                        "id": 76204,
                        "createdAt": "2026-09-25T16:00:06.9027584",
                        "clienteId": 131401,
                        "pedido": "2052969032",
                        "dataPedido": "2026-09-16T00:00:00",
                        "previsaoEntrega": "2026-09-18T00:00:00",
                        "previsaoEntregaAjustada": "2026-09-22T00:00:00",
                        "statusPrazo": 2,
                        "statusEntrega": 2
                    },
                    {
                        "tag": "Todos",
                        "codigoCliente": "1050088",
                        "razaoSocial": "LOJAS QUERO QUERO S A",
                        "id": 76205,
                        "createdAt": "2026-09-25T16:00:06.9027589",
                        "clienteId": 131401,
                        "pedido": "2052969056",
                        "dataPedido": "2026-09-16T00:00:00",
                        "previsaoEntrega": "2026-09-18T00:00:00",
                        "previsaoEntregaAjustada": "2026-09-22T00:00:00",
                        "statusPrazo": 2,
                        "statusEntrega": 2
                    },
                    {
                        "tag": "Todos",
                        "codigoCliente": "1050088",
                        "razaoSocial": "LOJAS QUERO QUERO S A",
                        "id": 76206,
                        "createdAt": "2026-09-25T16:00:06.9027594",
                        "clienteId": 131401,
                        "pedido": "2052969056",
                        "dataPedido": "2026-09-16T00:00:00",
                        "previsaoEntrega": "2026-09-18T00:00:00",
                        "previsaoEntregaAjustada": "2026-09-22T00:00:00",
                        "statusPrazo": 2,
                        "statusEntrega": 2
                    },
                    {
                        "tag": "Todos",
                        "codigoCliente": "1050088",
                        "razaoSocial": "LOJAS QUERO QUERO S A",
                        "id": 76207,
                        "createdAt": "2026-09-25T16:00:06.90276",
                        "clienteId": 131401,
                        "pedido": "2052969056",
                        "dataPedido": "2026-09-16T00:00:00",
                        "previsaoEntrega": "2026-09-18T00:00:00",
                        "previsaoEntregaAjustada": "2026-09-22T00:00:00",
                        "statusPrazo": 2,
                        "statusEntrega": 2
                    },
                    {
                        "tag": "Todos",
                        "codigoCliente": "1050088",
                        "razaoSocial": "LOJAS QUERO QUERO S A",
                        "id": 76208,
                        "createdAt": "2026-09-25T16:00:06.9027606",
                        "clienteId": 131401,
                        "pedido": "2052969006",
                        "dataPedido": "2026-09-16T00:00:00",
                        "previsaoEntrega": "2026-09-18T00:00:00",
                        "previsaoEntregaAjustada": "2026-09-22T00:00:00",
                        "statusPrazo": 2,
                        "statusEntrega": 2
                    },
                    {
                        "tag": "Todos",
                        "codigoCliente": "1050088",
                        "razaoSocial": "LOJAS QUERO QUERO S A",
                        "id": 76209,
                        "createdAt": "2026-09-25T16:00:06.9027612",
                        "clienteId": 131401,
                        "pedido": "2052969006",
                        "dataPedido": "2026-09-16T00:00:00",
                        "previsaoEntrega": "2026-09-18T00:00:00",
                        "previsaoEntregaAjustada": "2026-09-22T00:00:00",
                        "statusPrazo": 2,
                        "statusEntrega": 2
                    },
                    {
                        "tag": "Todos",
                        "codigoCliente": "1050088",
                        "razaoSocial": "LOJAS QUERO QUERO S A",
                        "id": 76210,
                        "createdAt": "2026-09-25T16:00:06.9027616",
                        "clienteId": 131401,
                        "pedido": "2052969006",
                        "dataPedido": "2026-09-16T00:00:00",
                        "previsaoEntrega": "2026-09-18T00:00:00",
                        "previsaoEntregaAjustada": "2026-09-22T00:00:00",
                        "statusPrazo": 2,
                        "statusEntrega": 2
                    },
                    {
                        "tag": "Todos",
                        "codigoCliente": "1050088",
                        "razaoSocial": "LOJAS QUERO QUERO S A",
                        "id": 76211,
                        "createdAt": "2026-09-25T16:00:06.9027621",
                        "clienteId": 131401,
                        "pedido": "2052948884",
                        "dataPedido": "2026-09-15T00:00:00",
                        "previsaoEntrega": "2026-09-22T00:00:00",
                        "previsaoEntregaAjustada": "2026-09-26T00:00:00",
                        "statusPrazo": 1,
                        "statusEntrega": 3
                    },
                    {
                        "tag": "Todos",
                        "codigoCliente": "1050088",
                        "razaoSocial": "LOJAS QUERO QUERO S A",
                        "id": 76212,
                        "createdAt": "2026-09-25T16:00:06.9027626",
                        "clienteId": 131401,
                        "pedido": "2052948884",
                        "dataPedido": "2026-09-15T00:00:00",
                        "previsaoEntrega": "2026-09-22T00:00:00",
                        "previsaoEntregaAjustada": "2026-09-26T00:00:00",
                        "statusPrazo": 1,
                        "statusEntrega": 3
                    },
                    {
                        "tag": "Todos",
                        "codigoCliente": "1050088",
                        "razaoSocial": "LOJAS QUERO QUERO S A",
                        "id": 76213,
                        "createdAt": "2026-09-25T16:00:06.9027631",
                        "clienteId": 131401,
                        "pedido": "2052948884",
                        "dataPedido": "2026-09-15T00:00:00",
                        "previsaoEntrega": "2026-09-22T00:00:00",
                        "previsaoEntregaAjustada": "2026-09-26T00:00:00",
                        "statusPrazo": 1,
                        "statusEntrega": 3
                    },
                    {
                        "tag": "Todos",
                        "codigoCliente": "1050088",
                        "razaoSocial": "LOJAS QUERO QUERO S A",
                        "id": 76214,
                        "createdAt": "2026-09-25T16:00:06.9027636",
                        "clienteId": 131401,
                        "pedido": "2052969085",
                        "dataPedido": "2026-09-16T00:00:00",
                        "previsaoEntrega": "2026-09-18T00:00:00",
                        "previsaoEntregaAjustada": "2026-09-22T00:00:00",
                        "statusPrazo": 2,
                        "statusEntrega": 2
                    },
                    {
                        "tag": "Todos",
                        "codigoCliente": "1050088",
                        "razaoSocial": "LOJAS QUERO QUERO S A",
                        "id": 76215,
                        "createdAt": "2026-09-25T16:00:06.9027642",
                        "clienteId": 131401,
                        "pedido": "2052969085",
                        "dataPedido": "2026-09-16T00:00:00",
                        "previsaoEntrega": "2026-09-18T00:00:00",
                        "previsaoEntregaAjustada": "2026-09-22T00:00:00",
                        "statusPrazo": 2,
                        "statusEntrega": 2
                    },
                    {
                        "tag": "Todos",
                        "codigoCliente": "1050088",
                        "razaoSocial": "LOJAS QUERO QUERO S A",
                        "id": 76216,
                        "createdAt": "2026-09-25T16:00:06.9027647",
                        "clienteId": 131401,
                        "pedido": "2052969085",
                        "dataPedido": "2026-09-16T00:00:00",
                        "previsaoEntrega": "2026-09-18T00:00:00",
                        "previsaoEntregaAjustada": "2026-09-22T00:00:00",
                        "statusPrazo": 2,
                        "statusEntrega": 2
                    },
                    {
                        "tag": "Todos",
                        "codigoCliente": "1077603",
                        "razaoSocial": "LOJAS QUERO QUERO S A",
                        "id": 76217,
                        "createdAt": "2026-09-25T16:00:06.9027653",
                        "clienteId": 27595,
                        "pedido": "2053044520",
                        "dataPedido": "2026-09-22T00:00:00",
                        "previsaoEntrega": "2026-09-30T00:00:00",
                        "previsaoEntregaAjustada": "2026-09-30T00:00:00",
                        "statusPrazo": 1,
                        "statusEntrega": 2
                    },
                    {
                        "tag": "Todos",
                        "codigoCliente": "1077603",
                        "razaoSocial": "LOJAS QUERO QUERO S A",
                        "id": 76218,
                        "createdAt": "2026-09-25T16:00:06.9027658",
                        "clienteId": 27595,
                        "pedido": "2053044520",
                        "dataPedido": "2026-09-22T00:00:00",
                        "previsaoEntrega": "2026-09-30T00:00:00",
                        "previsaoEntregaAjustada": "2026-09-30T00:00:00",
                        "statusPrazo": 1,
                        "statusEntrega": 2
                    },
                    {
                        "tag": "Todos",
                        "codigoCliente": "1077603",
                        "razaoSocial": "LOJAS QUERO QUERO S A",
                        "id": 76219,
                        "createdAt": "2026-09-25T16:00:06.9027664",
                        "clienteId": 27595,
                        "pedido": "2053044520",
                        "dataPedido": "2026-09-22T00:00:00",
                        "previsaoEntrega": "2026-09-30T00:00:00",
                        "previsaoEntregaAjustada": "2026-09-30T00:00:00",
                        "statusPrazo": 1,
                        "statusEntrega": 2
                    },
                    {
                        "tag": "Todos",
                        "codigoCliente": "1077603",
                        "razaoSocial": "LOJAS QUERO QUERO S A",
                        "id": 76220,
                        "createdAt": "2026-09-25T16:00:06.9027671",
                        "clienteId": 27595,
                        "pedido": "2052948893",
                        "dataPedido": "2026-09-15T00:00:00",
                        "previsaoEntrega": "2026-09-23T00:00:00",
                        "previsaoEntregaAjustada": "2026-09-26T00:00:00",
                        "statusPrazo": 1,
                        "statusEntrega": 3
                    },
                    {
                        "tag": "Todos",
                        "codigoCliente": "1077603",
                        "razaoSocial": "LOJAS QUERO QUERO S A",
                        "id": 76221,
                        "createdAt": "2026-09-25T16:00:06.9027676",
                        "clienteId": 27595,
                        "pedido": "2052948893",
                        "dataPedido": "2026-09-15T00:00:00",
                        "previsaoEntrega": "2026-09-23T00:00:00",
                        "previsaoEntregaAjustada": "2026-09-26T00:00:00",
                        "statusPrazo": 1,
                        "statusEntrega": 3
                    },
                    {
                        "tag": "Todos",
                        "codigoCliente": "1077603",
                        "razaoSocial": "LOJAS QUERO QUERO S A",
                        "id": 76222,
                        "createdAt": "2026-09-25T16:00:06.9027681",
                        "clienteId": 27595,
                        "pedido": "2052948893",
                        "dataPedido": "2026-09-15T00:00:00",
                        "previsaoEntrega": "2026-09-23T00:00:00",
                        "previsaoEntregaAjustada": "2026-09-26T00:00:00",
                        "statusPrazo": 1,
                        "statusEntrega": 3
                    },
                    {
                        "tag": "Todos",
                        "codigoCliente": "1399759",
                        "razaoSocial": "LOJAS BECKER LTDA",
                        "id": 76225,
                        "createdAt": "2026-09-25T16:00:06.9027698",
                        "clienteId": 131811,
                        "pedido": "2052949929",
                        "dataPedido": "2026-09-15T00:00:00",
                        "previsaoEntrega": "2026-09-21T00:00:00",
                        "previsaoEntregaAjustada": "2026-09-26T00:00:00",
                        "statusPrazo": 1,
                        "statusEntrega": 3
                    },
                    {
                        "tag": "Todos",
                        "codigoCliente": "1399759",
                        "razaoSocial": "LOJAS BECKER LTDA",
                        "id": 76226,
                        "createdAt": "2026-09-25T16:00:06.9027703",
                        "clienteId": 131811,
                        "pedido": "2052949929",
                        "dataPedido": "2026-09-15T00:00:00",
                        "previsaoEntrega": "2026-09-21T00:00:00",
                        "previsaoEntregaAjustada": "2026-09-26T00:00:00",
                        "statusPrazo": 1,
                        "statusEntrega": 3
                    },
                    {
                        "tag": "Todos",
                        "codigoCliente": "1399759",
                        "razaoSocial": "LOJAS BECKER LTDA",
                        "id": 76227,
                        "createdAt": "2026-09-25T16:00:06.9027709",
                        "clienteId": 131811,
                        "pedido": "2052949929",
                        "dataPedido": "2026-09-15T00:00:00",
                        "previsaoEntrega": "2026-09-21T00:00:00",
                        "previsaoEntregaAjustada": "2026-09-26T00:00:00",
                        "statusPrazo": 1,
                        "statusEntrega": 3
                    },
                    {
                        "tag": "Todos",
                        "codigoCliente": "1544446",
                        "razaoSocial": "CHARLES ANDREI DA SILVA & SANTOS",
                        "id": 76270,
                        "createdAt": "2026-09-25T16:00:06.902794",
                        "clienteId": 134710,
                        "pedido": "2052952683",
                        "dataPedido": "2026-09-15T00:00:00",
                        "previsaoEntrega": "2026-09-21T00:00:00",
                        "previsaoEntregaAjustada": "2026-09-26T00:00:00",
                        "statusPrazo": 1,
                        "statusEntrega": 3
                    },
                    {
                        "tag": "Todos",
                        "codigoCliente": "1544446",
                        "razaoSocial": "CHARLES ANDREI DA SILVA & SANTOS",
                        "id": 76271,
                        "createdAt": "2026-09-25T16:00:06.9027945",
                        "clienteId": 134710,
                        "pedido": "2052952683",
                        "dataPedido": "2026-09-15T00:00:00",
                        "previsaoEntrega": "2026-09-21T00:00:00",
                        "previsaoEntregaAjustada": "2026-09-26T00:00:00",
                        "statusPrazo": 1,
                        "statusEntrega": 3
                    },
                    {
                        "tag": "Todos",
                        "codigoCliente": "1544446",
                        "razaoSocial": "CHARLES ANDREI DA SILVA & SANTOS",
                        "id": 76272,
                        "createdAt": "2026-09-25T16:00:06.902795",
                        "clienteId": 134710,
                        "pedido": "2052952683",
                        "dataPedido": "2026-09-15T00:00:00",
                        "previsaoEntrega": "2026-09-21T00:00:00",
                        "previsaoEntregaAjustada": "2026-09-26T00:00:00",
                        "statusPrazo": 1,
                        "statusEntrega": 3
                    },
                    {
                        "tag": "Todos",
                        "codigoCliente": "1948010",
                        "razaoSocial": "SANDRA REGINA BORGES MARQUES",
                        "id": 76278,
                        "createdAt": "2026-09-25T16:00:06.9027984",
                        "clienteId": 1188747,
                        "pedido": "2052955075",
                        "dataPedido": "2026-09-15T00:00:00",
                        "previsaoEntrega": "2026-09-21T00:00:00",
                        "previsaoEntregaAjustada": "2026-09-26T00:00:00",
                        "statusPrazo": 1,
                        "statusEntrega": 3
                    },
                    {
                        "tag": "Todos",
                        "codigoCliente": "1948031",
                        "razaoSocial": "FLORIANO & FLORIANO FERRAGENS LTDA",
                        "id": 76293,
                        "createdAt": "2026-09-25T16:00:06.9028059",
                        "clienteId": 1188754,
                        "pedido": "2052955340",
                        "dataPedido": "2026-09-15T00:00:00",
                        "previsaoEntrega": "2026-09-21T00:00:00",
                        "previsaoEntregaAjustada": "2026-09-26T00:00:00",
                        "statusPrazo": 1,
                        "statusEntrega": 3
                    },
                    {
                        "tag": "Todos",
                        "codigoCliente": "1065215",
                        "razaoSocial": "LOJAS QUERO QUERO S A",
                        "id": 76323,
                        "createdAt": "2026-09-25T16:00:06.9028221",
                        "clienteId": 135312,
                        "pedido": "2052957235",
                        "dataPedido": "2026-09-15T00:00:00",
                        "previsaoEntrega": "2026-09-22T00:00:00",
                        "previsaoEntregaAjustada": "2026-09-26T00:00:00",
                        "statusPrazo": 1,
                        "statusEntrega": 3
                    },
                    {
                        "tag": "Todos",
                        "codigoCliente": "1065215",
                        "razaoSocial": "LOJAS QUERO QUERO S A",
                        "id": 76324,
                        "createdAt": "2026-09-25T16:00:06.9028226",
                        "clienteId": 135312,
                        "pedido": "2052957235",
                        "dataPedido": "2026-09-15T00:00:00",
                        "previsaoEntrega": "2026-09-22T00:00:00",
                        "previsaoEntregaAjustada": "2026-09-26T00:00:00",
                        "statusPrazo": 1,
                        "statusEntrega": 3
                    },
                    {
                        "tag": "Todos",
                        "codigoCliente": "1065215",
                        "razaoSocial": "LOJAS QUERO QUERO S A",
                        "id": 76325,
                        "createdAt": "2026-09-25T16:00:06.9028231",
                        "clienteId": 135312,
                        "pedido": "2052957235",
                        "dataPedido": "2026-09-15T00:00:00",
                        "previsaoEntrega": "2026-09-22T00:00:00",
                        "previsaoEntregaAjustada": "2026-09-26T00:00:00",
                        "statusPrazo": 1,
                        "statusEntrega": 3
                    },
                    {
                        "tag": "Todos",
                        "codigoCliente": "1928158",
                        "razaoSocial": "52 711 760 ALAN DA COSTA ZANELA",
                        "id": 76413,
                        "createdAt": "2026-09-25T16:00:06.902874",
                        "clienteId": 1162154,
                        "pedido": "2052962039",
                        "dataPedido": "2026-09-16T00:00:00",
                        "previsaoEntrega": "2026-09-22T00:00:00",
                        "previsaoEntregaAjustada": "2026-09-26T00:00:00",
                        "statusPrazo": 1,
                        "statusEntrega": 3
                    },
                    {
                        "tag": "Todos",
                        "codigoCliente": "1928158",
                        "razaoSocial": "52 711 760 ALAN DA COSTA ZANELA",
                        "id": 76414,
                        "createdAt": "2026-09-25T16:00:06.9028745",
                        "clienteId": 1162154,
                        "pedido": "2052962039",
                        "dataPedido": "2026-09-16T00:00:00",
                        "previsaoEntrega": "2026-09-22T00:00:00",
                        "previsaoEntregaAjustada": "2026-09-26T00:00:00",
                        "statusPrazo": 1,
                        "statusEntrega": 3
                    },
                    {
                        "tag": "Todos",
                        "codigoCliente": "1065216",
                        "razaoSocial": "LOJAS QUERO QUERO S A",
                        "id": 76699,
                        "createdAt": "2026-09-25T16:00:06.9030394",
                        "clienteId": 131815,
                        "pedido": "2052969291",
                        "dataPedido": "2026-09-16T00:00:00",
                        "previsaoEntrega": "2026-09-22T00:00:00",
                        "previsaoEntregaAjustada": "2026-09-26T00:00:00",
                        "statusPrazo": 1,
                        "statusEntrega": 3
                    },
                    {
                        "tag": "Todos",
                        "codigoCliente": "1065216",
                        "razaoSocial": "LOJAS QUERO QUERO S A",
                        "id": 76700,
                        "createdAt": "2026-09-25T16:00:06.9030399",
                        "clienteId": 131815,
                        "pedido": "2052969291",
                        "dataPedido": "2026-09-16T00:00:00",
                        "previsaoEntrega": "2026-09-22T00:00:00",
                        "previsaoEntregaAjustada": "2026-09-26T00:00:00",
                        "statusPrazo": 1,
                        "statusEntrega": 3
                    },
                    {
                        "tag": "Todos",
                        "codigoCliente": "1065216",
                        "razaoSocial": "LOJAS QUERO QUERO S A",
                        "id": 76701,
                        "createdAt": "2026-09-25T16:00:06.9030407",
                        "clienteId": 131815,
                        "pedido": "2052969291",
                        "dataPedido": "2026-09-16T00:00:00",
                        "previsaoEntrega": "2026-09-22T00:00:00",
                        "previsaoEntregaAjustada": "2026-09-26T00:00:00",
                        "statusPrazo": 1,
                        "statusEntrega": 3
                    },
                    {
                        "tag": "Todos",
                        "codigoCliente": "1065216",
                        "razaoSocial": "LOJAS QUERO QUERO S A",
                        "id": 76702,
                        "createdAt": "2026-09-25T16:00:06.9030413",
                        "clienteId": 131815,
                        "pedido": "2052969291",
                        "dataPedido": "2026-09-16T00:00:00",
                        "previsaoEntrega": "2026-09-22T00:00:00",
                        "previsaoEntregaAjustada": "2026-09-26T00:00:00",
                        "statusPrazo": 1,
                        "statusEntrega": 3
                    },
                    {
                        "tag": "Todos",
                        "codigoCliente": "1065216",
                        "razaoSocial": "LOJAS QUERO QUERO S A",
                        "id": 76703,
                        "createdAt": "2026-09-25T16:00:06.9030418",
                        "clienteId": 131815,
                        "pedido": "2052969262",
                        "dataPedido": "2026-09-16T00:00:00",
                        "previsaoEntrega": "2026-09-22T00:00:00",
                        "previsaoEntregaAjustada": "2026-09-26T00:00:00",
                        "statusPrazo": 1,
                        "statusEntrega": 3
                    },
                    {
                        "tag": "Todos",
                        "codigoCliente": "1065216",
                        "razaoSocial": "LOJAS QUERO QUERO S A",
                        "id": 76704,
                        "createdAt": "2026-09-25T16:00:06.9030425",
                        "clienteId": 131815,
                        "pedido": "2052969262",
                        "dataPedido": "2026-09-16T00:00:00",
                        "previsaoEntrega": "2026-09-22T00:00:00",
                        "previsaoEntregaAjustada": "2026-09-26T00:00:00",
                        "statusPrazo": 1,
                        "statusEntrega": 3
                    },
                    {
                        "tag": "Todos",
                        "codigoCliente": "1065216",
                        "razaoSocial": "LOJAS QUERO QUERO S A",
                        "id": 76705,
                        "createdAt": "2026-09-25T16:00:06.903043",
                        "clienteId": 131815,
                        "pedido": "2052969262",
                        "dataPedido": "2026-09-16T00:00:00",
                        "previsaoEntrega": "2026-09-22T00:00:00",
                        "previsaoEntregaAjustada": "2026-09-26T00:00:00",
                        "statusPrazo": 1,
                        "statusEntrega": 3
                    },
                    {
                        "tag": "Todos",
                        "codigoCliente": "1065216",
                        "razaoSocial": "LOJAS QUERO QUERO S A",
                        "id": 76706,
                        "createdAt": "2026-09-25T16:00:06.9030438",
                        "clienteId": 131815,
                        "pedido": "2052969262",
                        "dataPedido": "2026-09-16T00:00:00",
                        "previsaoEntrega": "2026-09-22T00:00:00",
                        "previsaoEntregaAjustada": "2026-09-26T00:00:00",
                        "statusPrazo": 1,
                        "statusEntrega": 3
                    },
                    {
                        "tag": "Todos",
                        "codigoCliente": "1056014",
                        "razaoSocial": "WILMO VALENTIM FRANCESCHI & CIA LTD",
                        "id": 76908,
                        "createdAt": "2026-09-25T16:00:06.9031626",
                        "clienteId": 134390,
                        "pedido": "2052979405",
                        "dataPedido": "2026-09-17T00:00:00",
                        "previsaoEntrega": "2026-09-22T00:00:00",
                        "previsaoEntregaAjustada": "2026-09-26T00:00:00",
                        "statusPrazo": 1,
                        "statusEntrega": 3
                    },
                    {
                        "tag": "Todos",
                        "codigoCliente": "1056014",
                        "razaoSocial": "WILMO VALENTIM FRANCESCHI & CIA LTD",
                        "id": 76909,
                        "createdAt": "2026-09-25T16:00:06.9031632",
                        "clienteId": 134390,
                        "pedido": "2052979405",
                        "dataPedido": "2026-09-17T00:00:00",
                        "previsaoEntrega": "2026-09-22T00:00:00",
                        "previsaoEntregaAjustada": "2026-09-26T00:00:00",
                        "statusPrazo": 1,
                        "statusEntrega": 3
                    },
                    {
                        "tag": "Todos",
                        "codigoCliente": "1056014",
                        "razaoSocial": "WILMO VALENTIM FRANCESCHI & CIA LTD",
                        "id": 76910,
                        "createdAt": "2026-09-25T16:00:06.9031638",
                        "clienteId": 134390,
                        "pedido": "2052979405",
                        "dataPedido": "2026-09-17T00:00:00",
                        "previsaoEntrega": "2026-09-22T00:00:00",
                        "previsaoEntregaAjustada": "2026-09-26T00:00:00",
                        "statusPrazo": 1,
                        "statusEntrega": 3
                    },
                    {
                        "tag": "Todos",
                        "codigoCliente": "1207906",
                        "razaoSocial": "TUMELERO MATERIAIS DE CONSTRUCAO",
                        "id": 76997,
                        "createdAt": "2026-09-25T16:00:06.9032159",
                        "clienteId": 137561,
                        "pedido": "2052981756",
                        "dataPedido": "2026-09-17T00:00:00",
                        "previsaoEntrega": "2026-09-23T00:00:00",
                        "previsaoEntregaAjustada": "2026-10-06T00:00:00",
                        "statusPrazo": 1,
                        "statusEntrega": 3
                    },
                    {
                        "tag": "Todos",
                        "codigoCliente": "1207906",
                        "razaoSocial": "TUMELERO MATERIAIS DE CONSTRUCAO",
                        "id": 76998,
                        "createdAt": "2026-09-25T16:00:06.9032164",
                        "clienteId": 137561,
                        "pedido": "2052981756",
                        "dataPedido": "2026-09-17T00:00:00",
                        "previsaoEntrega": "2026-09-23T00:00:00",
                        "previsaoEntregaAjustada": "2026-10-06T00:00:00",
                        "statusPrazo": 1,
                        "statusEntrega": 3
                    },
                    {
                        "tag": "Todos",
                        "codigoCliente": "1207906",
                        "razaoSocial": "TUMELERO MATERIAIS DE CONSTRUCAO",
                        "id": 76999,
                        "createdAt": "2026-09-25T16:00:06.903217",
                        "clienteId": 137561,
                        "pedido": "2052981756",
                        "dataPedido": "2026-09-17T00:00:00",
                        "previsaoEntrega": "2026-09-23T00:00:00",
                        "previsaoEntregaAjustada": "2026-10-06T00:00:00",
                        "statusPrazo": 1,
                        "statusEntrega": 3
                    },
                    {
                        "tag": "Todos",
                        "codigoCliente": "1475121",
                        "razaoSocial": "ROSANE FATIMA PARCIANELLO LINKE LTD",
                        "id": 77134,
                        "createdAt": "2026-09-25T16:00:06.9032955",
                        "clienteId": 131992,
                        "pedido": "2052988945",
                        "dataPedido": "2026-09-17T00:00:00",
                        "previsaoEntrega": "2026-09-28T00:00:00",
                        "previsaoEntregaAjustada": "2026-09-26T00:00:00",
                        "statusPrazo": 1,
                        "statusEntrega": 3
                    },
                    {
                        "tag": "Todos",
                        "codigoCliente": "1475121",
                        "razaoSocial": "ROSANE FATIMA PARCIANELLO LINKE LTD",
                        "id": 77135,
                        "createdAt": "2026-09-25T16:00:06.9032961",
                        "clienteId": 131992,
                        "pedido": "2052988945",
                        "dataPedido": "2026-09-17T00:00:00",
                        "previsaoEntrega": "2026-09-28T00:00:00",
                        "previsaoEntregaAjustada": "2026-09-26T00:00:00",
                        "statusPrazo": 1,
                        "statusEntrega": 3
                    },
                    {
                        "tag": "Todos",
                        "codigoCliente": "1475121",
                        "razaoSocial": "ROSANE FATIMA PARCIANELLO LINKE LTD",
                        "id": 77136,
                        "createdAt": "2026-09-25T16:00:06.9032968",
                        "clienteId": 131992,
                        "pedido": "2052988945",
                        "dataPedido": "2026-09-17T00:00:00",
                        "previsaoEntrega": "2026-09-28T00:00:00",
                        "previsaoEntregaAjustada": "2026-09-26T00:00:00",
                        "statusPrazo": 1,
                        "statusEntrega": 3
                    },
                    {
                        "tag": "Todos",
                        "codigoCliente": "1475121",
                        "razaoSocial": "ROSANE FATIMA PARCIANELLO LINKE LTD",
                        "id": 77137,
                        "createdAt": "2026-09-25T16:00:06.9032973",
                        "clienteId": 131992,
                        "pedido": "2053089701",
                        "dataPedido": "2026-09-25T00:00:00",
                        "previsaoEntrega": "2026-09-28T00:00:00",
                        "previsaoEntregaAjustada": "2026-09-28T00:00:00",
                        "statusPrazo": 1,
                        "statusEntrega": 2
                    },
                    {
                        "tag": "Todos",
                        "codigoCliente": "1475121",
                        "razaoSocial": "ROSANE FATIMA PARCIANELLO LINKE LTD",
                        "id": 77138,
                        "createdAt": "2026-09-25T16:00:06.9032982",
                        "clienteId": 131992,
                        "pedido": "2053089701",
                        "dataPedido": "2026-09-25T00:00:00",
                        "previsaoEntrega": "2026-09-28T00:00:00",
                        "previsaoEntregaAjustada": "2026-09-28T00:00:00",
                        "statusPrazo": 1,
                        "statusEntrega": 2
                    },
                    {
                        "tag": "Todos",
                        "codigoCliente": "1475121",
                        "razaoSocial": "ROSANE FATIMA PARCIANELLO LINKE LTD",
                        "id": 77139,
                        "createdAt": "2026-09-25T16:00:06.9032989",
                        "clienteId": 131992,
                        "pedido": "2053089701",
                        "dataPedido": "2026-09-25T00:00:00",
                        "previsaoEntrega": "2026-09-28T00:00:00",
                        "previsaoEntregaAjustada": "2026-09-28T00:00:00",
                        "statusPrazo": 1,
                        "statusEntrega": 2
                    },
                    {
                        "tag": "Todos",
                        "codigoCliente": "1366170",
                        "razaoSocial": "AYANG E MORAIS LTDA",
                        "id": 77207,
                        "createdAt": "2026-09-25T16:00:06.9033394",
                        "clienteId": 134688,
                        "pedido": "2052995135",
                        "dataPedido": "2026-09-18T00:00:00",
                        "previsaoEntrega": "2026-09-24T00:00:00",
                        "previsaoEntregaAjustada": "2026-10-06T00:00:00",
                        "statusPrazo": 1,
                        "statusEntrega": 3
                    },
                    {
                        "tag": "Todos",
                        "codigoCliente": "1366170",
                        "razaoSocial": "AYANG E MORAIS LTDA",
                        "id": 77208,
                        "createdAt": "2026-09-25T16:00:06.90334",
                        "clienteId": 134688,
                        "pedido": "2052995135",
                        "dataPedido": "2026-09-18T00:00:00",
                        "previsaoEntrega": "2026-09-24T00:00:00",
                        "previsaoEntregaAjustada": "2026-10-06T00:00:00",
                        "statusPrazo": 1,
                        "statusEntrega": 3
                    },
                    {
                        "tag": "Todos",
                        "codigoCliente": "1366170",
                        "razaoSocial": "AYANG E MORAIS LTDA",
                        "id": 77209,
                        "createdAt": "2026-09-25T16:00:06.9033407",
                        "clienteId": 134688,
                        "pedido": "2052995135",
                        "dataPedido": "2026-09-18T00:00:00",
                        "previsaoEntrega": "2026-09-24T00:00:00",
                        "previsaoEntregaAjustada": "2026-10-06T00:00:00",
                        "statusPrazo": 1,
                        "statusEntrega": 3
                    },
                    {
                        "tag": "Todos",
                        "codigoCliente": "1348553",
                        "razaoSocial": "CASA DAS CERAMICAS LTDA",
                        "id": 77210,
                        "createdAt": "2026-09-25T16:00:06.9033413",
                        "clienteId": 134687,
                        "pedido": "2052995206",
                        "dataPedido": "2026-09-18T00:00:00",
                        "previsaoEntrega": "2026-09-24T00:00:00",
                        "previsaoEntregaAjustada": "2026-10-06T00:00:00",
                        "statusPrazo": 1,
                        "statusEntrega": 3
                    },
                    {
                        "tag": "Todos",
                        "codigoCliente": "1348553",
                        "razaoSocial": "CASA DAS CERAMICAS LTDA",
                        "id": 77211,
                        "createdAt": "2026-09-25T16:00:06.903342",
                        "clienteId": 134687,
                        "pedido": "2052995206",
                        "dataPedido": "2026-09-18T00:00:00",
                        "previsaoEntrega": "2026-09-24T00:00:00",
                        "previsaoEntregaAjustada": "2026-10-06T00:00:00",
                        "statusPrazo": 1,
                        "statusEntrega": 3
                    },
                    {
                        "tag": "Todos",
                        "codigoCliente": "1348553",
                        "razaoSocial": "CASA DAS CERAMICAS LTDA",
                        "id": 77212,
                        "createdAt": "2026-09-25T16:00:06.9033426",
                        "clienteId": 134687,
                        "pedido": "2052995206",
                        "dataPedido": "2026-09-18T00:00:00",
                        "previsaoEntrega": "2026-09-24T00:00:00",
                        "previsaoEntregaAjustada": "2026-10-06T00:00:00",
                        "statusPrazo": 1,
                        "statusEntrega": 3
                    },
                    {
                        "tag": "Todos",
                        "codigoCliente": "1184889",
                        "razaoSocial": "MARTA A DE MORAIS",
                        "id": 77215,
                        "createdAt": "2026-09-25T16:00:06.9033442",
                        "clienteId": 135105,
                        "pedido": "2052995334",
                        "dataPedido": "2026-09-18T00:00:00",
                        "previsaoEntrega": "2026-09-24T00:00:00",
                        "previsaoEntregaAjustada": "2026-10-06T00:00:00",
                        "statusPrazo": 1,
                        "statusEntrega": 3
                    },
                    {
                        "tag": "Todos",
                        "codigoCliente": "1184889",
                        "razaoSocial": "MARTA A DE MORAIS",
                        "id": 77216,
                        "createdAt": "2026-09-25T16:00:06.9033451",
                        "clienteId": 135105,
                        "pedido": "2052995334",
                        "dataPedido": "2026-09-18T00:00:00",
                        "previsaoEntrega": "2026-09-24T00:00:00",
                        "previsaoEntregaAjustada": "2026-10-06T00:00:00",
                        "statusPrazo": 1,
                        "statusEntrega": 3
                    },
                    {
                        "tag": "Todos",
                        "codigoCliente": "1184889",
                        "razaoSocial": "MARTA A DE MORAIS",
                        "id": 77217,
                        "createdAt": "2026-09-25T16:00:06.9033457",
                        "clienteId": 135105,
                        "pedido": "2052995334",
                        "dataPedido": "2026-09-18T00:00:00",
                        "previsaoEntrega": "2026-09-24T00:00:00",
                        "previsaoEntregaAjustada": "2026-10-06T00:00:00",
                        "statusPrazo": 1,
                        "statusEntrega": 3
                    },
                    {
                        "tag": "Todos",
                        "codigoCliente": "1197438",
                        "razaoSocial": "MARTA A DE MORAIS   ME",
                        "id": 77218,
                        "createdAt": "2026-09-25T16:00:06.9033462",
                        "clienteId": 3802,
                        "pedido": "2052995409",
                        "dataPedido": "2026-09-18T00:00:00",
                        "previsaoEntrega": "2026-09-24T00:00:00",
                        "previsaoEntregaAjustada": "2026-10-06T00:00:00",
                        "statusPrazo": 1,
                        "statusEntrega": 3
                    },
                    {
                        "tag": "Todos",
                        "codigoCliente": "1197438",
                        "razaoSocial": "MARTA A DE MORAIS   ME",
                        "id": 77219,
                        "createdAt": "2026-09-25T16:00:06.9033467",
                        "clienteId": 3802,
                        "pedido": "2052995409",
                        "dataPedido": "2026-09-18T00:00:00",
                        "previsaoEntrega": "2026-09-24T00:00:00",
                        "previsaoEntregaAjustada": "2026-10-06T00:00:00",
                        "statusPrazo": 1,
                        "statusEntrega": 3
                    },
                    {
                        "tag": "Todos",
                        "codigoCliente": "1197438",
                        "razaoSocial": "MARTA A DE MORAIS   ME",
                        "id": 77220,
                        "createdAt": "2026-09-25T16:00:06.9033473",
                        "clienteId": 3802,
                        "pedido": "2052995409",
                        "dataPedido": "2026-09-18T00:00:00",
                        "previsaoEntrega": "2026-09-24T00:00:00",
                        "previsaoEntregaAjustada": "2026-10-06T00:00:00",
                        "statusPrazo": 1,
                        "statusEntrega": 3
                    },
                    {
                        "tag": "Todos",
                        "codigoCliente": "1197438",
                        "razaoSocial": "MARTA A DE MORAIS   ME",
                        "id": 77221,
                        "createdAt": "2026-09-25T16:00:06.9033478",
                        "clienteId": 3802,
                        "pedido": "2052995409",
                        "dataPedido": "2026-09-18T00:00:00",
                        "previsaoEntrega": "2026-09-24T00:00:00",
                        "previsaoEntregaAjustada": "2026-10-06T00:00:00",
                        "statusPrazo": 1,
                        "statusEntrega": 3
                    },
                    {
                        "tag": "Todos",
                        "codigoCliente": "1124055",
                        "razaoSocial": "ALFONSO KUHN & CIA LTDA",
                        "id": 77222,
                        "createdAt": "2026-09-25T16:00:06.9033484",
                        "clienteId": 135119,
                        "pedido": "2052995437",
                        "dataPedido": "2026-09-18T00:00:00",
                        "previsaoEntrega": "2026-09-25T00:00:00",
                        "previsaoEntregaAjustada": "2026-09-26T00:00:00",
                        "statusPrazo": 1,
                        "statusEntrega": 3
                    },
                    {
                        "tag": "Todos",
                        "codigoCliente": "1124055",
                        "razaoSocial": "ALFONSO KUHN & CIA LTDA",
                        "id": 77223,
                        "createdAt": "2026-09-25T16:00:06.9033489",
                        "clienteId": 135119,
                        "pedido": "2052995437",
                        "dataPedido": "2026-09-18T00:00:00",
                        "previsaoEntrega": "2026-09-25T00:00:00",
                        "previsaoEntregaAjustada": "2026-09-26T00:00:00",
                        "statusPrazo": 1,
                        "statusEntrega": 3
                    },
                    {
                        "tag": "Todos",
                        "codigoCliente": "1124055",
                        "razaoSocial": "ALFONSO KUHN & CIA LTDA",
                        "id": 77224,
                        "createdAt": "2026-09-25T16:00:06.9033495",
                        "clienteId": 135119,
                        "pedido": "2052995437",
                        "dataPedido": "2026-09-18T00:00:00",
                        "previsaoEntrega": "2026-09-25T00:00:00",
                        "previsaoEntregaAjustada": "2026-09-26T00:00:00",
                        "statusPrazo": 1,
                        "statusEntrega": 3
                    },
                    {
                        "tag": "Todos",
                        "codigoCliente": "1479418",
                        "razaoSocial": "JOAO BATISTA SANCHES SILVA LTDA",
                        "id": 77251,
                        "createdAt": "2026-09-25T16:00:06.9033661",
                        "clienteId": 137372,
                        "pedido": "2052995635",
                        "dataPedido": "2026-09-18T00:00:00",
                        "previsaoEntrega": "2026-09-25T00:00:00",
                        "previsaoEntregaAjustada": "2026-09-26T00:00:00",
                        "statusPrazo": 1,
                        "statusEntrega": 3
                    },
                    {
                        "tag": "Todos",
                        "codigoCliente": "1479418",
                        "razaoSocial": "JOAO BATISTA SANCHES SILVA LTDA",
                        "id": 77252,
                        "createdAt": "2026-09-25T16:00:06.9033666",
                        "clienteId": 137372,
                        "pedido": "2052995635",
                        "dataPedido": "2026-09-18T00:00:00",
                        "previsaoEntrega": "2026-09-25T00:00:00",
                        "previsaoEntregaAjustada": "2026-09-26T00:00:00",
                        "statusPrazo": 1,
                        "statusEntrega": 3
                    },
                    {
                        "tag": "Todos",
                        "codigoCliente": "1479418",
                        "razaoSocial": "JOAO BATISTA SANCHES SILVA LTDA",
                        "id": 77253,
                        "createdAt": "2026-09-25T16:00:06.9033671",
                        "clienteId": 137372,
                        "pedido": "2052995635",
                        "dataPedido": "2026-09-18T00:00:00",
                        "previsaoEntrega": "2026-09-25T00:00:00",
                        "previsaoEntregaAjustada": "2026-09-26T00:00:00",
                        "statusPrazo": 1,
                        "statusEntrega": 3
                    },
                    {
                        "tag": "Todos",
                        "codigoCliente": "1479418",
                        "razaoSocial": "JOAO BATISTA SANCHES SILVA LTDA",
                        "id": 77254,
                        "createdAt": "2026-09-25T16:00:06.9033679",
                        "clienteId": 137372,
                        "pedido": "2052995635",
                        "dataPedido": "2026-09-18T00:00:00",
                        "previsaoEntrega": "2026-09-25T00:00:00",
                        "previsaoEntregaAjustada": "2026-09-26T00:00:00",
                        "statusPrazo": 1,
                        "statusEntrega": 3
                    },
                    {
                        "tag": "Todos",
                        "codigoCliente": "1479418",
                        "razaoSocial": "JOAO BATISTA SANCHES SILVA LTDA",
                        "id": 77255,
                        "createdAt": "2026-09-25T16:00:06.9033685",
                        "clienteId": 137372,
                        "pedido": "2052995635",
                        "dataPedido": "2026-09-18T00:00:00",
                        "previsaoEntrega": "2026-09-25T00:00:00",
                        "previsaoEntregaAjustada": "2026-09-26T00:00:00",
                        "statusPrazo": 1,
                        "statusEntrega": 3
                    },
                    {
                        "tag": "Todos",
                        "codigoCliente": "1056172",
                        "razaoSocial": "LOJAS BECKER LTDA",
                        "id": 77405,
                        "createdAt": "2026-09-25T16:00:06.9034576",
                        "clienteId": 139058,
                        "pedido": "2052998484",
                        "dataPedido": "2026-09-18T00:00:00",
                        "previsaoEntrega": "2026-09-25T00:00:00",
                        "previsaoEntregaAjustada": "2026-09-26T00:00:00",
                        "statusPrazo": 1,
                        "statusEntrega": 3
                    },
                    {
                        "tag": "Todos",
                        "codigoCliente": "1056172",
                        "razaoSocial": "LOJAS BECKER LTDA",
                        "id": 77406,
                        "createdAt": "2026-09-25T16:00:06.9034581",
                        "clienteId": 139058,
                        "pedido": "2052998484",
                        "dataPedido": "2026-09-18T00:00:00",
                        "previsaoEntrega": "2026-09-25T00:00:00",
                        "previsaoEntregaAjustada": "2026-09-26T00:00:00",
                        "statusPrazo": 1,
                        "statusEntrega": 3
                    },
                    {
                        "tag": "Todos",
                        "codigoCliente": "1056172",
                        "razaoSocial": "LOJAS BECKER LTDA",
                        "id": 77407,
                        "createdAt": "2026-09-25T16:00:06.9034588",
                        "clienteId": 139058,
                        "pedido": "2052998484",
                        "dataPedido": "2026-09-18T00:00:00",
                        "previsaoEntrega": "2026-09-25T00:00:00",
                        "previsaoEntregaAjustada": "2026-09-26T00:00:00",
                        "statusPrazo": 1,
                        "statusEntrega": 3
                    },
                    {
                        "tag": "Todos",
                        "codigoCliente": "1935521",
                        "razaoSocial": "SOFIA GAU ACUNA LTDA",
                        "id": 77512,
                        "createdAt": "2026-09-25T16:00:06.9036273",
                        "clienteId": 1171639,
                        "pedido": "2052999807",
                        "dataPedido": "2026-09-18T00:00:00",
                        "previsaoEntrega": "2026-09-25T00:00:00",
                        "previsaoEntregaAjustada": "2026-10-06T00:00:00",
                        "statusPrazo": 1,
                        "statusEntrega": 3
                    },
                    {
                        "tag": "Todos",
                        "codigoCliente": "1077694",
                        "razaoSocial": "LOJAS BECKER LTDA",
                        "id": 77661,
                        "createdAt": "2026-09-25T16:00:06.9037105",
                        "clienteId": 131395,
                        "pedido": "2053008192",
                        "dataPedido": "2026-09-18T00:00:00",
                        "previsaoEntrega": "2026-09-28T00:00:00",
                        "previsaoEntregaAjustada": "2026-09-26T00:00:00",
                        "statusPrazo": 1,
                        "statusEntrega": 3
                    },
                    {
                        "tag": "Todos",
                        "codigoCliente": "1077694",
                        "razaoSocial": "LOJAS BECKER LTDA",
                        "id": 77662,
                        "createdAt": "2026-09-25T16:00:06.9037111",
                        "clienteId": 131395,
                        "pedido": "2053008192",
                        "dataPedido": "2026-09-18T00:00:00",
                        "previsaoEntrega": "2026-09-28T00:00:00",
                        "previsaoEntregaAjustada": "2026-09-26T00:00:00",
                        "statusPrazo": 1,
                        "statusEntrega": 3
                    },
                    {
                        "tag": "Todos",
                        "codigoCliente": "1077694",
                        "razaoSocial": "LOJAS BECKER LTDA",
                        "id": 77663,
                        "createdAt": "2026-09-25T16:00:06.9037117",
                        "clienteId": 131395,
                        "pedido": "2053008192",
                        "dataPedido": "2026-09-18T00:00:00",
                        "previsaoEntrega": "2026-09-28T00:00:00",
                        "previsaoEntregaAjustada": "2026-09-26T00:00:00",
                        "statusPrazo": 1,
                        "statusEntrega": 3
                    },
                    {
                        "tag": "Todos",
                        "codigoCliente": "1056204",
                        "razaoSocial": "LOJAS BECKER LTDA",
                        "id": 78024,
                        "createdAt": "2026-09-25T16:00:06.9039595",
                        "clienteId": 131406,
                        "pedido": "2053021709",
                        "dataPedido": "2026-09-21T00:00:00",
                        "previsaoEntrega": "2026-09-28T00:00:00",
                        "previsaoEntregaAjustada": "2026-09-26T00:00:00",
                        "statusPrazo": 1,
                        "statusEntrega": 3
                    },
                    {
                        "tag": "Todos",
                        "codigoCliente": "1056204",
                        "razaoSocial": "LOJAS BECKER LTDA",
                        "id": 78025,
                        "createdAt": "2026-09-25T16:00:06.9039601",
                        "clienteId": 131406,
                        "pedido": "2053021709",
                        "dataPedido": "2026-09-21T00:00:00",
                        "previsaoEntrega": "2026-09-28T00:00:00",
                        "previsaoEntregaAjustada": "2026-09-26T00:00:00",
                        "statusPrazo": 1,
                        "statusEntrega": 3
                    },
                    {
                        "tag": "Todos",
                        "codigoCliente": "1056204",
                        "razaoSocial": "LOJAS BECKER LTDA",
                        "id": 78026,
                        "createdAt": "2026-09-25T16:00:06.9039606",
                        "clienteId": 131406,
                        "pedido": "2053021709",
                        "dataPedido": "2026-09-21T00:00:00",
                        "previsaoEntrega": "2026-09-28T00:00:00",
                        "previsaoEntregaAjustada": "2026-09-26T00:00:00",
                        "statusPrazo": 1,
                        "statusEntrega": 3
                    },
                    {
                        "tag": "Todos",
                        "codigoCliente": "1056204",
                        "razaoSocial": "LOJAS BECKER LTDA",
                        "id": 78027,
                        "createdAt": "2026-09-25T16:00:06.9039611",
                        "clienteId": 131406,
                        "pedido": "2053021709",
                        "dataPedido": "2026-09-21T00:00:00",
                        "previsaoEntrega": "2026-09-28T00:00:00",
                        "previsaoEntregaAjustada": "2026-09-26T00:00:00",
                        "statusPrazo": 1,
                        "statusEntrega": 3
                    },
                    {
                        "tag": "Todos",
                        "codigoCliente": "1056220",
                        "razaoSocial": "LOJAS BECKER LTDA",
                        "id": 78069,
                        "createdAt": "2026-09-25T16:00:06.9039845",
                        "clienteId": 28878,
                        "pedido": "2053024129",
                        "dataPedido": "2026-09-21T00:00:00",
                        "previsaoEntrega": "2026-09-28T00:00:00",
                        "previsaoEntregaAjustada": "2026-09-26T00:00:00",
                        "statusPrazo": 1,
                        "statusEntrega": 3
                    },
                    {
                        "tag": "Todos",
                        "codigoCliente": "1056220",
                        "razaoSocial": "LOJAS BECKER LTDA",
                        "id": 78070,
                        "createdAt": "2026-09-25T16:00:06.903985",
                        "clienteId": 28878,
                        "pedido": "2053024129",
                        "dataPedido": "2026-09-21T00:00:00",
                        "previsaoEntrega": "2026-09-28T00:00:00",
                        "previsaoEntregaAjustada": "2026-09-26T00:00:00",
                        "statusPrazo": 1,
                        "statusEntrega": 3
                    },
                    {
                        "tag": "Todos",
                        "codigoCliente": "1056220",
                        "razaoSocial": "LOJAS BECKER LTDA",
                        "id": 78071,
                        "createdAt": "2026-09-25T16:00:06.9039855",
                        "clienteId": 28878,
                        "pedido": "2053024129",
                        "dataPedido": "2026-09-21T00:00:00",
                        "previsaoEntrega": "2026-09-28T00:00:00",
                        "previsaoEntregaAjustada": "2026-09-26T00:00:00",
                        "statusPrazo": 1,
                        "statusEntrega": 3
                    },
                    {
                        "tag": "Todos",
                        "codigoCliente": "1050321",
                        "razaoSocial": "LOJAS BECKER LTDA",
                        "id": 78090,
                        "createdAt": "2026-09-25T16:00:06.9039959",
                        "clienteId": 27313,
                        "pedido": "2053024542",
                        "dataPedido": "2026-09-21T00:00:00",
                        "previsaoEntrega": "2026-09-28T00:00:00",
                        "previsaoEntregaAjustada": "2026-09-26T00:00:00",
                        "statusPrazo": 1,
                        "statusEntrega": 3
                    },
                    {
                        "tag": "Todos",
                        "codigoCliente": "1050321",
                        "razaoSocial": "LOJAS BECKER LTDA",
                        "id": 78091,
                        "createdAt": "2026-09-25T16:00:06.9039965",
                        "clienteId": 27313,
                        "pedido": "2053024542",
                        "dataPedido": "2026-09-21T00:00:00",
                        "previsaoEntrega": "2026-09-28T00:00:00",
                        "previsaoEntregaAjustada": "2026-09-26T00:00:00",
                        "statusPrazo": 1,
                        "statusEntrega": 3
                    },
                    {
                        "tag": "Todos",
                        "codigoCliente": "1050321",
                        "razaoSocial": "LOJAS BECKER LTDA",
                        "id": 78092,
                        "createdAt": "2026-09-25T16:00:06.9039971",
                        "clienteId": 27313,
                        "pedido": "2053024542",
                        "dataPedido": "2026-09-21T00:00:00",
                        "previsaoEntrega": "2026-09-28T00:00:00",
                        "previsaoEntregaAjustada": "2026-09-26T00:00:00",
                        "statusPrazo": 1,
                        "statusEntrega": 3
                    },
                    {
                        "tag": "Todos",
                        "codigoCliente": "1057514",
                        "razaoSocial": "LOJAS BECKER LTDA",
                        "id": 78124,
                        "createdAt": "2026-09-25T16:00:06.9040147",
                        "clienteId": 139059,
                        "pedido": "2053025072",
                        "dataPedido": "2026-09-21T00:00:00",
                        "previsaoEntrega": "2026-09-28T00:00:00",
                        "previsaoEntregaAjustada": "2026-09-26T00:00:00",
                        "statusPrazo": 1,
                        "statusEntrega": 3
                    },
                    {
                        "tag": "Todos",
                        "codigoCliente": "1057514",
                        "razaoSocial": "LOJAS BECKER LTDA",
                        "id": 78125,
                        "createdAt": "2026-09-25T16:00:06.9040153",
                        "clienteId": 139059,
                        "pedido": "2053025072",
                        "dataPedido": "2026-09-21T00:00:00",
                        "previsaoEntrega": "2026-09-28T00:00:00",
                        "previsaoEntregaAjustada": "2026-09-26T00:00:00",
                        "statusPrazo": 1,
                        "statusEntrega": 3
                    },
                    {
                        "tag": "Todos",
                        "codigoCliente": "1057514",
                        "razaoSocial": "LOJAS BECKER LTDA",
                        "id": 78126,
                        "createdAt": "2026-09-25T16:00:06.9040158",
                        "clienteId": 139059,
                        "pedido": "2053025072",
                        "dataPedido": "2026-09-21T00:00:00",
                        "previsaoEntrega": "2026-09-28T00:00:00",
                        "previsaoEntregaAjustada": "2026-09-26T00:00:00",
                        "statusPrazo": 1,
                        "statusEntrega": 3
                    },
                    {
                        "tag": "Todos",
                        "codigoCliente": "1078651",
                        "razaoSocial": "LOJAS BECKER LTDA",
                        "id": 78205,
                        "createdAt": "2026-09-25T16:00:06.9040618",
                        "clienteId": 131400,
                        "pedido": "2053026367",
                        "dataPedido": "2026-09-21T00:00:00",
                        "previsaoEntrega": "2026-09-25T00:00:00",
                        "previsaoEntregaAjustada": "2026-09-26T00:00:00",
                        "statusPrazo": 1,
                        "statusEntrega": 3
                    },
                    {
                        "tag": "Todos",
                        "codigoCliente": "1078651",
                        "razaoSocial": "LOJAS BECKER LTDA",
                        "id": 78206,
                        "createdAt": "2026-09-25T16:00:06.9040624",
                        "clienteId": 131400,
                        "pedido": "2053026367",
                        "dataPedido": "2026-09-21T00:00:00",
                        "previsaoEntrega": "2026-09-25T00:00:00",
                        "previsaoEntregaAjustada": "2026-09-26T00:00:00",
                        "statusPrazo": 1,
                        "statusEntrega": 3
                    },
                    {
                        "tag": "Todos",
                        "codigoCliente": "1078651",
                        "razaoSocial": "LOJAS BECKER LTDA",
                        "id": 78207,
                        "createdAt": "2026-09-25T16:00:06.9040632",
                        "clienteId": 131400,
                        "pedido": "2053026367",
                        "dataPedido": "2026-09-21T00:00:00",
                        "previsaoEntrega": "2026-09-25T00:00:00",
                        "previsaoEntregaAjustada": "2026-09-26T00:00:00",
                        "statusPrazo": 1,
                        "statusEntrega": 3
                    },
                    {
                        "tag": "Todos",
                        "codigoCliente": "1420020",
                        "razaoSocial": "LOJAS BECKER LTDA",
                        "id": 78568,
                        "createdAt": "2026-09-25T16:00:06.9042734",
                        "clienteId": 131388,
                        "pedido": "2053038483",
                        "dataPedido": "2026-09-22T00:00:00",
                        "previsaoEntrega": "2026-09-28T00:00:00",
                        "previsaoEntregaAjustada": "2026-09-26T00:00:00",
                        "statusPrazo": 1,
                        "statusEntrega": 3
                    },
                    {
                        "tag": "Todos",
                        "codigoCliente": "1420020",
                        "razaoSocial": "LOJAS BECKER LTDA",
                        "id": 78569,
                        "createdAt": "2026-09-25T16:00:06.9042739",
                        "clienteId": 131388,
                        "pedido": "2053038483",
                        "dataPedido": "2026-09-22T00:00:00",
                        "previsaoEntrega": "2026-09-28T00:00:00",
                        "previsaoEntregaAjustada": "2026-09-26T00:00:00",
                        "statusPrazo": 1,
                        "statusEntrega": 3
                    },
                    {
                        "tag": "Todos",
                        "codigoCliente": "1420020",
                        "razaoSocial": "LOJAS BECKER LTDA",
                        "id": 78570,
                        "createdAt": "2026-09-25T16:00:06.9042744",
                        "clienteId": 131388,
                        "pedido": "2053038483",
                        "dataPedido": "2026-09-22T00:00:00",
                        "previsaoEntrega": "2026-09-28T00:00:00",
                        "previsaoEntregaAjustada": "2026-09-26T00:00:00",
                        "statusPrazo": 1,
                        "statusEntrega": 3
                    },
                    {
                        "tag": "Todos",
                        "codigoCliente": "1532734",
                        "razaoSocial": "MARCOS FLAVIO DO NASCIMENTO SILVA",
                        "id": 81047,
                        "createdAt": "2026-09-25T16:00:06.911577",
                        "clienteId": 137373,
                        "pedido": "2052948255",
                        "dataPedido": "2026-09-15T00:00:00",
                        "previsaoEntrega": "2026-09-21T00:00:00",
                        "previsaoEntregaAjustada": "2026-09-25T00:00:00",
                        "statusPrazo": 1,
                        "statusEntrega": 3
                    },
                    {
                        "tag": "Todos",
                        "codigoCliente": "1532734",
                        "razaoSocial": "MARCOS FLAVIO DO NASCIMENTO SILVA",
                        "id": 81048,
                        "createdAt": "2026-09-25T16:00:06.9115777",
                        "clienteId": 137373,
                        "pedido": "2052948255",
                        "dataPedido": "2026-09-15T00:00:00",
                        "previsaoEntrega": "2026-09-21T00:00:00",
                        "previsaoEntregaAjustada": "2026-09-25T00:00:00",
                        "statusPrazo": 1,
                        "statusEntrega": 3
                    },
                    {
                        "tag": "Todos",
                        "codigoCliente": "1532734",
                        "razaoSocial": "MARCOS FLAVIO DO NASCIMENTO SILVA",
                        "id": 81049,
                        "createdAt": "2026-09-25T16:00:06.9115782",
                        "clienteId": 137373,
                        "pedido": "2052948255",
                        "dataPedido": "2026-09-15T00:00:00",
                        "previsaoEntrega": "2026-09-21T00:00:00",
                        "previsaoEntregaAjustada": "2026-09-25T00:00:00",
                        "statusPrazo": 1,
                        "statusEntrega": 3
                    },
                    {
                        "tag": "Todos",
                        "codigoCliente": "1451874",
                        "razaoSocial": "TATIANE DORNELES DE LIMA LTDA",
                        "id": 81283,
                        "createdAt": "2026-09-25T16:00:06.9117257",
                        "clienteId": 134684,
                        "pedido": "2052964800",
                        "dataPedido": "2026-09-16T00:00:00",
                        "previsaoEntrega": "2026-09-21T00:00:00",
                        "previsaoEntregaAjustada": "2026-09-25T00:00:00",
                        "statusPrazo": 1,
                        "statusEntrega": 3
                    },
                    {
                        "tag": "Todos",
                        "codigoCliente": "1451874",
                        "razaoSocial": "TATIANE DORNELES DE LIMA LTDA",
                        "id": 81284,
                        "createdAt": "2026-09-25T16:00:06.9117265",
                        "clienteId": 134684,
                        "pedido": "2052964800",
                        "dataPedido": "2026-09-16T00:00:00",
                        "previsaoEntrega": "2026-09-21T00:00:00",
                        "previsaoEntregaAjustada": "2026-09-25T00:00:00",
                        "statusPrazo": 1,
                        "statusEntrega": 3
                    },
                    {
                        "tag": "Todos",
                        "codigoCliente": "1451874",
                        "razaoSocial": "TATIANE DORNELES DE LIMA LTDA",
                        "id": 81285,
                        "createdAt": "2026-09-25T16:00:06.9117272",
                        "clienteId": 134684,
                        "pedido": "2052964800",
                        "dataPedido": "2026-09-16T00:00:00",
                        "previsaoEntrega": "2026-09-21T00:00:00",
                        "previsaoEntregaAjustada": "2026-09-25T00:00:00",
                        "statusPrazo": 1,
                        "statusEntrega": 3
                    },
                    {
                        "tag": "Todos",
                        "codigoCliente": "1054502",
                        "razaoSocial": "LOJAS QUERO QUERO S A",
                        "id": 84791,
                        "createdAt": "2026-09-25T16:00:06.9138627",
                        "clienteId": 135314,
                        "pedido": "2052941202",
                        "dataPedido": "2026-09-14T00:00:00",
                        "previsaoEntrega": "2026-09-28T00:00:00",
                        "previsaoEntregaAjustada": "2026-09-28T00:00:00",
                        "statusPrazo": 1,
                        "statusEntrega": 2
                    },
                    {
                        "tag": "Todos",
                        "codigoCliente": "1054502",
                        "razaoSocial": "LOJAS QUERO QUERO S A",
                        "id": 84792,
                        "createdAt": "2026-09-25T16:00:06.9138633",
                        "clienteId": 135314,
                        "pedido": "2052941202",
                        "dataPedido": "2026-09-14T00:00:00",
                        "previsaoEntrega": "2026-09-28T00:00:00",
                        "previsaoEntregaAjustada": "2026-09-28T00:00:00",
                        "statusPrazo": 1,
                        "statusEntrega": 2
                    },
                    {
                        "tag": "Todos",
                        "codigoCliente": "1054502",
                        "razaoSocial": "LOJAS QUERO QUERO S A",
                        "id": 84793,
                        "createdAt": "2026-09-25T16:00:06.9138638",
                        "clienteId": 135314,
                        "pedido": "2052941202",
                        "dataPedido": "2026-09-14T00:00:00",
                        "previsaoEntrega": "2026-09-28T00:00:00",
                        "previsaoEntregaAjustada": "2026-09-28T00:00:00",
                        "statusPrazo": 1,
                        "statusEntrega": 2
                    },
                    {
                        "tag": "Todos",
                        "codigoCliente": "1056370",
                        "razaoSocial": "LOJAS BECKER LTDA",
                        "id": 84822,
                        "createdAt": "2026-09-25T16:00:06.9138809",
                        "clienteId": 131411,
                        "pedido": "2052949866",
                        "dataPedido": "2026-09-15T00:00:00",
                        "previsaoEntrega": "2026-09-21T00:00:00",
                        "previsaoEntregaAjustada": "2026-09-24T00:00:00",
                        "statusPrazo": 2,
                        "statusEntrega": 2
                    },
                    {
                        "tag": "Todos",
                        "codigoCliente": "1056370",
                        "razaoSocial": "LOJAS BECKER LTDA",
                        "id": 84823,
                        "createdAt": "2026-09-25T16:00:06.9138816",
                        "clienteId": 131411,
                        "pedido": "2052949866",
                        "dataPedido": "2026-09-15T00:00:00",
                        "previsaoEntrega": "2026-09-21T00:00:00",
                        "previsaoEntregaAjustada": "2026-09-24T00:00:00",
                        "statusPrazo": 2,
                        "statusEntrega": 2
                    },
                    {
                        "tag": "Todos",
                        "codigoCliente": "1056370",
                        "razaoSocial": "LOJAS BECKER LTDA",
                        "id": 84824,
                        "createdAt": "2026-09-25T16:00:06.9138821",
                        "clienteId": 131411,
                        "pedido": "2052949866",
                        "dataPedido": "2026-09-15T00:00:00",
                        "previsaoEntrega": "2026-09-21T00:00:00",
                        "previsaoEntregaAjustada": "2026-09-24T00:00:00",
                        "statusPrazo": 2,
                        "statusEntrega": 2
                    },
                    {
                        "tag": "Todos",
                        "codigoCliente": "1056370",
                        "razaoSocial": "LOJAS BECKER LTDA",
                        "id": 84825,
                        "createdAt": "2026-09-25T16:00:06.9138829",
                        "clienteId": 131411,
                        "pedido": "2053070222",
                        "dataPedido": "2026-09-24T00:00:00",
                        "previsaoEntrega": "2026-10-05T00:00:00",
                        "previsaoEntregaAjustada": "2026-10-05T00:00:00",
                        "statusPrazo": 1,
                        "statusEntrega": 2
                    },
                    {
                        "tag": "Todos",
                        "codigoCliente": "1056370",
                        "razaoSocial": "LOJAS BECKER LTDA",
                        "id": 84826,
                        "createdAt": "2026-09-25T16:00:06.9138836",
                        "clienteId": 131411,
                        "pedido": "2053070222",
                        "dataPedido": "2026-09-24T00:00:00",
                        "previsaoEntrega": "2026-10-05T00:00:00",
                        "previsaoEntregaAjustada": "2026-10-05T00:00:00",
                        "statusPrazo": 1,
                        "statusEntrega": 2
                    },
                    {
                        "tag": "Todos",
                        "codigoCliente": "1056370",
                        "razaoSocial": "LOJAS BECKER LTDA",
                        "id": 84827,
                        "createdAt": "2026-09-25T16:00:06.9138844",
                        "clienteId": 131411,
                        "pedido": "2053070222",
                        "dataPedido": "2026-09-24T00:00:00",
                        "previsaoEntrega": "2026-10-05T00:00:00",
                        "previsaoEntregaAjustada": "2026-10-05T00:00:00",
                        "statusPrazo": 1,
                        "statusEntrega": 2
                    },
                    {
                        "tag": "Todos",
                        "codigoCliente": "1117780",
                        "razaoSocial": "LOJAS BECKER LTDA",
                        "id": 84977,
                        "createdAt": "2026-09-25T16:00:06.9139757",
                        "clienteId": 131408,
                        "pedido": "2052968008",
                        "dataPedido": "2026-09-16T00:00:00",
                        "previsaoEntrega": "2026-09-25T00:00:00",
                        "previsaoEntregaAjustada": "2026-09-25T00:00:00",
                        "statusPrazo": 1,
                        "statusEntrega": 2
                    },
                    {
                        "tag": "Todos",
                        "codigoCliente": "1117780",
                        "razaoSocial": "LOJAS BECKER LTDA",
                        "id": 84978,
                        "createdAt": "2026-09-25T16:00:06.9139764",
                        "clienteId": 131408,
                        "pedido": "2052968008",
                        "dataPedido": "2026-09-16T00:00:00",
                        "previsaoEntrega": "2026-09-25T00:00:00",
                        "previsaoEntregaAjustada": "2026-09-25T00:00:00",
                        "statusPrazo": 1,
                        "statusEntrega": 2
                    },
                    {
                        "tag": "Todos",
                        "codigoCliente": "1117780",
                        "razaoSocial": "LOJAS BECKER LTDA",
                        "id": 84979,
                        "createdAt": "2026-09-25T16:00:06.9139769",
                        "clienteId": 131408,
                        "pedido": "2052968008",
                        "dataPedido": "2026-09-16T00:00:00",
                        "previsaoEntrega": "2026-09-25T00:00:00",
                        "previsaoEntregaAjustada": "2026-09-25T00:00:00",
                        "statusPrazo": 1,
                        "statusEntrega": 2
                    },
                    {
                        "tag": "Todos",
                        "codigoCliente": "1580154",
                        "razaoSocial": "LOJAS QUERO QUERO S A",
                        "id": 85021,
                        "createdAt": "2026-09-25T16:00:06.9140038",
                        "clienteId": 131394,
                        "pedido": "2052985544",
                        "dataPedido": "2026-09-17T00:00:00",
                        "previsaoEntrega": "2026-09-22T00:00:00",
                        "previsaoEntregaAjustada": "2026-09-25T00:00:00",
                        "statusPrazo": 1,
                        "statusEntrega": 2
                    },
                    {
                        "tag": "Todos",
                        "codigoCliente": "1580154",
                        "razaoSocial": "LOJAS QUERO QUERO S A",
                        "id": 85022,
                        "createdAt": "2026-09-25T16:00:06.9140044",
                        "clienteId": 131394,
                        "pedido": "2052985544",
                        "dataPedido": "2026-09-17T00:00:00",
                        "previsaoEntrega": "2026-09-22T00:00:00",
                        "previsaoEntregaAjustada": "2026-09-25T00:00:00",
                        "statusPrazo": 1,
                        "statusEntrega": 2
                    },
                    {
                        "tag": "Todos",
                        "codigoCliente": "1580154",
                        "razaoSocial": "LOJAS QUERO QUERO S A",
                        "id": 85023,
                        "createdAt": "2026-09-25T16:00:06.9140048",
                        "clienteId": 131394,
                        "pedido": "2052985544",
                        "dataPedido": "2026-09-17T00:00:00",
                        "previsaoEntrega": "2026-09-22T00:00:00",
                        "previsaoEntregaAjustada": "2026-09-25T00:00:00",
                        "statusPrazo": 1,
                        "statusEntrega": 2
                    },
                    {
                        "tag": "Todos",
                        "codigoCliente": "1580154",
                        "razaoSocial": "LOJAS QUERO QUERO S A",
                        "id": 85024,
                        "createdAt": "2026-09-25T16:00:06.9140054",
                        "clienteId": 131394,
                        "pedido": "2052985544",
                        "dataPedido": "2026-09-17T00:00:00",
                        "previsaoEntrega": "2026-09-22T00:00:00",
                        "previsaoEntregaAjustada": "2026-09-25T00:00:00",
                        "statusPrazo": 1,
                        "statusEntrega": 2
                    },
                    {
                        "tag": "Todos",
                        "codigoCliente": "1580154",
                        "razaoSocial": "LOJAS QUERO QUERO S A",
                        "id": 85025,
                        "createdAt": "2026-09-25T16:00:06.9140059",
                        "clienteId": 131394,
                        "pedido": "2052985544",
                        "dataPedido": "2026-09-17T00:00:00",
                        "previsaoEntrega": "2026-09-22T00:00:00",
                        "previsaoEntregaAjustada": "2026-09-25T00:00:00",
                        "statusPrazo": 1,
                        "statusEntrega": 2
                    },
                    {
                        "tag": "Todos",
                        "codigoCliente": "1580154",
                        "razaoSocial": "LOJAS QUERO QUERO S A",
                        "id": 85026,
                        "createdAt": "2026-09-25T16:00:06.9140066",
                        "clienteId": 131394,
                        "pedido": "2052970854",
                        "dataPedido": "2026-09-16T00:00:00",
                        "previsaoEntrega": "2026-09-22T00:00:00",
                        "previsaoEntregaAjustada": "2026-09-25T00:00:00",
                        "statusPrazo": 1,
                        "statusEntrega": 2
                    },
                    {
                        "tag": "Todos",
                        "codigoCliente": "1580154",
                        "razaoSocial": "LOJAS QUERO QUERO S A",
                        "id": 85027,
                        "createdAt": "2026-09-25T16:00:06.9140071",
                        "clienteId": 131394,
                        "pedido": "2052970854",
                        "dataPedido": "2026-09-16T00:00:00",
                        "previsaoEntrega": "2026-09-22T00:00:00",
                        "previsaoEntregaAjustada": "2026-09-25T00:00:00",
                        "statusPrazo": 1,
                        "statusEntrega": 2
                    },
                    {
                        "tag": "Todos",
                        "codigoCliente": "1580154",
                        "razaoSocial": "LOJAS QUERO QUERO S A",
                        "id": 85028,
                        "createdAt": "2026-09-25T16:00:06.9140078",
                        "clienteId": 131394,
                        "pedido": "2052970854",
                        "dataPedido": "2026-09-16T00:00:00",
                        "previsaoEntrega": "2026-09-22T00:00:00",
                        "previsaoEntregaAjustada": "2026-09-25T00:00:00",
                        "statusPrazo": 1,
                        "statusEntrega": 2
                    },
                    {
                        "tag": "Todos",
                        "codigoCliente": "1580154",
                        "razaoSocial": "LOJAS QUERO QUERO S A",
                        "id": 85029,
                        "createdAt": "2026-09-25T16:00:06.9140084",
                        "clienteId": 131394,
                        "pedido": "2052970854",
                        "dataPedido": "2026-09-16T00:00:00",
                        "previsaoEntrega": "2026-09-22T00:00:00",
                        "previsaoEntregaAjustada": "2026-09-25T00:00:00",
                        "statusPrazo": 1,
                        "statusEntrega": 2
                    },
                    {
                        "tag": "Todos",
                        "codigoCliente": "1580154",
                        "razaoSocial": "LOJAS QUERO QUERO S A",
                        "id": 85030,
                        "createdAt": "2026-09-25T16:00:06.914009",
                        "clienteId": 131394,
                        "pedido": "2052970854",
                        "dataPedido": "2026-09-16T00:00:00",
                        "previsaoEntrega": "2026-09-22T00:00:00",
                        "previsaoEntregaAjustada": "2026-09-25T00:00:00",
                        "statusPrazo": 1,
                        "statusEntrega": 2
                    },
                    {
                        "tag": "Todos",
                        "codigoCliente": "1399446",
                        "razaoSocial": "RIGHES & CIA LTDA",
                        "id": 85117,
                        "createdAt": "2026-09-25T16:00:06.9140617",
                        "clienteId": 318829,
                        "pedido": "2052984411",
                        "dataPedido": "2026-09-17T00:00:00",
                        "previsaoEntrega": "2026-09-22T00:00:00",
                        "previsaoEntregaAjustada": "2026-09-25T00:00:00",
                        "statusPrazo": 1,
                        "statusEntrega": 2
                    },
                    {
                        "tag": "Todos",
                        "codigoCliente": "1399446",
                        "razaoSocial": "RIGHES & CIA LTDA",
                        "id": 85118,
                        "createdAt": "2026-09-25T16:00:06.9140623",
                        "clienteId": 318829,
                        "pedido": "2052984411",
                        "dataPedido": "2026-09-17T00:00:00",
                        "previsaoEntrega": "2026-09-22T00:00:00",
                        "previsaoEntregaAjustada": "2026-09-25T00:00:00",
                        "statusPrazo": 1,
                        "statusEntrega": 2
                    },
                    {
                        "tag": "Todos",
                        "codigoCliente": "1399446",
                        "razaoSocial": "RIGHES & CIA LTDA",
                        "id": 85119,
                        "createdAt": "2026-09-25T16:00:06.9140628",
                        "clienteId": 318829,
                        "pedido": "2052984411",
                        "dataPedido": "2026-09-17T00:00:00",
                        "previsaoEntrega": "2026-09-22T00:00:00",
                        "previsaoEntregaAjustada": "2026-09-25T00:00:00",
                        "statusPrazo": 1,
                        "statusEntrega": 2
                    },
                    {
                        "tag": "Todos",
                        "codigoCliente": "1399446",
                        "razaoSocial": "RIGHES & CIA LTDA",
                        "id": 85120,
                        "createdAt": "2026-09-25T16:00:06.9140634",
                        "clienteId": 318829,
                        "pedido": "2052984411",
                        "dataPedido": "2026-09-17T00:00:00",
                        "previsaoEntrega": "2026-09-22T00:00:00",
                        "previsaoEntregaAjustada": "2026-09-25T00:00:00",
                        "statusPrazo": 1,
                        "statusEntrega": 2
                    },
                    {
                        "tag": "Todos",
                        "codigoCliente": "1399446",
                        "razaoSocial": "RIGHES & CIA LTDA",
                        "id": 85121,
                        "createdAt": "2026-09-25T16:00:06.9140639",
                        "clienteId": 318829,
                        "pedido": "2052984411",
                        "dataPedido": "2026-09-17T00:00:00",
                        "previsaoEntrega": "2026-09-22T00:00:00",
                        "previsaoEntregaAjustada": "2026-09-25T00:00:00",
                        "statusPrazo": 1,
                        "statusEntrega": 2
                    },
                    {
                        "tag": "Todos",
                        "codigoCliente": "1891376",
                        "razaoSocial": "RAQUEL FERREIRA BITTENCOURTE",
                        "id": 85276,
                        "createdAt": "2026-09-25T16:00:06.9141574",
                        "clienteId": 1111525,
                        "pedido": "2052999180",
                        "dataPedido": "2026-09-18T00:00:00",
                        "previsaoEntrega": "2026-09-25T00:00:00",
                        "previsaoEntregaAjustada": "2026-09-25T00:00:00",
                        "statusPrazo": 1,
                        "statusEntrega": 2
                    },
                    {
                        "tag": "Todos",
                        "codigoCliente": "1891376",
                        "razaoSocial": "RAQUEL FERREIRA BITTENCOURTE",
                        "id": 85277,
                        "createdAt": "2026-09-25T16:00:06.9141582",
                        "clienteId": 1111525,
                        "pedido": "2052999180",
                        "dataPedido": "2026-09-18T00:00:00",
                        "previsaoEntrega": "2026-09-25T00:00:00",
                        "previsaoEntregaAjustada": "2026-09-25T00:00:00",
                        "statusPrazo": 1,
                        "statusEntrega": 2
                    },
                    {
                        "tag": "Todos",
                        "codigoCliente": "1891376",
                        "razaoSocial": "RAQUEL FERREIRA BITTENCOURTE",
                        "id": 85278,
                        "createdAt": "2026-09-25T16:00:06.9141588",
                        "clienteId": 1111525,
                        "pedido": "2052999180",
                        "dataPedido": "2026-09-18T00:00:00",
                        "previsaoEntrega": "2026-09-25T00:00:00",
                        "previsaoEntregaAjustada": "2026-09-25T00:00:00",
                        "statusPrazo": 1,
                        "statusEntrega": 2
                    },
                    {
                        "tag": "Todos",
                        "codigoCliente": "1891376",
                        "razaoSocial": "RAQUEL FERREIRA BITTENCOURTE",
                        "id": 85279,
                        "createdAt": "2026-09-25T16:00:06.9141594",
                        "clienteId": 1111525,
                        "pedido": "2052999180",
                        "dataPedido": "2026-09-18T00:00:00",
                        "previsaoEntrega": "2026-09-25T00:00:00",
                        "previsaoEntregaAjustada": "2026-09-25T00:00:00",
                        "statusPrazo": 1,
                        "statusEntrega": 2
                    },
                    {
                        "tag": "Todos",
                        "codigoCliente": "1495967",
                        "razaoSocial": "LOJAS QUERO QUERO S A",
                        "id": 85429,
                        "createdAt": "2026-09-25T16:00:06.9142489",
                        "clienteId": 331105,
                        "pedido": "2053010207",
                        "dataPedido": "2026-09-18T00:00:00",
                        "previsaoEntrega": "2026-09-28T00:00:00",
                        "previsaoEntregaAjustada": "2026-09-28T00:00:00",
                        "statusPrazo": 1,
                        "statusEntrega": 2
                    },
                    {
                        "tag": "Todos",
                        "codigoCliente": "1495967",
                        "razaoSocial": "LOJAS QUERO QUERO S A",
                        "id": 85430,
                        "createdAt": "2026-09-25T16:00:06.9142495",
                        "clienteId": 331105,
                        "pedido": "2053010207",
                        "dataPedido": "2026-09-18T00:00:00",
                        "previsaoEntrega": "2026-09-28T00:00:00",
                        "previsaoEntregaAjustada": "2026-09-28T00:00:00",
                        "statusPrazo": 1,
                        "statusEntrega": 2
                    },
                    {
                        "tag": "Todos",
                        "codigoCliente": "1495967",
                        "razaoSocial": "LOJAS QUERO QUERO S A",
                        "id": 85431,
                        "createdAt": "2026-09-25T16:00:06.9142501",
                        "clienteId": 331105,
                        "pedido": "2053010207",
                        "dataPedido": "2026-09-18T00:00:00",
                        "previsaoEntrega": "2026-09-28T00:00:00",
                        "previsaoEntregaAjustada": "2026-09-28T00:00:00",
                        "statusPrazo": 1,
                        "statusEntrega": 2
                    },
                    {
                        "tag": "Todos",
                        "codigoCliente": "1495967",
                        "razaoSocial": "LOJAS QUERO QUERO S A",
                        "id": 85432,
                        "createdAt": "2026-09-25T16:00:06.9142506",
                        "clienteId": 331105,
                        "pedido": "2053010207",
                        "dataPedido": "2026-09-18T00:00:00",
                        "previsaoEntrega": "2026-09-28T00:00:00",
                        "previsaoEntregaAjustada": "2026-09-28T00:00:00",
                        "statusPrazo": 1,
                        "statusEntrega": 2
                    },
                    {
                        "tag": "Todos",
                        "codigoCliente": "1495967",
                        "razaoSocial": "LOJAS QUERO QUERO S A",
                        "id": 85433,
                        "createdAt": "2026-09-25T16:00:06.9142511",
                        "clienteId": 331105,
                        "pedido": "2053010207",
                        "dataPedido": "2026-09-18T00:00:00",
                        "previsaoEntrega": "2026-09-28T00:00:00",
                        "previsaoEntregaAjustada": "2026-09-28T00:00:00",
                        "statusPrazo": 1,
                        "statusEntrega": 2
                    },
                    {
                        "tag": "Todos",
                        "codigoCliente": "1495967",
                        "razaoSocial": "LOJAS QUERO QUERO S A",
                        "id": 85434,
                        "createdAt": "2026-09-25T16:00:06.9142517",
                        "clienteId": 331105,
                        "pedido": "2053010211",
                        "dataPedido": "2026-09-18T00:00:00",
                        "previsaoEntrega": "2026-09-28T00:00:00",
                        "previsaoEntregaAjustada": "2026-09-28T00:00:00",
                        "statusPrazo": 1,
                        "statusEntrega": 2
                    },
                    {
                        "tag": "Todos",
                        "codigoCliente": "1495967",
                        "razaoSocial": "LOJAS QUERO QUERO S A",
                        "id": 85435,
                        "createdAt": "2026-09-25T16:00:06.9142524",
                        "clienteId": 331105,
                        "pedido": "2053010211",
                        "dataPedido": "2026-09-18T00:00:00",
                        "previsaoEntrega": "2026-09-28T00:00:00",
                        "previsaoEntregaAjustada": "2026-09-28T00:00:00",
                        "statusPrazo": 1,
                        "statusEntrega": 2
                    },
                    {
                        "tag": "Todos",
                        "codigoCliente": "1495967",
                        "razaoSocial": "LOJAS QUERO QUERO S A",
                        "id": 85436,
                        "createdAt": "2026-09-25T16:00:06.9142529",
                        "clienteId": 331105,
                        "pedido": "2053010211",
                        "dataPedido": "2026-09-18T00:00:00",
                        "previsaoEntrega": "2026-09-28T00:00:00",
                        "previsaoEntregaAjustada": "2026-09-28T00:00:00",
                        "statusPrazo": 1,
                        "statusEntrega": 2
                    },
                    {
                        "tag": "Todos",
                        "codigoCliente": "1495967",
                        "razaoSocial": "LOJAS QUERO QUERO S A",
                        "id": 85437,
                        "createdAt": "2026-09-25T16:00:06.9142534",
                        "clienteId": 331105,
                        "pedido": "2053010211",
                        "dataPedido": "2026-09-18T00:00:00",
                        "previsaoEntrega": "2026-09-28T00:00:00",
                        "previsaoEntregaAjustada": "2026-09-28T00:00:00",
                        "statusPrazo": 1,
                        "statusEntrega": 2
                    },
                    {
                        "tag": "Todos",
                        "codigoCliente": "1495967",
                        "razaoSocial": "LOJAS QUERO QUERO S A",
                        "id": 85438,
                        "createdAt": "2026-09-25T16:00:06.9142541",
                        "clienteId": 331105,
                        "pedido": "2053010211",
                        "dataPedido": "2026-09-18T00:00:00",
                        "previsaoEntrega": "2026-09-28T00:00:00",
                        "previsaoEntregaAjustada": "2026-09-28T00:00:00",
                        "statusPrazo": 1,
                        "statusEntrega": 2
                    },
                    {
                        "tag": "Todos",
                        "codigoCliente": "1056120",
                        "razaoSocial": "LOJAS BECKER LTDA",
                        "id": 85610,
                        "createdAt": "2026-09-25T16:00:06.9143576",
                        "clienteId": 131410,
                        "pedido": "2053023192",
                        "dataPedido": "2026-09-21T00:00:00",
                        "previsaoEntrega": "2026-09-25T00:00:00",
                        "previsaoEntregaAjustada": "2026-09-25T00:00:00",
                        "statusPrazo": 1,
                        "statusEntrega": 2
                    },
                    {
                        "tag": "Todos",
                        "codigoCliente": "1056120",
                        "razaoSocial": "LOJAS BECKER LTDA",
                        "id": 85611,
                        "createdAt": "2026-09-25T16:00:06.9143584",
                        "clienteId": 131410,
                        "pedido": "2053023192",
                        "dataPedido": "2026-09-21T00:00:00",
                        "previsaoEntrega": "2026-09-25T00:00:00",
                        "previsaoEntregaAjustada": "2026-09-25T00:00:00",
                        "statusPrazo": 1,
                        "statusEntrega": 2
                    },
                    {
                        "tag": "Todos",
                        "codigoCliente": "1056120",
                        "razaoSocial": "LOJAS BECKER LTDA",
                        "id": 85612,
                        "createdAt": "2026-09-25T16:00:06.9143592",
                        "clienteId": 131410,
                        "pedido": "2053023192",
                        "dataPedido": "2026-09-21T00:00:00",
                        "previsaoEntrega": "2026-09-25T00:00:00",
                        "previsaoEntregaAjustada": "2026-09-25T00:00:00",
                        "statusPrazo": 1,
                        "statusEntrega": 2
                    },
                    {
                        "tag": "Todos",
                        "codigoCliente": "1169330",
                        "razaoSocial": "LOJAS BECKER LTDA",
                        "id": 85709,
                        "createdAt": "2026-09-25T16:00:06.9144163",
                        "clienteId": 131819,
                        "pedido": "2053028707",
                        "dataPedido": "2026-09-21T00:00:00",
                        "previsaoEntrega": "2026-09-24T00:00:00",
                        "previsaoEntregaAjustada": "2026-09-28T00:00:00",
                        "statusPrazo": 1,
                        "statusEntrega": 2
                    },
                    {
                        "tag": "Todos",
                        "codigoCliente": "1169330",
                        "razaoSocial": "LOJAS BECKER LTDA",
                        "id": 85710,
                        "createdAt": "2026-09-25T16:00:06.914417",
                        "clienteId": 131819,
                        "pedido": "2053028707",
                        "dataPedido": "2026-09-21T00:00:00",
                        "previsaoEntrega": "2026-09-24T00:00:00",
                        "previsaoEntregaAjustada": "2026-09-28T00:00:00",
                        "statusPrazo": 1,
                        "statusEntrega": 2
                    },
                    {
                        "tag": "Todos",
                        "codigoCliente": "1169330",
                        "razaoSocial": "LOJAS BECKER LTDA",
                        "id": 85711,
                        "createdAt": "2026-09-25T16:00:06.9144176",
                        "clienteId": 131819,
                        "pedido": "2053028707",
                        "dataPedido": "2026-09-21T00:00:00",
                        "previsaoEntrega": "2026-09-24T00:00:00",
                        "previsaoEntregaAjustada": "2026-09-28T00:00:00",
                        "statusPrazo": 1,
                        "statusEntrega": 2
                    },
                    {
                        "tag": "Todos",
                        "codigoCliente": "1169330",
                        "razaoSocial": "LOJAS BECKER LTDA",
                        "id": 85712,
                        "createdAt": "2026-09-25T16:00:06.9144183",
                        "clienteId": 131819,
                        "pedido": "2053028707",
                        "dataPedido": "2026-09-21T00:00:00",
                        "previsaoEntrega": "2026-09-24T00:00:00",
                        "previsaoEntregaAjustada": "2026-09-28T00:00:00",
                        "statusPrazo": 1,
                        "statusEntrega": 2
                    },
                    {
                        "tag": "Todos",
                        "codigoCliente": "1169330",
                        "razaoSocial": "LOJAS BECKER LTDA",
                        "id": 85713,
                        "createdAt": "2026-09-25T16:00:06.9144189",
                        "clienteId": 131819,
                        "pedido": "2053028707",
                        "dataPedido": "2026-09-21T00:00:00",
                        "previsaoEntrega": "2026-09-24T00:00:00",
                        "previsaoEntregaAjustada": "2026-09-28T00:00:00",
                        "statusPrazo": 1,
                        "statusEntrega": 2
                    },
                    {
                        "tag": "Todos",
                        "codigoCliente": "1169330",
                        "razaoSocial": "LOJAS BECKER LTDA",
                        "id": 85714,
                        "createdAt": "2026-09-25T16:00:06.9144196",
                        "clienteId": 131819,
                        "pedido": "2053028707",
                        "dataPedido": "2026-09-21T00:00:00",
                        "previsaoEntrega": "2026-09-24T00:00:00",
                        "previsaoEntregaAjustada": "2026-09-28T00:00:00",
                        "statusPrazo": 1,
                        "statusEntrega": 2
                    },
                    {
                        "tag": "Todos",
                        "codigoCliente": "1048434",
                        "razaoSocial": "LOJAS BECKER LTDA",
                        "id": 85717,
                        "createdAt": "2026-09-25T16:00:06.9144215",
                        "clienteId": 131402,
                        "pedido": "2053029476",
                        "dataPedido": "2026-09-21T00:00:00",
                        "previsaoEntrega": "2026-09-28T00:00:00",
                        "previsaoEntregaAjustada": "2026-09-28T00:00:00",
                        "statusPrazo": 1,
                        "statusEntrega": 2
                    },
                    {
                        "tag": "Todos",
                        "codigoCliente": "1048434",
                        "razaoSocial": "LOJAS BECKER LTDA",
                        "id": 85718,
                        "createdAt": "2026-09-25T16:00:06.9144223",
                        "clienteId": 131402,
                        "pedido": "2053029476",
                        "dataPedido": "2026-09-21T00:00:00",
                        "previsaoEntrega": "2026-09-28T00:00:00",
                        "previsaoEntregaAjustada": "2026-09-28T00:00:00",
                        "statusPrazo": 1,
                        "statusEntrega": 2
                    },
                    {
                        "tag": "Todos",
                        "codigoCliente": "1048434",
                        "razaoSocial": "LOJAS BECKER LTDA",
                        "id": 85719,
                        "createdAt": "2026-09-25T16:00:06.9144229",
                        "clienteId": 131402,
                        "pedido": "2053029476",
                        "dataPedido": "2026-09-21T00:00:00",
                        "previsaoEntrega": "2026-09-28T00:00:00",
                        "previsaoEntregaAjustada": "2026-09-28T00:00:00",
                        "statusPrazo": 1,
                        "statusEntrega": 2
                    },
                    {
                        "tag": "Todos",
                        "codigoCliente": "1260407",
                        "razaoSocial": "LOJAS BECKER LTDA",
                        "id": 85748,
                        "createdAt": "2026-09-25T16:00:06.9144407",
                        "clienteId": 139117,
                        "pedido": "2053030162",
                        "dataPedido": "2026-09-21T00:00:00",
                        "previsaoEntrega": "2026-09-28T00:00:00",
                        "previsaoEntregaAjustada": "2026-09-28T00:00:00",
                        "statusPrazo": 1,
                        "statusEntrega": 2
                    },
                    {
                        "tag": "Todos",
                        "codigoCliente": "1260407",
                        "razaoSocial": "LOJAS BECKER LTDA",
                        "id": 85749,
                        "createdAt": "2026-09-25T16:00:06.9144415",
                        "clienteId": 139117,
                        "pedido": "2053030162",
                        "dataPedido": "2026-09-21T00:00:00",
                        "previsaoEntrega": "2026-09-28T00:00:00",
                        "previsaoEntregaAjustada": "2026-09-28T00:00:00",
                        "statusPrazo": 1,
                        "statusEntrega": 2
                    },
                    {
                        "tag": "Todos",
                        "codigoCliente": "1260407",
                        "razaoSocial": "LOJAS BECKER LTDA",
                        "id": 85750,
                        "createdAt": "2026-09-25T16:00:06.9144421",
                        "clienteId": 139117,
                        "pedido": "2053030162",
                        "dataPedido": "2026-09-21T00:00:00",
                        "previsaoEntrega": "2026-09-28T00:00:00",
                        "previsaoEntregaAjustada": "2026-09-28T00:00:00",
                        "statusPrazo": 1,
                        "statusEntrega": 2
                    },
                    {
                        "tag": "Todos",
                        "codigoCliente": "1123124",
                        "razaoSocial": "LOJAS QUERO QUERO S A",
                        "id": 86400,
                        "createdAt": "2026-09-25T16:00:06.9148293",
                        "clienteId": 131397,
                        "pedido": "2053062943",
                        "dataPedido": "2026-09-23T00:00:00",
                        "previsaoEntrega": "2026-09-28T00:00:00",
                        "previsaoEntregaAjustada": "2026-09-28T00:00:00",
                        "statusPrazo": 1,
                        "statusEntrega": 2
                    },
                    {
                        "tag": "Todos",
                        "codigoCliente": "1123124",
                        "razaoSocial": "LOJAS QUERO QUERO S A",
                        "id": 86401,
                        "createdAt": "2026-09-25T16:00:06.9148298",
                        "clienteId": 131397,
                        "pedido": "2053062943",
                        "dataPedido": "2026-09-23T00:00:00",
                        "previsaoEntrega": "2026-09-28T00:00:00",
                        "previsaoEntregaAjustada": "2026-09-28T00:00:00",
                        "statusPrazo": 1,
                        "statusEntrega": 2
                    },
                    {
                        "tag": "Todos",
                        "codigoCliente": "1123124",
                        "razaoSocial": "LOJAS QUERO QUERO S A",
                        "id": 86402,
                        "createdAt": "2026-09-25T16:00:06.9148304",
                        "clienteId": 131397,
                        "pedido": "2053062943",
                        "dataPedido": "2026-09-23T00:00:00",
                        "previsaoEntrega": "2026-09-28T00:00:00",
                        "previsaoEntregaAjustada": "2026-09-28T00:00:00",
                        "statusPrazo": 1,
                        "statusEntrega": 2
                    },
                    {
                        "tag": "Todos",
                        "codigoCliente": "1123124",
                        "razaoSocial": "LOJAS QUERO QUERO S A",
                        "id": 86403,
                        "createdAt": "2026-09-25T16:00:06.914831",
                        "clienteId": 131397,
                        "pedido": "2053059335",
                        "dataPedido": "2026-09-23T00:00:00",
                        "previsaoEntrega": "2026-09-30T00:00:00",
                        "previsaoEntregaAjustada": "2026-09-30T00:00:00",
                        "statusPrazo": 1,
                        "statusEntrega": 2
                    },
                    {
                        "tag": "Todos",
                        "codigoCliente": "1123124",
                        "razaoSocial": "LOJAS QUERO QUERO S A",
                        "id": 86404,
                        "createdAt": "2026-09-25T16:00:06.9148316",
                        "clienteId": 131397,
                        "pedido": "2053059335",
                        "dataPedido": "2026-09-23T00:00:00",
                        "previsaoEntrega": "2026-09-30T00:00:00",
                        "previsaoEntregaAjustada": "2026-09-30T00:00:00",
                        "statusPrazo": 1,
                        "statusEntrega": 2
                    },
                    {
                        "tag": "Todos",
                        "codigoCliente": "1123124",
                        "razaoSocial": "LOJAS QUERO QUERO S A",
                        "id": 86405,
                        "createdAt": "2026-09-25T16:00:06.9148321",
                        "clienteId": 131397,
                        "pedido": "2053059335",
                        "dataPedido": "2026-09-23T00:00:00",
                        "previsaoEntrega": "2026-09-30T00:00:00",
                        "previsaoEntregaAjustada": "2026-09-30T00:00:00",
                        "statusPrazo": 1,
                        "statusEntrega": 2
                    },
                    {
                        "tag": "Todos",
                        "codigoCliente": "1581874",
                        "razaoSocial": "LOJAS QUERO QUERO S A",
                        "id": 86406,
                        "createdAt": "2026-09-25T16:00:06.9148326",
                        "clienteId": 27696,
                        "pedido": "2053059348",
                        "dataPedido": "2026-09-23T00:00:00",
                        "previsaoEntrega": "2026-09-28T00:00:00",
                        "previsaoEntregaAjustada": "2026-09-28T00:00:00",
                        "statusPrazo": 1,
                        "statusEntrega": 2
                    },
                    {
                        "tag": "Todos",
                        "codigoCliente": "1581874",
                        "razaoSocial": "LOJAS QUERO QUERO S A",
                        "id": 86407,
                        "createdAt": "2026-09-25T16:00:06.9148332",
                        "clienteId": 27696,
                        "pedido": "2053059348",
                        "dataPedido": "2026-09-23T00:00:00",
                        "previsaoEntrega": "2026-09-28T00:00:00",
                        "previsaoEntregaAjustada": "2026-09-28T00:00:00",
                        "statusPrazo": 1,
                        "statusEntrega": 2
                    },
                    {
                        "tag": "Todos",
                        "codigoCliente": "1581874",
                        "razaoSocial": "LOJAS QUERO QUERO S A",
                        "id": 86408,
                        "createdAt": "2026-09-25T16:00:06.9148338",
                        "clienteId": 27696,
                        "pedido": "2053059348",
                        "dataPedido": "2026-09-23T00:00:00",
                        "previsaoEntrega": "2026-09-28T00:00:00",
                        "previsaoEntregaAjustada": "2026-09-28T00:00:00",
                        "statusPrazo": 1,
                        "statusEntrega": 2
                    },
                    {
                        "tag": "Todos",
                        "codigoCliente": "1581874",
                        "razaoSocial": "LOJAS QUERO QUERO S A",
                        "id": 86409,
                        "createdAt": "2026-09-25T16:00:06.9148343",
                        "clienteId": 27696,
                        "pedido": "2053063005",
                        "dataPedido": "2026-09-23T00:00:00",
                        "previsaoEntrega": "2026-09-28T00:00:00",
                        "previsaoEntregaAjustada": "2026-09-28T00:00:00",
                        "statusPrazo": 1,
                        "statusEntrega": 2
                    },
                    {
                        "tag": "Todos",
                        "codigoCliente": "1581874",
                        "razaoSocial": "LOJAS QUERO QUERO S A",
                        "id": 86410,
                        "createdAt": "2026-09-25T16:00:06.9148348",
                        "clienteId": 27696,
                        "pedido": "2053063005",
                        "dataPedido": "2026-09-23T00:00:00",
                        "previsaoEntrega": "2026-09-28T00:00:00",
                        "previsaoEntregaAjustada": "2026-09-28T00:00:00",
                        "statusPrazo": 1,
                        "statusEntrega": 2
                    },
                    {
                        "tag": "Todos",
                        "codigoCliente": "1581874",
                        "razaoSocial": "LOJAS QUERO QUERO S A",
                        "id": 86411,
                        "createdAt": "2026-09-25T16:00:06.9148354",
                        "clienteId": 27696,
                        "pedido": "2053063005",
                        "dataPedido": "2026-09-23T00:00:00",
                        "previsaoEntrega": "2026-09-28T00:00:00",
                        "previsaoEntregaAjustada": "2026-09-28T00:00:00",
                        "statusPrazo": 1,
                        "statusEntrega": 2
                    },
                    {
                        "tag": "Todos",
                        "codigoCliente": "1402049",
                        "razaoSocial": "CAZAROTTO & CIA LTDA",
                        "id": 86843,
                        "createdAt": "2026-09-25T16:00:06.915101",
                        "clienteId": 134708,
                        "pedido": "2053069472",
                        "dataPedido": "2026-09-24T00:00:00",
                        "previsaoEntrega": "2026-09-29T00:00:00",
                        "previsaoEntregaAjustada": "2026-09-29T00:00:00",
                        "statusPrazo": 1,
                        "statusEntrega": 2
                    },
                    {
                        "tag": "Todos",
                        "codigoCliente": "1402049",
                        "razaoSocial": "CAZAROTTO & CIA LTDA",
                        "id": 86844,
                        "createdAt": "2026-09-25T16:00:06.9151017",
                        "clienteId": 134708,
                        "pedido": "2053069472",
                        "dataPedido": "2026-09-24T00:00:00",
                        "previsaoEntrega": "2026-09-29T00:00:00",
                        "previsaoEntregaAjustada": "2026-09-29T00:00:00",
                        "statusPrazo": 1,
                        "statusEntrega": 2
                    },
                    {
                        "tag": "Todos",
                        "codigoCliente": "1402049",
                        "razaoSocial": "CAZAROTTO & CIA LTDA",
                        "id": 86845,
                        "createdAt": "2026-09-25T16:00:06.9151022",
                        "clienteId": 134708,
                        "pedido": "2053069472",
                        "dataPedido": "2026-09-24T00:00:00",
                        "previsaoEntrega": "2026-09-29T00:00:00",
                        "previsaoEntregaAjustada": "2026-09-29T00:00:00",
                        "statusPrazo": 1,
                        "statusEntrega": 2
                    },
                    {
                        "tag": "Todos",
                        "codigoCliente": "1579945",
                        "razaoSocial": "LOJAS BECKER LTDA",
                        "id": 87175,
                        "createdAt": "2026-09-25T16:00:06.9153094",
                        "clienteId": 131393,
                        "pedido": "2053071503",
                        "dataPedido": "2026-09-24T00:00:00",
                        "previsaoEntrega": "2026-10-02T00:00:00",
                        "previsaoEntregaAjustada": "2026-10-02T00:00:00",
                        "statusPrazo": 1,
                        "statusEntrega": 2
                    },
                    {
                        "tag": "Todos",
                        "codigoCliente": "1579945",
                        "razaoSocial": "LOJAS BECKER LTDA",
                        "id": 87176,
                        "createdAt": "2026-09-25T16:00:06.9153105",
                        "clienteId": 131393,
                        "pedido": "2053071503",
                        "dataPedido": "2026-09-24T00:00:00",
                        "previsaoEntrega": "2026-10-02T00:00:00",
                        "previsaoEntregaAjustada": "2026-10-02T00:00:00",
                        "statusPrazo": 1,
                        "statusEntrega": 2
                    },
                    {
                        "tag": "Todos",
                        "codigoCliente": "1579945",
                        "razaoSocial": "LOJAS BECKER LTDA",
                        "id": 87177,
                        "createdAt": "2026-09-25T16:00:06.915311",
                        "clienteId": 131393,
                        "pedido": "2053071503",
                        "dataPedido": "2026-09-24T00:00:00",
                        "previsaoEntrega": "2026-10-02T00:00:00",
                        "previsaoEntregaAjustada": "2026-10-02T00:00:00",
                        "statusPrazo": 1,
                        "statusEntrega": 2
                    },
                    {
                        "tag": "Todos",
                        "codigoCliente": "1064441",
                        "razaoSocial": "TORRES COMERCIO DE MATERIAL DE",
                        "id": 87257,
                        "createdAt": "2026-09-25T16:00:06.9153539",
                        "clienteId": 137219,
                        "pedido": "2053072214",
                        "dataPedido": "2026-09-24T00:00:00",
                        "previsaoEntrega": "2026-09-30T00:00:00",
                        "previsaoEntregaAjustada": "2026-09-30T00:00:00",
                        "statusPrazo": 1,
                        "statusEntrega": 2
                    },
                    {
                        "tag": "Todos",
                        "codigoCliente": "1064441",
                        "razaoSocial": "TORRES COMERCIO DE MATERIAL DE",
                        "id": 87258,
                        "createdAt": "2026-09-25T16:00:06.9153544",
                        "clienteId": 137219,
                        "pedido": "2053072214",
                        "dataPedido": "2026-09-24T00:00:00",
                        "previsaoEntrega": "2026-09-30T00:00:00",
                        "previsaoEntregaAjustada": "2026-09-30T00:00:00",
                        "statusPrazo": 1,
                        "statusEntrega": 2
                    },
                    {
                        "tag": "Todos",
                        "codigoCliente": "1064441",
                        "razaoSocial": "TORRES COMERCIO DE MATERIAL DE",
                        "id": 87259,
                        "createdAt": "2026-09-25T16:00:06.9153549",
                        "clienteId": 137219,
                        "pedido": "2053072214",
                        "dataPedido": "2026-09-24T00:00:00",
                        "previsaoEntrega": "2026-09-30T00:00:00",
                        "previsaoEntregaAjustada": "2026-09-30T00:00:00",
                        "statusPrazo": 1,
                        "statusEntrega": 2
                    },
                    {
                        "tag": "Todos",
                        "codigoCliente": "1295404",
                        "razaoSocial": "BARCEMAG FERRAGEM & MATERIAIS DE",
                        "id": 87863,
                        "createdAt": "2026-09-25T16:00:06.9216948",
                        "clienteId": 14107,
                        "pedido": "2053078148",
                        "dataPedido": "2026-09-24T00:00:00",
                        "previsaoEntrega": "2026-09-29T00:00:00",
                        "previsaoEntregaAjustada": "2026-09-29T00:00:00",
                        "statusPrazo": 1,
                        "statusEntrega": 2
                    },
                    {
                        "tag": "Todos",
                        "codigoCliente": "1295404",
                        "razaoSocial": "BARCEMAG FERRAGEM & MATERIAIS DE",
                        "id": 87864,
                        "createdAt": "2026-09-25T16:00:06.9216955",
                        "clienteId": 14107,
                        "pedido": "2053078148",
                        "dataPedido": "2026-09-24T00:00:00",
                        "previsaoEntrega": "2026-09-29T00:00:00",
                        "previsaoEntregaAjustada": "2026-09-29T00:00:00",
                        "statusPrazo": 1,
                        "statusEntrega": 2
                    },
                    {
                        "tag": "Todos",
                        "codigoCliente": "1295404",
                        "razaoSocial": "BARCEMAG FERRAGEM & MATERIAIS DE",
                        "id": 87865,
                        "createdAt": "2026-09-25T16:00:06.9216961",
                        "clienteId": 14107,
                        "pedido": "2053078148",
                        "dataPedido": "2026-09-24T00:00:00",
                        "previsaoEntrega": "2026-09-29T00:00:00",
                        "previsaoEntregaAjustada": "2026-09-29T00:00:00",
                        "statusPrazo": 1,
                        "statusEntrega": 2
                    },
                    {
                        "tag": "Todos",
                        "codigoCliente": "1053144",
                        "razaoSocial": "SETIMO NOCCHI S A COMERCIO E",
                        "id": 89509,
                        "createdAt": "2026-09-25T16:00:06.9226667",
                        "clienteId": 137221,
                        "pedido": "2053090594",
                        "dataPedido": "2026-09-25T00:00:00",
                        "previsaoEntrega": "2026-09-28T00:00:00",
                        "previsaoEntregaAjustada": "2026-10-08T00:00:00",
                        "statusPrazo": 1,
                        "statusEntrega": 2
                    },
                    {
                        "tag": "Todos",
                        "codigoCliente": "1053144",
                        "razaoSocial": "SETIMO NOCCHI S A COMERCIO E",
                        "id": 89510,
                        "createdAt": "2026-09-25T16:00:06.9226672",
                        "clienteId": 137221,
                        "pedido": "2053090594",
                        "dataPedido": "2026-09-25T00:00:00",
                        "previsaoEntrega": "2026-09-28T00:00:00",
                        "previsaoEntregaAjustada": "2026-10-08T00:00:00",
                        "statusPrazo": 1,
                        "statusEntrega": 2
                    },
                    {
                        "tag": "Todos",
                        "codigoCliente": "1053144",
                        "razaoSocial": "SETIMO NOCCHI S A COMERCIO E",
                        "id": 89511,
                        "createdAt": "2026-09-25T16:00:06.9226677",
                        "clienteId": 137221,
                        "pedido": "2053090594",
                        "dataPedido": "2026-09-25T00:00:00",
                        "previsaoEntrega": "2026-09-28T00:00:00",
                        "previsaoEntregaAjustada": "2026-10-08T00:00:00",
                        "statusPrazo": 1,
                        "statusEntrega": 2
                    },
                    {
                        "tag": "Todos",
                        "codigoCliente": "1697354",
                        "razaoSocial": "SEVERO & ROTHER MATERIAIS DE",
                        "id": 89619,
                        "createdAt": "2026-09-25T16:00:06.9227309",
                        "clienteId": 137371,
                        "pedido": "2053091008",
                        "dataPedido": "2026-09-25T00:00:00",
                        "previsaoEntrega": "2026-10-01T00:00:00",
                        "previsaoEntregaAjustada": "2026-10-01T00:00:00",
                        "statusPrazo": 1,
                        "statusEntrega": 2
                    },
                    {
                        "tag": "Todos",
                        "codigoCliente": "1697354",
                        "razaoSocial": "SEVERO & ROTHER MATERIAIS DE",
                        "id": 89620,
                        "createdAt": "2026-09-25T16:00:06.9227314",
                        "clienteId": 137371,
                        "pedido": "2053091008",
                        "dataPedido": "2026-09-25T00:00:00",
                        "previsaoEntrega": "2026-10-01T00:00:00",
                        "previsaoEntregaAjustada": "2026-10-01T00:00:00",
                        "statusPrazo": 1,
                        "statusEntrega": 2
                    },
                    {
                        "tag": "Todos",
                        "codigoCliente": "1697354",
                        "razaoSocial": "SEVERO & ROTHER MATERIAIS DE",
                        "id": 89621,
                        "createdAt": "2026-09-25T16:00:06.9227319",
                        "clienteId": 137371,
                        "pedido": "2053091008",
                        "dataPedido": "2026-09-25T00:00:00",
                        "previsaoEntrega": "2026-10-01T00:00:00",
                        "previsaoEntregaAjustada": "2026-10-01T00:00:00",
                        "statusPrazo": 1,
                        "statusEntrega": 2
                    }
                ]
            }
        ]
]